/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** A GeoJSON object as defined by RFC 7946: https://datatracker.ietf.org/doc/html/rfc7946 */
  GeoJSON: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: Record<string, any>; output: Record<string, any>; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File; }
};

export type AddPageManagerInput = {
  /** which page and how the user is associated with it */
  association: AssociationInput;
  /** Indicates if buzz reminders are enabled */
  buzzReminders: Scalars['Boolean']['input'];
  /** Role of the page manager */
  contactRole?: InputMaybe<ContactRole>;
  /** Email address of the page manager */
  email: Scalars['String']['input'];
  /** First name of the page manager */
  firstName: Scalars['String']['input'];
  /** Language of the page manager */
  language?: InputMaybe<Language>;
  /** Last name of the page manager */
  lastName: Scalars['String']['input'];
  /** Mobile phone number of the page manager */
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the page manager */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** System role of the page manager */
  role?: InputMaybe<Role>;
  /** Indicates if subscriber alerts are opted in */
  subscriberAlertsOptIn: Scalars['Boolean']['input'];
  /** Indicates if visit reminders are enabled */
  visitReminders: Scalars['Boolean']['input'];
};

export type AddPagesToGroupInput = {
  pageGroupId: Scalars['String']['input'];
  pageIds: Array<Scalars['String']['input']>;
};

export type AddSelfAddedSiteInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type AddTeamMemberInput = {
  contactRole?: InputMaybe<ContactRole>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AddToWaitingListInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  language: Language;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['String']['input'];
  source: PageSubscriberSource;
};

export type AddUserToGroupPagesInput = {
  pageGroupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AddUserToUserToClonePagesInput = {
  userId: Scalars['String']['input'];
  userToCloneId: Scalars['String']['input'];
};

export type AdminAssignmentResult = {
  __typename?: 'AdminAssignmentResult';
  addedPageCount: Scalars['Int']['output'];
  keptContactPageCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type AdminInvoice = {
  __typename?: 'AdminInvoice';
  currency: Scalars['String']['output'];
  docNumber?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /** The HubSpot Service Subscription the invoice belongs to — the customer. */
  hubspotSubscriptionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** A page carrying that subscription’s id, for display; null when no page does. */
  pageId?: Maybe<Scalars['String']['output']>;
  pageSlug?: Maybe<Scalars['String']['output']>;
  pageTitle: Scalars['String']['output'];
  paymentLink?: Maybe<Scalars['String']['output']>;
  provider: InvoicingServiceProvider;
  remainingBalance: Scalars['Float']['output'];
  status: InvoiceStatus;
  totalAmount: Scalars['Float']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

export type AdminInvoiceCurrencyStats = {
  __typename?: 'AdminInvoiceCurrencyStats';
  currency: Scalars['String']['output'];
  openBalance: Scalars['Float']['output'];
  openCount: Scalars['Int']['output'];
  paidCount: Scalars['Int']['output'];
};

export type AdminInvoiceStats = {
  __typename?: 'AdminInvoiceStats';
  byCurrency: Array<AdminInvoiceCurrencyStats>;
  openCount: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
  paidCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminPage = {
  __typename?: 'AdminPage';
  id: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AdminPageGroup = {
  __typename?: 'AdminPageGroup';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pages: Array<AdminPage>;
};

export type AdminRemovalResult = {
  __typename?: 'AdminRemovalResult';
  keptContactPageCount: Scalars['Int']['output'];
  removedPageCount: Scalars['Int']['output'];
};

export type AdminSitePage = {
  __typename?: 'AdminSitePage';
  auraTier: AuraTier;
  hasSensorData?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  meadowSiteId?: Maybe<Scalars['String']['output']>;
  pageId: Scalars['ID']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  polygonGeojson?: Maybe<Scalars['JSON']['output']>;
  threebeeId?: Maybe<Scalars['String']['output']>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  /** Whether the account named by targetUserId already manages every page this account does (false with no pages, false without a target). */
  coveredByTarget: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isViewer: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pageCount: Scalars['Int']['output'];
  role: Role;
};


export type AdminUserCoveredByTargetArgs = {
  targetUserId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserDetail = {
  __typename?: 'AdminUserDetail';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isViewer: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pageCount: Scalars['Int']['output'];
  pages: Array<AdminPage>;
  role: Role;
};

export enum AlveolePackages {
  Base = 'BASE',
  CultivateChange = 'CULTIVATE_CHANGE',
  Deluxe = 'DELUXE',
  EducationalPackage = 'EDUCATIONAL_PACKAGE',
  MeetTheBees = 'MEET_THE_BEES',
  MeetTheWildBees = 'MEET_THE_WILD_BEES',
  NatureImpact = 'NATURE_IMPACT',
  NatureRisk = 'NATURE_RISK',
  Premium = 'PREMIUM',
  School = 'SCHOOL',
  Standard = 'STANDARD',
  TrackYourImpact = 'TRACK_YOUR_IMPACT',
  WelcomeLocalPollinators = 'WELCOME_LOCAL_POLLINATORS'
}

export type AssociationInput = {
  pageId: Scalars['String']['input'];
  type: ContactType;
};

export type AtRiskSpeciesData = {
  __typename?: 'AtRiskSpeciesData';
  aoi: Scalars['GeoJSON']['output'];
  rank: AuraRank;
  score: Scalars['Float']['output'];
  speciesList: Array<AuraSpeciesListItem>;
  summary: AuraSpeciesSummary;
  threatenedSpeciesTotal: Scalars['Int']['output'];
};

export type AudienceMember = {
  __typename?: 'AudienceMember';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  interestedInEvents: Scalars['Boolean']['output'];
  interestedInHoney: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  since: Scalars['DateTime']['output'];
  subscriber: Scalars['Boolean']['output'];
};

export type AuraActor = {
  __typename?: 'AuraActor';
  hasEmail: Scalars['Boolean']['output'];
};

export type AuraBioacousticsData = {
  __typename?: 'AuraBioacousticsData';
  birdObservations: Array<AuraBirdObservation>;
  buzzDetections: Array<AuraBuzzDetection>;
  dailyPollinatorData: Array<AuraDailyBioacousticsData>;
  hourlyPollinatorObservations: Array<AuraHourlyObservation>;
};

export type AuraBirdObservation = {
  __typename?: 'AuraBirdObservation';
  audioClip: Scalars['String']['output'];
  commonName?: Maybe<Scalars['String']['output']>;
  dateTime: Scalars['String']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  latinTaxa: Scalars['String']['output'];
};

export type AuraBuzzDetection = {
  __typename?: 'AuraBuzzDetection';
  audioUrl: Scalars['String']['output'];
  dateTime: Scalars['String']['output'];
  hz: Scalars['String']['output'];
};

export type AuraChatMessage = {
  __typename?: 'AuraChatMessage';
  attachments: Array<AuraChatMessageAttachment>;
  content: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: AuraChatRole;
  seq: Scalars['Int']['output'];
  stopReason?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  toolCalls: Array<AuraChatToolCall>;
};

export type AuraChatMessageAttachment = {
  __typename?: 'AuraChatMessageAttachment';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum AuraChatRole {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

export type AuraChatSession = {
  __typename?: 'AuraChatSession';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastMessageAt: Scalars['DateTime']['output'];
  messageCount: Scalars['Int']['output'];
  messages: Array<AuraChatMessage>;
  pageId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AuraChatToolCall = {
  __typename?: 'AuraChatToolCall';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  toolUseId: Scalars['ID']['output'];
};

export type AuraDailyBioacousticsData = {
  __typename?: 'AuraDailyBioacousticsData';
  date: Scalars['DateTime']['output'];
  meanBuzzPerHour: Scalars['Float']['output'];
  weatherData: AuraDailyWeatherData;
};

export type AuraDailyWeatherData = {
  __typename?: 'AuraDailyWeatherData';
  meanTemp: Scalars['Float']['output'];
  totalPrecip: Scalars['Float']['output'];
};

export type AuraData = {
  __typename?: 'AuraData';
  dependency: AuraDataEntity_Dependency_OrLocked;
  impactAndState: AuraDataEntity_ImpactAndState_OrLocked;
  locationRisk: LocationRiskDataEntity;
  meadowSiteId: Scalars['String']['output'];
  measurements: MeasurementsEntity;
  tier: AuraTier;
};

export type AuraDataEntity_Dependency_OrLocked = DependencyDataEntity | Locked;

export type AuraDataEntity_ImpactAndState_OrLocked = ImpactAndStateDataEntity | Locked;

export type AuraHourlyObservation = {
  __typename?: 'AuraHourlyObservation';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  hour: Scalars['Int']['output'];
  hz: Scalars['String']['output'];
};

export type AuraLandCoverData = {
  __typename?: 'AuraLandCoverData';
  aoi?: Maybe<Scalars['GeoJSON']['output']>;
  generating: Scalars['Boolean']['output'];
  /** Presigned URL to the GeoTIFF */
  mapLayerUrl?: Maybe<Scalars['String']['output']>;
  naturalCoverage?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<AuraRank>;
  score?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<ThreebeeLandUseSummary>;
  /** Natural land-use percent for the ring outside the site's AOI but inside the map layer's crop circle - null when the site has no stored polygon (nothing beyond the AOI to summarize) */
  surroundingNaturalPercent?: Maybe<Scalars['Float']['output']>;
  surroundingSummary?: Maybe<ThreebeeLandUseSummary>;
};

export type AuraProtectedArea = {
  __typename?: 'AuraProtectedArea';
  /** This area's raw contribution to the site's summed pasi (pre-percentile-normalization) */
  contribution: Scalars['Float']['output'];
  designation: Scalars['String']['output'];
  distance: Scalars['Float']['output'];
  geometry: Scalars['GeoJSON']['output'];
  intersectArea: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  sitePid: Scalars['String']['output'];
};

export type AuraProtectedAreasData = {
  __typename?: 'AuraProtectedAreasData';
  aoi: Scalars['GeoJSON']['output'];
  areas: Array<AuraProtectedArea>;
  count: Scalars['Int']['output'];
  pasi: Scalars['Float']['output'];
  rank: AuraRank;
  score: Scalars['Float']['output'];
};

export enum AuraRank {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW'
}

export type AuraReport = {
  __typename?: 'AuraReport';
  downloadUrl: Scalars['String']['output'];
};

export enum AuraReportFormat {
  Pdf = 'PDF',
  Xlsx = 'XLSX'
}

export enum AuraReportFramework {
  Csrd = 'CSRD',
  Gresb = 'GRESB',
  Tnfd = 'TNFD'
}

export enum AuraReportLanguage {
  En = 'EN',
  Fr = 'FR'
}

export type AuraShareAdoption = {
  __typename?: 'AuraShareAdoption';
  added: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type AuraShareLink = {
  __typename?: 'AuraShareLink';
  token: Scalars['String']['output'];
};

export type AuraSpeciesInfo = {
  __typename?: 'AuraSpeciesInfo';
  canonicalName?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  iucn?: Maybe<MeadowIucnRedListCategory>;
  kingdom?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  phylum?: Maybe<Scalars['String']['output']>;
  scientificName?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  speciesKey: Scalars['Int']['output'];
  vernacularName?: Maybe<Scalars['String']['output']>;
};

export type AuraSpeciesListItem = {
  __typename?: 'AuraSpeciesListItem';
  count: Scalars['Int']['output'];
  speciesInfo: AuraSpeciesInfo;
};

export type AuraSpeciesSummary = {
  __typename?: 'AuraSpeciesSummary';
  criticalSpeciesCount: Scalars['Int']['output'];
  endangeredSpeciesCount: Scalars['Int']['output'];
  leastConcernSpeciesCount: Scalars['Int']['output'];
  nearThreatenedSpeciesCount: Scalars['Int']['output'];
  speciesCount: Scalars['Int']['output'];
  vulnerableSpeciesCount: Scalars['Int']['output'];
};

export enum AuraTier {
  Free = 'FREE',
  Full = 'FULL'
}

export type AuraVisitor = {
  __typename?: 'AuraVisitor';
  token: Scalars['String']['output'];
};

export type AuraWatershed = {
  __typename?: 'AuraWatershed';
  drought: Scalars['Float']['output'];
  /** The worse of floodRiver/floodCoastal - same collapse as the site's own flood.score */
  flood: Scalars['Float']['output'];
  floodCoastal: Scalars['Float']['output'];
  floodRiver: Scalars['Float']['output'];
  geometry: Scalars['GeoJSON']['output'];
  waterStress: Scalars['Float']['output'];
  watershedId: Scalars['String']['output'];
};

export type BeekeepingVisit = {
  __typename?: 'BeekeepingVisit';
  beekeeperFirstName: Scalars['String']['output'];
  beekeeperLastName: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title: LanguageText;
};

export enum BenchMarkBuildingType {
  Hospitality = 'Hospitality',
  Industrial = 'Industrial',
  MultiFamily = 'MultiFamily',
  Office = 'Office',
  Other = 'Other',
  Retail = 'Retail',
  Unknown = 'Unknown'
}

export type BenchMarkRaw = {
  __typename?: 'BenchMarkRaw';
  percentileScore: Scalars['Float']['output'];
  rank?: Maybe<Scalars['Float']['output']>;
  sampleMean?: Maybe<Scalars['Float']['output']>;
  sampleSize?: Maybe<Scalars['Int']['output']>;
  sampleStd?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
  zScore?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkSiteMetricsPayload = {
  __typename?: 'BenchmarkSiteMetricsPayload';
  address?: Maybe<Scalars['String']['output']>;
  agriculturalCover?: Maybe<Scalars['Float']['output']>;
  artificialCover?: Maybe<Scalars['Float']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  buildingType: BenchMarkBuildingType;
  cloudCover?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  criticalSpeciesCount?: Maybe<Scalars['Int']['output']>;
  distance: Scalars['Float']['output'];
  endangeredSpeciesCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  leastConcernSpeciesCount?: Maybe<Scalars['Int']['output']>;
  lng: Scalars['Float']['output'];
  msaLU?: Maybe<Scalars['Float']['output']>;
  naturalCover?: Maybe<Scalars['Float']['output']>;
  nearThreatenedSpeciesCount?: Maybe<Scalars['Int']['output']>;
  pasi?: Maybe<Scalars['Float']['output']>;
  speciesCount?: Maybe<Scalars['Int']['output']>;
  threatenedSpeciesTotal?: Maybe<Scalars['Int']['output']>;
  vulnerableSpeciesCount?: Maybe<Scalars['Int']['output']>;
  waterCover?: Maybe<Scalars['Float']['output']>;
};

export type BioacousticsEntity = {
  __typename?: 'BioacousticsEntity';
  birdObservations: Array<BirdObservation>;
  buzzDetections: Array<BuzzDetection>;
  dailyPollinatorData: Array<DailyBioacousticsData>;
  hourlyPollinatorObservations: Array<HourlyObservation>;
  siteDetails: SiteDetails;
};

export type BirdObservation = {
  __typename?: 'BirdObservation';
  audioClip: Scalars['String']['output'];
  commonName?: Maybe<Scalars['String']['output']>;
  dateTime: Scalars['String']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  latinTaxa: Scalars['String']['output'];
};

export type BouncingPage = {
  __typename?: 'BouncingPage';
  id: Scalars['String']['output'];
  pageManagers: Array<SimplePageManager>;
  region?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  zuperCustomerUid?: Maybe<Scalars['String']['output']>;
  zuperHubspotCustomerId?: Maybe<Scalars['String']['output']>;
};

export type BuzzDetection = {
  __typename?: 'BuzzDetection';
  audioUrl: Scalars['String']['output'];
  dateTime: Scalars['String']['output'];
  hz: Scalars['String']['output'];
};

export type BuzzGood = {
  __typename?: 'BuzzGOOD';
  authorId: Scalars['String']['output'];
  beekeeperAvatarUrl?: Maybe<Scalars['String']['output']>;
  beekeeperFirstName: Scalars['String']['output'];
  beekeeperLastName: Scalars['String']['output'];
  beekeeperTagline: Scalars['String']['output'];
  city: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isYearEnd?: Maybe<Scalars['Boolean']['output']>;
  likedByMe: Scalars['Boolean']['output'];
  media: Array<BuzzMediaGood>;
  text: Scalars['String']['output'];
  totalLikes: Scalars['Int']['output'];
  weatherDescription?: Maybe<Scalars['String']['output']>;
  weatherTempCelsius?: Maybe<Scalars['String']['output']>;
};

export type BuzzMediaGood = {
  __typename?: 'BuzzMediaGOOD';
  buzzId?: Maybe<Scalars['String']['output']>;
  fileUrl: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
};

export type BuzzMediaItem = {
  __typename?: 'BuzzMediaItem';
  url: Scalars['String']['output'];
  video: Scalars['Boolean']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: MessageRole;
  sessionId: Scalars['ID']['output'];
  toolCalls?: Maybe<Scalars['JSONObject']['output']>;
  toolResults?: Maybe<Scalars['JSONObject']['output']>;
};

export type ChatSession = {
  __typename?: 'ChatSession';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  messages: Array<ChatMessage>;
  source: ChatSessionSource;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ChatSessionMinified = {
  __typename?: 'ChatSessionMinified';
  id: Scalars['ID']['output'];
  lastMessageDate: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export enum ChatSessionSource {
  Aura = 'AURA',
  AuraFree = 'AURA_FREE'
}

export type ChatStreamEvent = {
  __typename?: 'ChatStreamEvent';
  chatId: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  toolName?: Maybe<Scalars['String']['output']>;
  type: ChatStreamEventType;
};

export enum ChatStreamEventType {
  ContentBlock = 'CONTENT_BLOCK',
  Done = 'DONE',
  Error = 'ERROR',
  Text = 'TEXT',
  Thinking = 'THINKING',
  ToolEnd = 'TOOL_END',
  ToolStart = 'TOOL_START',
  UiCommand = 'UI_COMMAND'
}

export enum CommunicationMedium {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type CompletedEvent = {
  __typename?: 'CompletedEvent';
  attendedCount?: Maybe<Scalars['Int']['output']>;
  attendees: Array<EventAttendee>;
  buzzAuthorName?: Maybe<Scalars['String']['output']>;
  buzzMedia: Array<BuzzMediaItem>;
  buzzPhotoUrl?: Maybe<Scalars['String']['output']>;
  buzzText?: Maybe<Scalars['String']['output']>;
  endedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageKey: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  title: LanguageText;
};

export enum ContactRole {
  AssetManagementTeam = 'ASSET_MANAGEMENT_TEAM',
  MarketingAndCommsTeam = 'MARKETING_AND_COMMS_TEAM',
  PropertyTeam = 'PROPERTY_TEAM',
  SustainabilityTeam = 'SUSTAINABILITY_TEAM',
  TenantOccupant = 'TENANT_OCCUPANT'
}

export enum ContactType {
  HiveContact = 'HIVE_CONTACT',
  MainContact = 'MAIN_CONTACT',
  PageManager = 'PAGE_MANAGER'
}

export type CreateBuzzInput = {
  /** buzz media */
  media: Array<Scalars['Upload']['input']>;
  /** weather city ? */
  metaCity?: InputMaybe<Scalars['String']['input']>;
  /** Temperature in Celsius */
  metaTempCelsius?: InputMaybe<Scalars['Float']['input']>;
  /** weather description text */
  metaWeatherDescription?: InputMaybe<Scalars['String']['input']>;
  /** pages to post to */
  pageIds: Array<Scalars['String']['input']>;
  /** buzz text */
  text: Scalars['String']['input'];
};

export type CreateChatSessionInput = {
  chatId: Scalars['String']['input'];
};

export type CreateFreeToolSessionInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  sites: Array<FreeToolSiteInput>;
};

export type CreateLinkedInShareInput = {
  media?: InputMaybe<Array<LinkedInMediaInput>>;
  mode?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type CreatePageGroupInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pageIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateRegionInput = {
  name: Scalars['String']['input'];
};

export type CreateReportInput = {
  /** Page Ids, provide 1 for single asset or multiple for multi-asset */
  pageIds: Array<Scalars['String']['input']>;
  /** Format of report, e.g. PDF or XLSX */
  reportFormat: Scalars['String']['input'];
  /** Language for report */
  reportLanguage: Scalars['String']['input'];
  /** Report type, e.g. CSRD, TNFD, GRESB, ENGAGEMENT */
  reportType: Scalars['String']['input'];
};

export type CreateReportSectionTemplateInput = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateReportTemplateInput = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language?: InputMaybe<Language>;
  lastName: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  role: Role;
};

export type CrownQueenCandidateInput = {
  candidateId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};

export type CustomerAsset = {
  __typename?: 'CustomerAsset';
  assetCategory?: Maybe<CustomerAssetCategory>;
  assetStatus?: Maybe<CustomerAssetStatus>;
  createdAt: Scalars['DateTime']['output'];
  hiveHealth?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum CustomerAssetCategory {
  BeeHive = 'BeeHive',
  BeeHome = 'BeeHome',
  BirdSensor = 'BirdSensor',
  PollinatorSensor = 'PollinatorSensor',
  YardBeehives = 'YardBeehives'
}

export enum CustomerAssetStatus {
  Installed = 'INSTALLED',
  NeedRepair = 'NEED_REPAIR',
  Obsolete = 'OBSOLETE',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  ReadyToInstall = 'READY_TO_INSTALL',
  Removed = 'REMOVED',
  UnderService = 'UNDER_SERVICE'
}

export enum CustomerIoMessageStatus {
  Bounced = 'bounced',
  Clicked = 'clicked',
  Delivered = 'delivered',
  Drafted = 'drafted',
  Failed = 'failed',
  Opened = 'opened',
  Sent = 'sent',
  Subscribed = 'subscribed',
  Suppressed = 'suppressed',
  Undelivered = 'undelivered',
  Unsubscribed = 'unsubscribed'
}

export type DailyBioacousticsData = {
  __typename?: 'DailyBioacousticsData';
  date: Scalars['DateTime']['output'];
  meanBuzzPerHour: Scalars['Float']['output'];
  weatherData: DailyWeatherData;
};

export type DailyWeatherData = {
  __typename?: 'DailyWeatherData';
  meanTemp: Scalars['Float']['output'];
  totalPrecip: Scalars['Float']['output'];
};

export type DependencyDataEntity = {
  __typename?: 'DependencyDataEntity';
  /** null if the site falls outside any known Aqueduct watershed */
  drought?: Maybe<DroughtData>;
  /** null if the site falls outside any known Aqueduct watershed */
  waterStress?: Maybe<WaterStressData>;
};

export type DownloadUrlResponse = {
  __typename?: 'DownloadUrlResponse';
  downloadUrl: Scalars['String']['output'];
  reportId?: Maybe<Scalars['String']['output']>;
  viewUrl?: Maybe<Scalars['String']['output']>;
};

export type DroughtData = {
  __typename?: 'DroughtData';
  rank: AuraRank;
  score: Scalars['Float']['output'];
};

export type EdnaData = {
  __typename?: 'EdnaData';
  detections: Array<EdnaPlantDetection>;
  pageCity: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  totalHits: Scalars['Int']['output'];
  totalUniqueHits: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type EdnaDataEntity = {
  __typename?: 'EdnaDataEntity';
  detections: Array<EdnaPlantEntity>;
  totalMatches: Scalars['Int']['output'];
  uniqueKinds: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type EdnaPlantDetection = {
  __typename?: 'EdnaPlantDetection';
  commonNameEn: Scalars['String']['output'];
  commonNameFr: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  growthHabit: Scalars['String']['output'];
  imgUrl: Scalars['String']['output'];
  iucnStatus: Scalars['String']['output'];
  latinTaxon: Scalars['String']['output'];
};

export type EdnaPlantEntity = {
  __typename?: 'EdnaPlantEntity';
  commonNameEn: Scalars['String']['output'];
  commonNameFr: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  growthHabit: Scalars['String']['output'];
  imgUrl: Scalars['String']['output'];
  iucnStatus: Scalars['String']['output'];
  latinTaxon: Scalars['String']['output'];
  taxonResolution: Scalars['String']['output'];
};

export enum EmailAddressStatus {
  Invalid = 'INVALID',
  Unknown = 'UNKNOWN',
  Valid = 'VALID'
}

export type EmailAttendeesInput = {
  language: Language;
  message: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  workshopId: Scalars['String']['input'];
};

export type Event = {
  __typename?: 'Event';
  beekeeperFirstName: Scalars['String']['output'];
  beekeeperLastName: Scalars['String']['output'];
  capacity?: Maybe<Scalars['Float']['output']>;
  description: LanguageText;
  endTime: Scalars['String']['output'];
  eventType: EventType;
  id: Scalars['String']['output'];
  imageFilename?: Maybe<Scalars['String']['output']>;
  registeredCount: Scalars['Int']['output'];
  registeredUsers: Array<RegisteredUser>;
  startTime: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title: LanguageText;
  zuperJobUid: Scalars['String']['output'];
};

export type EventAttendee = {
  __typename?: 'EventAttendee';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  interestedInEvents: Scalars['Boolean']['output'];
  interestedInHoney: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  subscriber: Scalars['Boolean']['output'];
};

export type EventHighlight = {
  __typename?: 'EventHighlight';
  buzzId: Scalars['String']['output'];
  buzzText: Scalars['String']['output'];
  eventDate: Scalars['DateTime']['output'];
  mediaPath?: Maybe<Scalars['String']['output']>;
  title: LanguageText;
};

export enum EventRegistrationStatus {
  Attendee = 'ATTENDEE',
  Registered = 'REGISTERED',
  Unregistered = 'UNREGISTERED'
}

export enum EventType {
  BeeThereOrBeeSquare = 'BEE_THERE_OR_BEE_SQUARE',
  BeeTheMovement = 'BEE_THE_MOVEMENT',
  DiscoverTheWorldOfBees = 'DISCOVER_THE_WORLD_OF_BEES',
  ExploreTheWorldOfWildBees = 'EXPLORE_THE_WORLD_OF_WILD_BEES',
  FromHiveToHoneyJar = 'FROM_HIVE_TO_HONEY_JAR',
  HoneyTasting = 'HONEY_TASTING',
  KioskWhatsTheBuzz = 'KIOSK_WHATS_THE_BUZZ',
  MeetYourBeekeeper = 'MEET_YOUR_BEEKEEPER',
  MeetYourBees = 'MEET_YOUR_BEES',
  TheCandleMakingWorkshop = 'THE_CANDLE_MAKING_WORKSHOP',
  TheWondersOfBeeswax = 'THE_WONDERS_OF_BEESWAX'
}

export type FloodData = {
  __typename?: 'FloodData';
  coastalRank: AuraRank;
  coastalScore: Scalars['Float']['output'];
  rank: AuraRank;
  riverRank: AuraRank;
  riverScore: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
};

export type FreeSiteDataPayload = {
  __typename?: 'FreeSiteDataPayload';
  benchmarks: FreeToolBenchmarks;
  landCoverData: LandCoverData;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  protectedAreasData: ProtectedAreasData;
  speciesData: SpeciesData;
};

export type FreeToolBenchmarks = {
  __typename?: 'FreeToolBenchmarks';
  impactScore: Scalars['Float']['output'];
  msaRaw: BenchMarkRaw;
  naturalCoverRaw: BenchMarkRaw;
  pasiRaw: BenchMarkRaw;
  riskScore: Scalars['Float']['output'];
  threatenedSpeciesRaw: BenchMarkRaw;
};

export type FreeToolSite = {
  __typename?: 'FreeToolSite';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type FreeToolSiteInput = {
  address: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type FreeToolUiContext = {
  siteId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  view: Scalars['String']['input'];
};

export type FreeToolUseSession = {
  __typename?: 'FreeToolUseSession';
  chatSessionId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  sites: Array<FreeToolSite>;
};

export type GenerateAuraFreeReportInput = {
  pageId?: InputMaybe<Scalars['ID']['input']>;
  selfAddedSiteId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateAuraReportInput = {
  format: AuraReportFormat;
  framework: AuraReportFramework;
  language: AuraReportLanguage;
  pageId: Scalars['ID']['input'];
};

export type GenerateReportInput = {
  payload: Scalars['JSONObject']['input'];
  reportTemplateId: Scalars['String']['input'];
  sectionVersion?: InputMaybe<SectionVersion>;
};

export type GetChatSessionInput = {
  chatId: Scalars['String']['input'];
};

export type HiveDataEntity = {
  __typename?: 'HiveDataEntity';
  pointCount: Scalars['Int']['output'];
  timeline: Array<HiveDataPointEntity>;
};

export type HiveDataPointEntity = {
  __typename?: 'HiveDataPointEntity';
  beeFrames?: Maybe<Scalars['Int']['output']>;
  broodFrames?: Maybe<Scalars['Int']['output']>;
  date: Scalars['DateTime']['output'];
  honeyFrames?: Maybe<Scalars['Int']['output']>;
  queenSpotted: Scalars['Boolean']['output'];
  showNectarFlow: Scalars['Boolean']['output'];
  state: HiveState;
  trendPercent?: Maybe<Scalars['Float']['output']>;
};

export type HivePageAssignSelfOnlyResult = {
  __typename?: 'HivePageAssignSelfOnlyResult';
  /** Other pages kept because the viewer is their main or hive contact */
  keptContactPageCount: Scalars['Int']['output'];
};

export type HivePageAuraMap = {
  __typename?: 'HivePageAuraMap';
  areas: Array<HivePageAuraMapArea>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  paAoi?: Maybe<Scalars['JSONObject']['output']>;
  speciesAoi?: Maybe<Scalars['JSONObject']['output']>;
};

export type HivePageAuraMapArea = {
  __typename?: 'HivePageAuraMapArea';
  designation: Scalars['String']['output'];
  distanceKm: Scalars['Float']['output'];
  geometry: Scalars['JSONObject']['output'];
  hectares: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type HivePageBuzz = {
  __typename?: 'HivePageBuzz';
  authorAvatarUrl?: Maybe<Scalars['String']['output']>;
  authorFirstName: Scalars['String']['output'];
  authorTagline?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  likeCount: Scalars['Int']['output'];
  media: Array<HivePageBuzzMedia>;
  tempC?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
};

export type HivePageBuzzMedia = {
  __typename?: 'HivePageBuzzMedia';
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type HivePageBuzzStream = {
  __typename?: 'HivePageBuzzStream';
  items: Array<HivePageBuzz>;
  totalCount: Scalars['Int']['output'];
};

export type HivePageCard = {
  __typename?: 'HivePageCard';
  address?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  galleryUrls: Array<Scalars['String']['output']>;
  honeyInterestEnabled: Scalars['Boolean']['output'];
  honeyListCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  subscriberCount: Scalars['Int']['output'];
  subscriberInitials: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type HivePageCreateBuzzInput = {
  media: Array<Scalars['Upload']['input']>;
  pageId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type HivePageEvent = {
  __typename?: 'HivePageEvent';
  capacity: Scalars['Int']['output'];
  description: LanguageText;
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  imageFilename: Scalars['String']['output'];
  registeredCount: Scalars['Int']['output'];
  registeredInitials: Array<Scalars['String']['output']>;
  startsAt: Scalars['DateTime']['output'];
  title: LanguageText;
};

export type HivePageEvents = {
  __typename?: 'HivePageEvents';
  events: Array<HivePageEvent>;
  interestEnabled: Scalars['Boolean']['output'];
  interestListCount: Scalars['Int']['output'];
  registrationEnabled: Scalars['Boolean']['output'];
  showUpcomingEvents: Scalars['Boolean']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type HivePageInviteInput = {
  language: Language;
  pageId: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
};

export type HivePageJoinManagerPagesResult = {
  __typename?: 'HivePageJoinManagerPagesResult';
  addedPageCount: Scalars['Int']['output'];
  keptContactPageCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type HivePageListInput = {
  email: Scalars['String']['input'];
  language: Language;
  pageId: Scalars['String']['input'];
};

export type HivePageNature = {
  __typename?: 'HivePageNature';
  aura?: Maybe<HivePageNatureAura>;
  edna?: Maybe<HivePageNatureEdna>;
  hive?: Maybe<HivePageNatureHive>;
  nesting?: Maybe<HivePageNatureNesting>;
  sensor?: Maybe<HivePageNatureSensor>;
};

export type HivePageNatureAura = {
  __typename?: 'HivePageNatureAura';
  protectedAreasCount: Scalars['Int']['output'];
  speciesCount: Scalars['Int']['output'];
  threatenedSpecies: Array<HivePageNatureAuraSpecies>;
  threatenedSpeciesCount: Scalars['Int']['output'];
  topSpecies: Array<HivePageNatureAuraSpecies>;
};

export type HivePageNatureAuraSpecies = {
  __typename?: 'HivePageNatureAuraSpecies';
  count: Scalars['Int']['output'];
  iucnCategory?: Maybe<MeadowIucnRedListCategory>;
  name: Scalars['String']['output'];
  scientificName?: Maybe<Scalars['String']['output']>;
};

export type HivePageNatureEdna = {
  __typename?: 'HivePageNatureEdna';
  detections: Array<HivePageNatureEdnaDetection>;
  totalMatches: Scalars['Int']['output'];
  uniqueKinds: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type HivePageNatureEdnaDetection = {
  __typename?: 'HivePageNatureEdnaDetection';
  commonNameEn: Scalars['String']['output'];
  commonNameFr: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  growthHabit: Scalars['String']['output'];
  imgUrl: Scalars['String']['output'];
  iucnStatus: Scalars['String']['output'];
  latinTaxon: Scalars['String']['output'];
};

export type HivePageNatureHive = {
  __typename?: 'HivePageNatureHive';
  peakBeeFrames: Scalars['Int']['output'];
  pointCount: Scalars['Int']['output'];
  timeline: Array<HivePageNatureHivePoint>;
};

export type HivePageNatureHivePoint = {
  __typename?: 'HivePageNatureHivePoint';
  beeFrames?: Maybe<Scalars['Int']['output']>;
  broodFrames?: Maybe<Scalars['Int']['output']>;
  date: Scalars['String']['output'];
  honeyFrames?: Maybe<Scalars['Int']['output']>;
  queenSpotted: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  trendPercent?: Maybe<Scalars['Float']['output']>;
};

export type HivePageNatureNesting = {
  __typename?: 'HivePageNatureNesting';
  materials: Array<HivePageNatureNestingMaterial>;
  total: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type HivePageNatureNestingMaterial = {
  __typename?: 'HivePageNatureNestingMaterial';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type HivePageNatureSensor = {
  __typename?: 'HivePageNatureSensor';
  detectionCount: Scalars['Int']['output'];
  lastDetectionAt?: Maybe<Scalars['String']['output']>;
  species: Array<HivePageNatureSensorSpecies>;
  speciesCount: Scalars['Int']['output'];
};

export type HivePageNatureSensorSpecies = {
  __typename?: 'HivePageNatureSensorSpecies';
  audioClip: Scalars['String']['output'];
  commonName?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  lastHeardAt: Scalars['String']['output'];
  latinTaxa: Scalars['String']['output'];
};

export type HivePageNominateInput = {
  name: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};

export type HivePageQueen = {
  __typename?: 'HivePageQueen';
  candidateCount: Scalars['Int']['output'];
  candidates: Array<HivePageQueenCandidate>;
  crownedAt?: Maybe<Scalars['DateTime']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  hasWinner: Scalars['Boolean']['output'];
  launchedAt: Scalars['DateTime']['output'];
  votingEnabled: Scalars['Boolean']['output'];
  winnerName?: Maybe<Scalars['String']['output']>;
  winnerVoteCount?: Maybe<Scalars['Int']['output']>;
};

export type HivePageQueenCandidate = {
  __typename?: 'HivePageQueenCandidate';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  voteCount: Scalars['Int']['output'];
};

export type HivePageStaffAccess = {
  __typename?: 'HivePageStaffAccess';
  id: Scalars['String']['output'];
  managers: Array<HivePageStaffManager>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  viewerManages: Scalars['Boolean']['output'];
  zuperCustomerUid?: Maybe<Scalars['String']['output']>;
};

export type HivePageStaffManager = {
  __typename?: 'HivePageStaffManager';
  coveredByViewer: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  hiveContact: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isViewer: Scalars['Boolean']['output'];
  mainContact: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pageCount: Scalars['Int']['output'];
  role: Role;
};

export type HivePageUpdateBuzzInput = {
  buzzId: Scalars['String']['input'];
  existingMediaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  newMedia?: InputMaybe<Array<Scalars['Upload']['input']>>;
  newMediaPositions?: InputMaybe<Array<Scalars['Int']['input']>>;
  text: Scalars['String']['input'];
};

export enum HiveState {
  Conserving = 'CONSERVING',
  Growing = 'GROWING',
  Reducing = 'REDUCING',
  Stable = 'STABLE',
  Thriving = 'THRIVING'
}

export type HiveStrengthDto = {
  __typename?: 'HiveStrengthDto';
  pointCount: Scalars['Int']['output'];
  timeline: Array<HiveStrengthPointDto>;
  windowWeeks: Scalars['Int']['output'];
};

export type HiveStrengthPointDto = {
  __typename?: 'HiveStrengthPointDto';
  beeFrames?: Maybe<Scalars['Int']['output']>;
  broodFrames?: Maybe<Scalars['Int']['output']>;
  date: Scalars['DateTime']['output'];
  honeyFrames?: Maybe<Scalars['Int']['output']>;
  isHarvest: Scalars['Boolean']['output'];
  queenSpotted: Scalars['Boolean']['output'];
  showNectarFlow: Scalars['Boolean']['output'];
  state: HiveStrengthState;
  trendPercent?: Maybe<Scalars['Float']['output']>;
};

export enum HiveStrengthState {
  Conserving = 'CONSERVING',
  Growing = 'GROWING',
  Reducing = 'REDUCING',
  Stable = 'STABLE',
  Thriving = 'THRIVING'
}

export type HoneyDeliveryDetails = {
  __typename?: 'HoneyDeliveryDetails';
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  customized: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByEmail?: Maybe<Scalars['String']['output']>;
};

export type HoneyJourneyState = {
  __typename?: 'HoneyJourneyState';
  deliveryScheduledFor?: Maybe<Scalars['DateTime']['output']>;
  onHold: Scalars['Boolean']['output'];
  step: HoneyJourneyStep;
  steps: Array<HoneyJourneyStepEvent>;
};

/** Where this building's honey is, hive to doorstep. Ladder order: AWAITING_HARVEST -> HARVESTED -> PALLETIZED -> AT_WAREHOUSE -> EXTRACTED -> JARRED -> AT_LOCAL_TEAM -> DELIVERY_SCHEDULED -> DELIVERED; NO_HARVEST is an off-ramp. */
export enum HoneyJourneyStep {
  AtLocalTeam = 'AT_LOCAL_TEAM',
  AtWarehouse = 'AT_WAREHOUSE',
  AwaitingHarvest = 'AWAITING_HARVEST',
  Delivered = 'DELIVERED',
  DeliveryScheduled = 'DELIVERY_SCHEDULED',
  Extracted = 'EXTRACTED',
  Harvested = 'HARVESTED',
  Jarred = 'JARRED',
  NoHarvest = 'NO_HARVEST',
  Palletized = 'PALLETIZED'
}

export type HoneyJourneyStepEvent = {
  __typename?: 'HoneyJourneyStepEvent';
  at: Scalars['DateTime']['output'];
  step: HoneyJourneyStep;
};

export type HoneyLabel = {
  __typename?: 'HoneyLabel';
  designRefId?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  status: HoneyLabelStatus;
  zuperJobId: Scalars['String']['output'];
};

/** What an open honey-label design cycle needs from the viewer. */
export enum HoneyLabelAction {
  Draft = 'DRAFT',
  ReviewReady = 'REVIEW_READY'
}

export type HoneyLabelDesign = {
  __typename?: 'HoneyLabelDesign';
  designRefId?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  status: HoneyLabelStatus;
  zuperJobUid: Scalars['String']['output'];
};

/** The status of a honey label */
export enum HoneyLabelStatus {
  ClientSubmitted = 'CLIENT_SUBMITTED',
  DesignInProgress = 'DESIGN_IN_PROGRESS',
  NoLabel = 'NO_LABEL',
  PendingClientReview = 'PENDING_CLIENT_REVIEW',
  Printed = 'PRINTED',
  ReadyToPrint = 'READY_TO_PRINT',
  ToReprint = 'TO_REPRINT',
  ToSubmit = 'TO_SUBMIT'
}

export type HoneyLabelStatusInput = {
  status: HoneyLabelStatus;
  zuperJobId: Scalars['String']['input'];
};

export type HourlyObservation = {
  __typename?: 'HourlyObservation';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  hour: Scalars['Int']['output'];
  hz: Scalars['String']['output'];
};

/** The accounting record behind a subscription: which platform holds the customer, and where to open it. */
export type HubspotAccountingCustomer = {
  __typename?: 'HubspotAccountingCustomer';
  /** The customer id on that platform. */
  externalId: Scalars['String']['output'];
  /** QuickBooks Canada, QuickBooks US or Pennylane. */
  provider: Scalars['String']['output'];
  /** The customer page in the platform’s web app; null when the link cannot be built (Pennylane without an API key). */
  url?: Maybe<Scalars['String']['output']>;
};

/** Aura customers two ways: HubSpot’s (an Aura line on this season’s deals, auraKind) and the app’s (MyHive pages on the FULL Aura tier, set by hand). Subscription counts are active subscriptions only. */
export type HubspotAuraCoverage = {
  __typename?: 'HubspotAuraCoverage';
  /** Pages on the FULL Aura tier. */
  pagesFull: Scalars['Int']['output'];
  /** Of those, linked to an active subscription with an Aura line. */
  pagesFullAuraSubscription: Scalars['Int']['output'];
  /** Of those, linked to a subscription HubSpot does not consider Aura — check. */
  pagesFullOtherSubscription: Scalars['Int']['output'];
  /** Of those, no HubSpot link at all (no id, or an id HubSpot does not know) — check. */
  pagesFullUnlinked: Scalars['Int']['output'];
  /** Active subscriptions with an Aura line this season. */
  subscriptionsAura: Scalars['Int']['output'];
  /** Of those, an Aura line sits next to a hive package. */
  subscriptionsAuraAddon: Scalars['Int']['output'];
  /** Churned subscriptions whose last season had an Aura line. */
  subscriptionsAuraChurned: Scalars['Int']['output'];
  /** Of those, the package line itself is Aura. */
  subscriptionsAuraPackage: Scalars['Int']['output'];
  /** Of those, linked pages exist but none is on the FULL tier. */
  subscriptionsAuraPageFree: Scalars['Int']['output'];
  /** Of those, at least one linked page is on the FULL tier. */
  subscriptionsAuraPageFull: Scalars['Int']['output'];
  /** Of those, no page carries the subscription’s id. */
  subscriptionsAuraWithoutPage: Scalars['Int']['output'];
};

/** HUBSPOT = an Aura line on this season’s deals; APP_ONLY = a page on the FULL Aura tier but no Aura line in HubSpot; HUBSPOT_ONLY = an Aura line in HubSpot but no page on the FULL tier. */
export enum HubspotAuraFilter {
  AppOnly = 'APP_ONLY',
  Hubspot = 'HUBSPOT',
  HubspotOnly = 'HUBSPOT_ONLY'
}

/** Whether this season’s lines make the subscription an Aura customer: ADDON = an Aura line next to a hive package; PACKAGE = the package line itself is Aura (Nature Impact, Nature Risk Tracking, Remote Sensing); NONE otherwise. Aura SKUs: S1002 remote sensing, S641 ground truth, S1001 honey eDNA. */
export enum HubspotAuraKind {
  Addon = 'ADDON',
  None = 'NONE',
  Package = 'PACKAGE'
}

/** Per-SKU entitlements per unit, inferred at sync time from every line carrying the SKU. */
export type HubspotCatalogEntry = {
  __typename?: 'HubspotCatalogEntry';
  /** Share of lines whose stated per-unit counts equal the inferred ones. */
  agreement: Scalars['Float']['output'];
  alveolePackage?: Maybe<AlveolePackages>;
  /** SKU, or name:<normalised name> for lines without one. */
  id: Scalars['String']['output'];
  lines: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packageShare: Scalars['Float']['output'];
  perUnit: HubspotEntitlements;
  sku?: Maybe<Scalars['String']['output']>;
  /** At least 75% agreement — used for per-line checks. */
  trusted: Scalars['Boolean']['output'];
};

/** Contacts two ways: the platform’s main and hive (site) contacts against HubSpot’s labelled contacts on the subscription. Billing has no platform side, so it is HubSpot’s label against HubSpot’s own typed property. Population: active pages linked to a subscription. */
export type HubspotContactCoverage = {
  __typename?: 'HubspotContactCoverage';
  /** Subscriptions with an Asset Management contact label. */
  assetManagement: Scalars['Int']['output'];
  /** Of the labelled ones, the typed billing email names someone else. */
  billingDiffer: Scalars['Int']['output'];
  /** Subscriptions with a Billing Contact label. */
  billingLabelled: Scalars['Int']['output'];
  /** No billing contact either way. */
  billingNone: Scalars['Int']['output'];
  /** A billing email typed on the subscription, but no Billing Contact label. */
  billingPropertyOnly: Scalars['Int']['output'];
  hive: HubspotContactRoleCoverage;
  main: HubspotContactRoleCoverage;
  /** Active pages linked to a subscription — the population compared. */
  pages: Scalars['Int']['output'];
};

/** One contact role, the platform’s page-manager flag against HubSpot’s labelled contact, over active pages linked to a subscription. */
export type HubspotContactRoleCoverage = {
  __typename?: 'HubspotContactRoleCoverage';
  /** Both sides name someone, and they differ. */
  different: Scalars['Int']['output'];
  /** HubSpot has a labelled contact; the platform names nobody. */
  hubspotOnly: Scalars['Int']['output'];
  /** Inside HubSpot: the typed *_contact_email property names someone other than the labelled contact. */
  labelPropertyDiffer: Scalars['Int']['output'];
  neither: Scalars['Int']['output'];
  /** The platform names someone; HubSpot has no contact with this label. */
  platformOnly: Scalars['Int']['output'];
  /** Same person on both sides. */
  same: Scalars['Int']['output'];
};

export type HubspotCount = {
  __typename?: 'HubspotCount';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type HubspotDeal = {
  __typename?: 'HubspotDeal';
  alveolePackage?: Maybe<AlveolePackages>;
  amount?: Maybe<Scalars['Float']['output']>;
  /** Any of its lines is an Aura product. */
  aura: Scalars['Boolean']['output'];
  carrType?: Maybe<Scalars['String']['output']>;
  /** CLOSED, YYYY-MM-DD: when the deal was signed or is expected to be. Floats around the season; on a renewal deal it is the renewal date. */
  closeDate?: Maybe<Scalars['String']['output']>;
  hubspotUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  labels: Array<Scalars['Int']['output']>;
  lineItems: Array<HubspotLineItem>;
  name: Scalars['String']['output'];
  outcome: HubspotDealOutcome;
  packageName?: Maybe<Scalars['String']['output']>;
  pipelineName: Scalars['String']['output'];
  /** RETIRED, YYYY-MM-DD: when the deal stopped carrying the recurring revenue. Null while live. */
  recurringRevenueInactiveDate?: Maybe<Scalars['String']['output']>;
  /** Why it retired: RENEWAL, UPGRADE or DOWNGRADE mean a successor deal took over; CHURNED means nobody did. */
  recurringRevenueInactiveReason?: Maybe<Scalars['String']['output']>;
  role: HubspotDealRole;
  /** HubSpot’s own rule for a live subscription: Renewals pipeline at Renewed (Closed) or Changes to Renewed Deals, with no recurring-revenue inactive date. One such deal per live subscription. */
  serviceActive: Scalars['Boolean']['output'];
  /** HubSpot’s object source (CRM_UI, AUTOMATION_PLATFORM, INTEGRATION…). */
  source?: Maybe<Scalars['String']['output']>;
  stageName: Scalars['String']['output'];
  /** The deal’s typed per-line counters, summed. */
  stated: HubspotEntitlements;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  /** CONTRACT end, YYYY-MM-DD: Contract End Date (Calculated), or the end calculated from the term when that is the 2050 placeholder — the date the customer has to be renewed by. */
  windowEnd?: Maybe<Scalars['String']['output']>;
  /** Where the contract end came from. */
  windowSource: HubspotWindowSource;
  /** CONTRACT start, YYYY-MM-DD: the deal’s Service Start Date. */
  windowStart?: Maybe<Scalars['String']['output']>;
};

export enum HubspotDealOutcome {
  Lost = 'LOST',
  Open = 'OPEN',
  Won = 'WON'
}

/** From the association label HubSpot automation maintains (ACTIVE, RENEWAL, SUPERSEDED, CARR, ORIGINAL) or, for the label-less Add-On and Aura pipelines, the pipeline. */
export enum HubspotDealRole {
  Active = 'ACTIVE',
  Addon = 'ADDON',
  AuraSale = 'AURA_SALE',
  Carr = 'CARR',
  Original = 'ORIGINAL',
  Other = 'OTHER',
  Renewal = 'RENEWAL',
  Superseded = 'SUPERSEDED'
}

/** Entitlement counts, keyed like the HubSpot line-item properties they come from. */
export type HubspotEntitlements = {
  __typename?: 'HubspotEntitlements';
  auraReport: Scalars['Float']['output'];
  beehomes: Scalars['Float']['output'];
  birdSensor: Scalars['Float']['output'];
  hives: Scalars['Float']['output'];
  honeyEdnaAnalysis: Scalars['Float']['output'];
  honeyJars: Scalars['Float']['output'];
  microplasticMonitoring: Scalars['Float']['output'];
  pesticideMonitoring: Scalars['Float']['output'];
  pollinatorSensor: Scalars['Float']['output'];
  seedPacks: Scalars['Float']['output'];
  workshopCredits: Scalars['Float']['output'];
};

/** One data-quality finding, evaluated by the last sync. */
export type HubspotFinding = {
  __typename?: 'HubspotFinding';
  /** YYYY-MM-DD — the date the checks were evaluated for. */
  asOf: Scalars['String']['output'];
  code: Scalars['String']['output'];
  dealId?: Maybe<Scalars['String']['output']>;
  dealName?: Maybe<Scalars['String']['output']>;
  /** What the code means, in words. */
  description: Scalars['String']['output'];
  detail: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lineItemId?: Maybe<Scalars['String']['output']>;
  severity: HubspotIssueSeverity;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionName?: Maybe<Scalars['String']['output']>;
  subscriptionStatus?: Maybe<HubspotSubscriptionStatus>;
};

export type HubspotFindingTypeCount = {
  __typename?: 'HubspotFindingTypeCount';
  /** What the finding is about: status (active or churned) | season (season dates) | renewal (renewal preview) | lines (line items and counters) | aura (Aura customers, HubSpot against the app) | contacts (main, hive and billing contacts, the platform against HubSpot and HubSpot against itself) | addons (invoiced add-on deals and how they count toward a season) | invoicing (the QuickBooks / Pennylane invoice cache against the season and the add-ons). */
  area: Scalars['String']['output'];
  code: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  severity: HubspotIssueSeverity;
};

/** ERRORS = at least one error; ANY = at least one error or warning; CLEAN = info-level findings only. */
export enum HubspotFindingsFilter {
  Any = 'ANY',
  Clean = 'CLEAN',
  Errors = 'ERRORS'
}

/** ERROR = the product model cannot be evaluated; WARN = wrong or ambiguous data; INFO = worth knowing, not wrong. */
export enum HubspotIssueSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warn = 'WARN'
}

export type HubspotLineItem = {
  __typename?: 'HubspotLineItem';
  amount?: Maybe<Scalars['Float']['output']>;
  /** Inferred catalog per-unit × quantity; null when the SKU is not trusted. */
  catalog?: Maybe<HubspotEntitlements>;
  contractType?: Maybe<Scalars['String']['output']>;
  /** engagement (hives, workshops, jars…) | aura (remote sensing, ground truth, eDNA). */
  family: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPackage: Scalars['Boolean']['output'];
  /** Entitlement keys where stated and catalog disagree. */
  mismatch: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  /** The per-line counts as stored in HubSpot — hand-maintained totals. */
  stated: HubspotEntitlements;
  /** recurring | one-time (installation fee, one-time benefit: never renews) | discount (one-time or perpetual: HubSpot cannot tell, confirm). */
  term: Scalars['String']['output'];
  termMonths?: Maybe<Scalars['Int']['output']>;
};

/** LINKED = a MyHive page carries this subscription’s id; UNLINKED = no page does. */
export enum HubspotLinkFilter {
  Linked = 'LINKED',
  Unlinked = 'UNLINKED'
}

/** The MyHive page that reaches this subscription today, through Zuper’s copy of the id. */
export type HubspotLinkedPage = {
  __typename?: 'HubspotLinkedPage';
  /** The page’s Aura tier in our app (FREE or FULL) — set by hand today, not from HubSpot. */
  auraTier: Scalars['String']['output'];
  id: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The admin hub’s HubSpot overview — every number reads from the mirror tables and the last successful sync. */
export type HubspotOverview = {
  __typename?: 'HubspotOverview';
  activeSubscriptions: Scalars['Int']['output'];
  /** Active subscriptions whose open renewal deal has line items. */
  activeWithRenewalPreview: Scalars['Int']['output'];
  /** YYYY-MM-DD the findings were evaluated for; null before the first sync. */
  asOf?: Maybe<Scalars['String']['output']>;
  auraCoverage: HubspotAuraCoverage;
  /** Active subscriptions with nothing above info level. */
  cleanActiveSubscriptions: Scalars['Int']['output'];
  contactCoverage: HubspotContactCoverage;
  coverage: HubspotPageCoverage;
  dealsByRole: Array<HubspotCount>;
  findingsBySeverity: Array<HubspotCount>;
  /** Every finding type in the catalog with its severity, description and count as of the last sync — zero counts included, ordered errors → warnings → info, most frequent first. */
  findingsByType: Array<HubspotFindingTypeCount>;
  lastSync?: Maybe<HubspotSyncRun>;
  /** Add-On / Aura pipeline deals attached to no subscription. */
  orphanDeals: Scalars['Int']['output'];
  renewalCoverage: HubspotRenewalCoverage;
  /** Active subscriptions with no closed-won deal covering today. */
  seasonNotCovered: Scalars['Int']['output'];
  serviceCoverage: HubspotServiceCoverage;
  /** Subscriptions whose status property is empty. */
  statusUnset: Scalars['Int']['output'];
  subscriptions: Scalars['Int']['output'];
  subscriptionsByStatus: Array<HubspotCount>;
  subscriptionsWithErrors: Scalars['Int']['output'];
};

/** MyHive pages against HubSpot subscriptions, both ways. A page reaches its subscription through Zuper’s copy of the id (Page.zuperHubspotCustomerId); "unknown" means the id is set but HubSpot has no such subscription. */
export type HubspotPageCoverage = {
  __typename?: 'HubspotPageCoverage';
  /** Of the subscriptions without a page, those effectively active. */
  activeSubscriptionsWithoutPage: Scalars['Int']['output'];
  /** Every Page row. */
  pages: Scalars['Int']['output'];
  /** Pages whose id matches a subscription in the mirror. */
  pagesLinked: Scalars['Int']['output'];
  /** Of the linked pages, those Zuper marks active whose subscription has no live deal. */
  pagesLinkedActiveNotLive: Scalars['Int']['output'];
  /** Of the linked pages, those Zuper marks ended whose subscription has a live deal. */
  pagesLinkedEndedLive: Scalars['Int']['output'];
  pagesWithUnknownSubscription: Scalars['Int']['output'];
  /** Of the pages with an unknown id, those whose service status is ACTIVE. */
  pagesWithUnknownSubscriptionActiveService: Scalars['Int']['output'];
  pagesWithoutHubspotId: Scalars['Int']['output'];
  /** Of the pages without an id, those whose service status is ACTIVE. */
  pagesWithoutHubspotIdActiveService: Scalars['Int']['output'];
  subscriptions: Scalars['Int']['output'];
  subscriptionsWithPage: Scalars['Int']['output'];
  /** Subscriptions whose id sits on more than one page. */
  subscriptionsWithSeveralPages: Scalars['Int']['output'];
  subscriptionsWithoutPage: Scalars['Int']['output'];
};

/** Next season: the Renewal Contract deal, diffed line by line against the active deal. */
export type HubspotRenewal = {
  __typename?: 'HubspotRenewal';
  dealId?: Maybe<Scalars['String']['output']>;
  diff: Array<HubspotRenewalDiffEntry>;
  /** YYYY-MM-DD — the renewal deal’s close date. */
  renewalDate?: Maybe<Scalars['String']['output']>;
};

/** Renewals on the active subscriptions, seen through two dates: the season end (the live deal’s package-line billing end) and the renewal due date (the open Renewals-pipeline deal’s close date, set to the season end). A preview needs the renewal deal to have a package line. */
export type HubspotRenewalCoverage = {
  __typename?: 'HubspotRenewalCoverage';
  activeSubscriptions: Scalars['Int']['output'];
  /** Active subscriptions whose contract ends today or later (renew by), by contract-end year, ascending. With liveDealSeasonEnded and contractsUnknown these add up to activeSubscriptions. */
  contractsByYear: Array<HubspotCount>;
  /** Active subscriptions with no contract end — Contract End Date (Calculated) empty or the 2050 placeholder, and no term to calculate one from. */
  contractsUnknown: Scalars['Int']['output'];
  /** Active subscriptions whose live deal’s contract already ended (its Contract End Date is past) — the renewal is late. */
  liveDealSeasonEnded: Scalars['Int']['output'];
  /** Renewal deals by pipeline stage, most common first. */
  renewalsByStage: Array<HubspotCount>;
  /** Renewal deals still open although their own Service Start Date is already past — late. */
  renewalsLate: Scalars['Int']['output'];
  /** Renewal deals with a Service Start Date whose live contract has no end date to compare it with. */
  renewalsNoContractEnd: Scalars['Int']['output'];
  /** Renewal deals with no Service Start Date — nothing to check against. */
  renewalsNoServiceStart: Scalars['Int']['output'];
  /** Renewal deals (one per subscription, soonest when several) with a line flagged as the package — a preview is possible. */
  renewalsPreviewable: Scalars['Int']['output'];
  /** Renewal deals whose Service Start Date is exactly the day after the subscription’s contract end. */
  renewalsStartDayAfter: Scalars['Int']['output'];
  /** Renewal deals (not late) whose Service Start Date is not exactly the day after the live contract ends — a gap or an overlap. */
  renewalsStartNotAfterContractEnd: Scalars['Int']['output'];
  /** Renewal deals carrying a discount, which may be one-time or perpetual: HubSpot cannot tell. */
  renewalsWithDiscountLines: Scalars['Int']['output'];
  /** Renewal deals carrying an installation fee or one-time benefit, which never renews. */
  renewalsWithOneTimeLines: Scalars['Int']['output'];
  renewalsWithoutLineItems: Scalars['Int']['output'];
  /** Renewal deals with line items but no line flagged as the package. */
  renewalsWithoutPackageLine: Scalars['Int']['output'];
  /** Active subscriptions whose current service year (a 12-month slice of the contract from its Service Start Date) ends today or later, by year, ascending. With liveDealSeasonEnded and seasonsUnknown these add up to activeSubscriptions. */
  seasonsByYear: Array<HubspotCount>;
  /** Active subscriptions with no service year — the live deal has no Service Start Date. */
  seasonsUnknown: Scalars['Int']['output'];
  /** Active subscriptions with exactly one open Renewals-pipeline deal. */
  withOneRenewal: Scalars['Int']['output'];
  withSeveralRenewals: Scalars['Int']['output'];
  withoutRenewal: Scalars['Int']['output'];
};

export type HubspotRenewalDiffEntry = {
  __typename?: 'HubspotRenewalDiffEntry';
  /** This season: the live deal plus the season’s Add-On deals. */
  activeQty: Scalars['Float']['output'];
  /** The part of activeQty that came from Add-On deals. */
  addonQty: Scalars['Float']['output'];
  /** added | removed | changed | same; one-time when a one-time line is absent next season as expected; none when there is no renewal deal to compare with. */
  change: Scalars['String']['output'];
  /** Sum of this season’s line amounts. */
  currentAmount?: Maybe<Scalars['Float']['output']>;
  /** HubSpot’s own counters on this season’s lines, summed — a package line carries its contents here. */
  currentCounters: HubspotEntitlements;
  /** engagement | aura (lineFamilyOf). */
  family: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The same for the renewal deal’s line. */
  renewalCounters?: Maybe<HubspotEntitlements>;
  renewalLine?: Maybe<HubspotRenewalLine>;
  renewalQty: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  /** This season’s lines, one per deal they sit on. */
  sources: Array<HubspotSeasonLineSource>;
  /** recurring | one-time | discount (lineTermOf). A discount absent next season reads `removed`, because it may have been perpetual. */
  term: Scalars['String']['output'];
};

/** The renewal deal’s line for a HubspotRenewalDiffEntry. */
export type HubspotRenewalLine = {
  __typename?: 'HubspotRenewalLine';
  amount?: Maybe<Scalars['Float']['output']>;
  isPackage: Scalars['Boolean']['output'];
  quantity: Scalars['Float']['output'];
};

/** This season: the live deal’s current service year and what counts toward it. */
export type HubspotSeason = {
  __typename?: 'HubspotSeason';
  activeDealId?: Maybe<Scalars['String']['output']>;
  addonDealIds: Array<Scalars['String']['output']>;
  /** Won Existing CARR deals overlapping the season — listed, not counted. */
  carrDealIds: Array<Scalars['String']['output']>;
  /** YYYY-MM-DD. The live deal’s contract end — renew by. */
  contractEnd?: Maybe<Scalars['String']['output']>;
  /** YYYY-MM-DD. The live deal’s Service Start Date. */
  contractStart?: Maybe<Scalars['String']['output']>;
  totals: HubspotSeasonTotals;
  /** YYYY-MM-DD. This service year’s end. */
  windowEnd?: Maybe<Scalars['String']['output']>;
  windowSource?: Maybe<HubspotWindowSource>;
  /** YYYY-MM-DD. This service year’s start. */
  windowStart?: Maybe<Scalars['String']['output']>;
  /** Which service year of the contract this is, from 1. */
  year?: Maybe<Scalars['Int']['output']>;
  /** How many service years the contract has; null without an end. */
  years?: Maybe<Scalars['Int']['output']>;
};

/** One of this season’s lines behind a HubspotRenewalDiffEntry: the deal it sits on and HubSpot’s own quantity and amount. */
export type HubspotSeasonLineSource = {
  __typename?: 'HubspotSeasonLineSource';
  amount?: Maybe<Scalars['Float']['output']>;
  /** HubSpot’s own counters on this line (hives, credits, jars…). */
  counters: HubspotEntitlements;
  dealId: Scalars['String']['output'];
  dealName: Scalars['String']['output'];
  isPackage: Scalars['Boolean']['output'];
  quantity: Scalars['Float']['output'];
  role: HubspotDealRole;
};

export type HubspotSeasonTotals = {
  __typename?: 'HubspotSeasonTotals';
  /** The live deal’s typed per-line counters, summed. */
  active: HubspotEntitlements;
  /** The season’s won add-on deals’ typed counters, summed. */
  addons: HubspotEntitlements;
  /** active + addons. Always HubSpot’s own typed values — never a catalog estimate, so a line sales ops zeroed stays zero. */
  total: HubspotEntitlements;
};

/** Active subscriptions — a deal in the Renewals pipeline at Renewed (Closed) or Changes to Renewed Deals with no recurring-revenue inactive date, the one rule that decides it — against the MyHive pages that say their service is active. */
export type HubspotServiceCoverage = {
  __typename?: 'HubspotServiceCoverage';
  /** Pages whose service status is ACTIVE. */
  pagesActive: Scalars['Int']['output'];
  /** Active pages linked to a subscription that is live by the rule. */
  pagesActiveLive: Scalars['Int']['output'];
  /** Active pages linked to a subscription that is NOT live by the rule. */
  pagesActiveNotLive: Scalars['Int']['output'];
  pagesActiveWithUnknownSubscription: Scalars['Int']['output'];
  pagesActiveWithoutHubspotId: Scalars['Int']['output'];
  /** Deals meeting the rule; one per active subscription. */
  serviceActiveDeals: Scalars['Int']['output'];
  /** Subscriptions with such a deal. */
  subscriptionsLive: Scalars['Int']['output'];
  subscriptionsLiveWithPage: Scalars['Int']['output'];
  subscriptionsLiveWithoutPage: Scalars['Int']['output'];
};

export type HubspotSubscription = {
  __typename?: 'HubspotSubscription';
  auraKind: HubspotAuraKind;
  /** YYYY-MM-DD. The live deal’s contract end — the date the customer has to be renewed by. */
  contractEndDate?: Maybe<Scalars['String']['output']>;
  /** YYYY-MM-DD. The live deal’s Service Start Date. */
  contractStartDate?: Maybe<Scalars['String']['output']>;
  currentArrCad?: Maybe<Scalars['Float']['output']>;
  currentPackage?: Maybe<Scalars['String']['output']>;
  effectiveStatus: HubspotSubscriptionStatus;
  /** Error-level findings on this subscription, as of the last sync. */
  errorCount: Scalars['Int']['output'];
  hubspotModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  hubspotUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  myhiveUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** YYYY-MM-DD */
  nextRenewalDate?: Maybe<Scalars['String']['output']>;
  page?: Maybe<HubspotLinkedPage>;
  previousPackage?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  /** YYYY-MM-DD. This service year’s end — when seasonal entitlements run out; the contract end on the last year. */
  seasonEndDate?: Maybe<Scalars['String']['output']>;
  /** Where the contract end came from; NONE when there is no live deal or it has no dates. */
  seasonSource: HubspotWindowSource;
  /** YYYY-MM-DD. This service year’s start: a 12-month slice of the live deal’s contract, counted from its Service Start Date. */
  seasonStartDate?: Maybe<Scalars['String']['output']>;
  /** Which service year of the contract the customer is in, from 1. */
  serviceYear?: Maybe<Scalars['Int']['output']>;
  /** How many service years the contract has; null without an end. */
  serviceYears?: Maybe<Scalars['Int']['output']>;
  /** The raw status property; null when HubSpot never set it. */
  status?: Maybe<Scalars['String']['output']>;
  /** True when HubSpot’s own status property is empty or disagrees with effectiveStatus. */
  statusDerived: Scalars['Boolean']['output'];
  warnCount: Scalars['Int']['output'];
};

export type HubspotSubscriptionDetail = {
  __typename?: 'HubspotSubscriptionDetail';
  /** Null until the invoicing sync has matched the subscription to a QuickBooks or Pennylane customer. */
  accountingCustomer?: Maybe<HubspotAccountingCustomer>;
  auraKind: HubspotAuraKind;
  /** YYYY-MM-DD. The live deal’s contract end — the date the customer has to be renewed by. */
  contractEndDate?: Maybe<Scalars['String']['output']>;
  /** YYYY-MM-DD. The live deal’s Service Start Date. */
  contractStartDate?: Maybe<Scalars['String']['output']>;
  currentArrCad?: Maybe<Scalars['Float']['output']>;
  currentPackage?: Maybe<Scalars['String']['output']>;
  deals: Array<HubspotDeal>;
  effectiveStatus: HubspotSubscriptionStatus;
  /** Error-level findings on this subscription, as of the last sync. */
  errorCount: Scalars['Int']['output'];
  findings: Array<HubspotFinding>;
  hubspotModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  hubspotUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  myhiveUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** YYYY-MM-DD */
  nextRenewalDate?: Maybe<Scalars['String']['output']>;
  page?: Maybe<HubspotLinkedPage>;
  previousPackage?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  renewal: HubspotRenewal;
  season: HubspotSeason;
  /** YYYY-MM-DD. This service year’s end — when seasonal entitlements run out; the contract end on the last year. */
  seasonEndDate?: Maybe<Scalars['String']['output']>;
  /** Where the contract end came from; NONE when there is no live deal or it has no dates. */
  seasonSource: HubspotWindowSource;
  /** YYYY-MM-DD. This service year’s start: a 12-month slice of the live deal’s contract, counted from its Service Start Date. */
  seasonStartDate?: Maybe<Scalars['String']['output']>;
  /** Which service year of the contract the customer is in, from 1. */
  serviceYear?: Maybe<Scalars['Int']['output']>;
  /** How many service years the contract has; null without an end. */
  serviceYears?: Maybe<Scalars['Int']['output']>;
  /** The raw status property; null when HubSpot never set it. */
  status?: Maybe<Scalars['String']['output']>;
  /** True when HubSpot’s own status property is empty or disagrees with effectiveStatus. */
  statusDerived: Scalars['Boolean']['output'];
  warnCount: Scalars['Int']['output'];
};

/** ACTIVE when the subscription has a service-active deal (Renewals pipeline, Renewed or Changes to Renewed, no recurring-revenue inactive date), else CHURNED. HubSpot’s own status property is reported beside it, never used to decide. UNKNOWN is no longer produced. */
export enum HubspotSubscriptionStatus {
  Active = 'ACTIVE',
  Churned = 'CHURNED',
  Unknown = 'UNKNOWN'
}

export type HubspotSyncRun = {
  __typename?: 'HubspotSyncRun';
  deals?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  issues?: Maybe<Scalars['Int']['output']>;
  lineItems?: Maybe<Scalars['Int']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: HubspotSyncStatus;
  subscriptions?: Maybe<Scalars['Int']['output']>;
  /** "cron", "cli", or the user id that pressed refresh. */
  triggeredBy: Scalars['String']['output'];
};

export enum HubspotSyncStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

/** Where a deal’s contract end came from: Contract End Date (Calculated); the end calculated from the term, when the calculated one is HubSpot’s 2050 placeholder; a Service Start Date with no end; nothing. Line item billing dates are never read. */
export enum HubspotWindowSource {
  ContractEnd = 'CONTRACT_END',
  ContractTerm = 'CONTRACT_TERM',
  None = 'NONE',
  StartOnly = 'START_ONLY'
}

export type ImpactAndStateDataEntity = {
  __typename?: 'ImpactAndStateDataEntity';
  landCover: AuraLandCoverData;
  lightPollution: LightPollutionData;
  msa: MsaData;
  surfaceTemperature: SurfaceTemperatureData;
};

export type ImpactStats = {
  __typename?: 'ImpactStats';
  eventsThisYear: Scalars['Int']['output'];
  newSubscribers: Scalars['Int']['output'];
  subscribers: Scalars['Int']['output'];
};

export type InviteTenantsToEventInput = {
  eventId: Scalars['ID']['input'];
  language: Language;
  message: Scalars['String']['input'];
  tenantEmails: Array<Scalars['String']['input']>;
};

export enum InvoiceStatus {
  Open = 'OPEN',
  Paid = 'PAID'
}

export enum InvoicingServiceProvider {
  Pennylane = 'PENNYLANE',
  QuickbooksCa = 'QUICKBOOKS_CA',
  QuickbooksUs = 'QUICKBOOKS_US'
}

export enum IucnSpeciesCategory {
  CriticallyEndangered = 'CriticallyEndangered',
  Endangered = 'Endangered',
  LeastConcern = 'LeastConcern',
  NearThreatened = 'NearThreatened',
  Unknown = 'Unknown',
  Vulnerable = 'Vulnerable'
}

export type KioskFromZuperJobUid = {
  __typename?: 'KioskFromZuperJobUid';
  coverPic?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventDescription: LanguageText;
  eventId: Scalars['String']['output'];
  eventImageFilename?: Maybe<Scalars['String']['output']>;
  eventTitle: LanguageText;
  eventType: EventType;
  language?: Maybe<Language>;
  pageId: Scalars['String']['output'];
  profilePic?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type KioskRegistrantInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
};

export type LandCoverData = {
  __typename?: 'LandCoverData';
  /** GeoJSON string */
  aoi: Scalars['String']['output'];
  sources: Array<Scalars['String']['output']>;
  summary: LandCoverSummary;
  /** Base64 encoded TIFF file */
  tiff: Scalars['String']['output'];
};

export type LandCoverSummary = {
  __typename?: 'LandCoverSummary';
  agriculturalCover: Scalars['Float']['output'];
  artificialCover: Scalars['Float']['output'];
  cloudCover: Scalars['Float']['output'];
  msaLU: Scalars['Float']['output'];
  naturalCover: Scalars['Float']['output'];
  waterCover: Scalars['Float']['output'];
};

export enum Language {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Nl = 'NL'
}

export type LanguageText = {
  __typename?: 'LanguageText';
  en: Scalars['String']['output'];
  fr: Scalars['String']['output'];
};

export type LaunchQueenContestInput = {
  communityVoting: Scalars['Boolean']['input'];
  deadline?: InputMaybe<Scalars['String']['input']>;
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
  pageId: Scalars['ID']['input'];
};

export type LightPollutionData = {
  __typename?: 'LightPollutionData';
  aoi: Scalars['GeoJSON']['output'];
  avgBrightness?: Maybe<Scalars['Float']['output']>;
  generating: Scalars['Boolean']['output'];
  /** Presigned URL to the GeoTIFF */
  mapLayerUrl?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<AuraRank>;
  score?: Maybe<Scalars['Float']['output']>;
  /** Mean radiance for the ring outside the ROI but inside the map layer's crop circle - null only when that ring has no valid pixels at all (eg. the ROI's own radius already reaches the crop radius) */
  surroundingAvgBrightness?: Maybe<Scalars['Float']['output']>;
};

export type LinkedInMediaInput = {
  mimeType: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type LinkedInShareSessionResponse = {
  __typename?: 'LinkedInShareSessionResponse';
  redirectUrl: Scalars['String']['output'];
};

export type LocationRiskDataEntity = {
  __typename?: 'LocationRiskDataEntity';
  atRiskSpecies: AtRiskSpeciesData;
  /** null if the site falls outside any known Aqueduct watershed */
  flood?: Maybe<FloodData>;
  protectedAreas: AuraProtectedAreasData;
  watershedId?: Maybe<Scalars['String']['output']>;
  /** Aqueduct watersheds around the site - the flood/water-stress/drought map layer */
  watersheds?: Maybe<Array<AuraWatershed>>;
};

export type Locked = {
  __typename?: 'Locked';
  locked: Scalars['Boolean']['output'];
};

export type ManagedPage = {
  __typename?: 'ManagedPage';
  /** Total recorded attendance across this year's completed events (checklist first, kiosk fallback). */
  attendedThisYear: Scalars['Int']['output'];
  auraTier: AuraTier;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** Every completed event of this calendar year, chronological — the Events page's season slots. */
  completedEventsThisYear: Array<CompletedEvent>;
  contractedEvents: Scalars['Int']['output'];
  country?: Maybe<Scalars['String']['output']>;
  defaultLanguage: Language;
  description?: Maybe<Scalars['String']['output']>;
  eventCreditsLeft: Scalars['Int']['output'];
  eventInterest: Array<AudienceMember>;
  eventInterestCount: Scalars['Int']['output'];
  eventsBookedThisYear: Scalars['Int']['output'];
  features: PageFeatures;
  /** Who Alvéole contacts on arrival and where the honey goes. */
  honeyDeliveryDetails: HoneyDeliveryDetails;
  honeyInterest: Array<AudienceMember>;
  honeyInterestCount: Scalars['Int']['output'];
  honeyJourney?: Maybe<HoneyJourneyState>;
  honeyLabel?: Maybe<HoneyLabelDesign>;
  honeyLabelAction?: Maybe<HoneyLabelAction>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  /** This building's most recent completed events, with buzz photos and attendance, newest first. */
  latestCompletedEvents: Array<CompletedEvent>;
  lng?: Maybe<Scalars['Float']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  newSubscriberCount: Scalars['Int']['output'];
  primaryContactName?: Maybe<Scalars['String']['output']>;
  queenCandidates: Array<QueenCandidateEntry>;
  queenContestState: QueenContestState;
  queenCrownedAt?: Maybe<Scalars['DateTime']['output']>;
  queenVoteClosesAt?: Maybe<Scalars['DateTime']['output']>;
  queenVotingEnabled: Scalars['Boolean']['output'];
  queenWinnerName?: Maybe<Scalars['String']['output']>;
  /** This building's recent buzzes as feed rows, newest first. */
  recentUpdates: Array<RecentUpdate>;
  /** Meadow priority scores; null when unlinkable or meadow is down. */
  scores?: Maybe<PriorityScore>;
  /** This season's live (pending or confirmed) events regardless of date, joined with the event catalog — past-dated rows Zuper hasn't resolved included. The client splits upcoming from past by its own clock. */
  seasonEvents: Array<UpcomingEvent>;
  slug?: Maybe<Scalars['String']['output']>;
  slugs: Array<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  subscriberCount: Scalars['Int']['output'];
  subscribers: Array<AudienceMember>;
  team: Array<TeamMember>;
  title: Scalars['String']['output'];
  unreachableContacts: UnreachableContacts;
  /** Upcoming field work at this building — beekeeper visits and hive installations, for the NEXT THREE MONTHS only (events look a year ahead; see VISIT_LOOKAHEAD_DAYS). */
  upcomingVisits: Array<UpcomingVisit>;
  venueTimeZone?: Maybe<Scalars['String']['output']>;
  zuperCustomerUid?: Maybe<Scalars['String']['output']>;
  zuperRegion?: Maybe<Scalars['String']['output']>;
};

export type Me = {
  __typename?: 'Me';
  /** When Aura's one-time welcome dialog was dismissed — null means never shown (apps/web). */
  auraWelcomeSeenAt?: Maybe<Scalars['DateTime']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  /** Page ids where the viewer is on the event interest list (apps/web site page's on-list state). */
  eventInterestPageIds: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Page ids where the viewer is on the honey list (apps/web site page's on-list state). */
  honeyInterestPageIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Portfolio-wide aggregates for the Today page's impact hero. */
  impactStats: ImpactStats;
  jobTitle?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Language>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Ids of the ACTIVE pages the viewer manages — the cheap manager check (apps/web tenant page's Page settings door). `managedPages` is the same rule with the portfolio payload. */
  managedPageIds: Array<Scalars['String']['output']>;
  /** Active pages where the viewer is a page manager. */
  managedPages: Array<ManagedPage>;
  phone?: Maybe<Scalars['String']['output']>;
  /** When the PM quick tour was completed or skipped — null means never offered (apps/web). */
  pmTourSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the PM product-update banner was dismissed — null means still showing (apps/web). */
  pmUpdateBannerDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Event ids the viewer holds a REGISTERED registration for (apps/web site page's Registered state). */
  registeredEventIds: Array<Scalars['String']['output']>;
  role: Role;
  /** Ids of the ACTIVE pages whose subscriber list has the viewer's email — the cheap follower count (apps/web person properties, on the login and refresh paths). `subscribedPages` is the same rule with the page payload. */
  subscribedPageIds: Array<Scalars['String']['output']>;
  /** Active pages whose subscriber list has the viewer's email. */
  subscribedPages: Array<SubscribedPage>;
};

export enum MeadowIucnRedListCategory {
  CriticallyEndangered = 'CRITICALLY_ENDANGERED',
  Endangered = 'ENDANGERED',
  LeastConcern = 'LEAST_CONCERN',
  NearThreatened = 'NEAR_THREATENED',
  Unknown = 'UNKNOWN',
  Vulnerable = 'VULNERABLE'
}

export type MeadowSite = {
  __typename?: 'MeadowSite';
  hasSensorData: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  polygonGeojson?: Maybe<Scalars['JSON']['output']>;
  threebeeId?: Maybe<Scalars['String']['output']>;
};

export type MeasurementsEntity = {
  __typename?: 'MeasurementsEntity';
  /** null if the site has no ThreeBee sensor connected */
  bioacoustics?: Maybe<AuraBioacousticsData>;
  /** null if the site has no honey eDNA sample for the current year */
  ednaData?: Maybe<EdnaDataEntity>;
  /** null if the site has no hive */
  hiveData?: Maybe<HiveDataEntity>;
  /** null if the site has no hive */
  nestingData?: Maybe<NestingDataEntity>;
};

export type MessageEventAttendeesInput = {
  eventId: Scalars['ID']['input'];
  language: Language;
  message: Scalars['String']['input'];
};

export enum MessageRole {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

export type MsaData = {
  __typename?: 'MsaData';
  aoi?: Maybe<Scalars['GeoJSON']['output']>;
  generating: Scalars['Boolean']['output'];
  /** Presigned URL to the GeoTIFF */
  mapLayerUrl?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<AuraRank>;
  score?: Maybe<Scalars['Float']['output']>;
  /** Mean per-pixel MSA weight for the ring outside the site's AOI but inside the map layer's crop circle - null when the site has no stored polygon (nothing beyond the AOI to summarize) */
  surroundingValue?: Maybe<Scalars['Float']['output']>;
  /** ThreeBee's own precomputed msa-family KPI scores (value_roi only), keyed by image_type (eg. msa, msa_i, msa_f, msa_lu_animals, msa_lu_plants) - which keys exist varies by site. */
  threebeeMsa?: Maybe<Scalars['JSONObject']['output']>;
  /** Mean per-pixel MSA weight within the ROI */
  value?: Maybe<Scalars['Float']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPageManager: Scalars['Boolean']['output'];
  addPageSubscriber: Scalars['Boolean']['output'];
  addPagesToGroup: Scalars['Boolean']['output'];
  /** Add a site the actor picked from address search. */
  addSelfAddedSite: SelfAddedSite;
  /** Add a contact to the building's team; the invite email rides the legacy choreography (apps/web). */
  addTeamMember: Scalars['Boolean']['output'];
  addToEventWaitingList: Scalars['Boolean']['output'];
  addToHoneyWaitingList: Scalars['Boolean']['output'];
  addUserToAllGroupPages: Scalars['Float']['output'];
  addUserToAllUserToClonePages: Scalars['Float']['output'];
  /** Assign an account to every page of a page group — clearOthers false adds them, true makes them the account's only pages (main/hive-contact rows kept; admin hub; internal roles only). */
  adminAssignUserToGroup: AdminAssignmentResult;
  /** Assign an account to ONE page — clearOthers false adds it, true makes it the account's only page (main/hive-contact rows kept; admin hub; internal roles only). */
  adminAssignUserToPage: AdminAssignmentResult;
  /** Give an account another account's pages — clearOthers false adds them to its own, true replaces its own with them (main/hive-contact rows kept; admin hub; internal roles only). */
  adminJoinUserPages: AdminAssignmentResult;
  /** Take an account off every page of a page group (main/hive-contact rows stay and are counted; admin hub; internal roles only). */
  adminRemoveUserFromGroup: AdminRemovalResult;
  /** Take an account off ONE page (a main/hive-contact row stays and is counted; admin hub; internal roles only). */
  adminRemoveUserFromPage: AdminRemovalResult;
  /** Copy a shared list into the caller's own sites. */
  adoptAuraShareLink: AuraShareAdoption;
  /** Approve the building's current honey-label design — flips the real Zuper label job to Client Submitted; HoneyJars reflects it after the next sync (apps/web). */
  approveHoneyLabel: Scalars['Boolean']['output'];
  /** Archive a chat session. Returns false if it was not found. */
  archiveAuraChatSession: Scalars['Boolean']['output'];
  /** Claim anonymous sessions for the signed-in viewer. Returns the count. */
  claimAuraChatSessions: Scalars['Int']['output'];
  clearAllUserPages: Scalars['Float']['output'];
  /** Create a share link for sites the actor owns. */
  createAuraShareLink: AuraShareLink;
  /** Create an anonymous visitor identity. */
  createAuraVisitor: AuraVisitor;
  createBuzz: Scalars['Boolean']['output'];
  createChatSession: Scalars['String']['output'];
  createFreeToolSession: FreeToolUseSession;
  createFreeToolShareSession?: Maybe<FreeToolUseSession>;
  createLinkedInShareSession: LinkedInShareSessionResponse;
  createPageGroup: PageGroup;
  createRegion: Region;
  createReportSectionTemplate: ReportSectionTemplate;
  createReportTemplate: ReportTemplate;
  /** Provisions a brand-new ThreeBee site (under the Aura platform account configured in Meadow) for a Meadow site that has none yet, and records its id. */
  createThreebeeSite: MeadowSite;
  createUser: Scalars['Boolean']['output'];
  crownQueenCandidate: Scalars['Boolean']['output'];
  /** Crown the contest's winning name — announces through the legacy comms path; named apart from legacy's crownQueenCandidate, which shares the schema (apps/web). */
  crownQueenContestWinner: Scalars['Boolean']['output'];
  deletePageGroup: Scalars['Boolean']['output'];
  deleteRegion: Scalars['Boolean']['output'];
  deleteReportSectionTemplate: Scalars['Boolean']['output'];
  deleteReportTemplate: Scalars['Boolean']['output'];
  emailAttendees: Scalars['Boolean']['output'];
  /** Generate the free screening report for one building (apps/web). */
  generateAuraFreeReport: AuraReport;
  /** Generate one building's framework report (apps/web). */
  generateAuraReport: AuraReport;
  /** Generate a free tool report and return its download URL */
  generateFreeToolReport: DownloadUrlResponse;
  /** Generate, store and return report download URL */
  generateReport: Report;
  generateReportFromTemplate: Scalars['String']['output'];
  getOrCreateMeadowSiteForPage: AdminSitePage;
  /** Add the viewer as a manager of THIS page, keeping every other assignment (apps/web site/:site — the header staff door; internal roles only). */
  hivePageAssignSelf: Scalars['Boolean']['output'];
  /** Make the viewer the manager of THIS page and of no other (apps/web site/:site — the header staff door; internal roles only). Pages where the viewer is the main or hive contact are kept; the result counts them. */
  hivePageAssignSelfOnly: HivePageAssignSelfOnlyResult;
  /** Create a buzz on a page the viewer manages (apps/web site/:site — manager authoring). */
  hivePageCreateBuzz: Scalars['Boolean']['output'];
  /** Delete a buzz on a page the viewer manages (apps/web site/:site — manager authoring; a soft delete, legacy contract). */
  hivePageDeleteBuzz: Scalars['Boolean']['output'];
  /** Email a colleague the page link (apps/web — anonymous-capable; a session personalizes the sender). */
  hivePageInviteColleague: Scalars['Boolean']['output'];
  /** Join the page's event interest list (apps/web — upsert; also page-subscribes, legacy contract). */
  hivePageJoinEventInterest: Scalars['Boolean']['output'];
  /** Join the page's honey list (apps/web — upsert; also page-subscribes, legacy contract). */
  hivePageJoinHoneyInterest: Scalars['Boolean']['output'];
  /** Join every page one of THIS page's managers manages — clearOthers false adds them to the viewer's own, true makes the viewer's pages exactly theirs (main/hive-contact rows kept; apps/web site/:site — the header staff door; internal roles only). */
  hivePageJoinManagerPages: HivePageJoinManagerPagesResult;
  /** Like (liked: true) or unlike a buzz (apps/web — anonymous likes ride the counter, legacy contract). */
  hivePageLikeBuzz: Scalars['Boolean']['output'];
  /** Suggest a queen name (apps/web — duplicates and closed contests throw). */
  hivePageNominateQueenName: QueenCandidateDto;
  /** Register the signed-in viewer for an event (apps/web — capacity/duplicate conflicts thrown). */
  hivePageRegisterForEvent: Scalars['Boolean']['output'];
  /** Subscribe an email to the page's updates (apps/web site/:site — idempotent). */
  hivePageSubscribe: Scalars['Boolean']['output'];
  /** Toggle the viewer's vote on a queen candidate (apps/web). */
  hivePageToggleQueenVote: Scalars['Boolean']['output'];
  /** Cancel the signed-in viewer's registration for an event (apps/web — throws if not registered, or already unregistered). */
  hivePageUnregisterFromEvent: Scalars['Boolean']['output'];
  /** Edit a buzz on a page the viewer manages (apps/web site/:site — manager authoring). */
  hivePageUpdateBuzz: Scalars['Boolean']['output'];
  /** Email an event invitation to tenant addresses (apps/web). Sender is the token's user. */
  inviteTenantsToEvent: Scalars['Boolean']['output'];
  /** Start a Name-the-Queen contest at this building — turns the queen feature on with the chosen settings and opens an election (apps/web). */
  launchQueenContest: Scalars['Boolean']['output'];
  likeBuzz: Scalars['Boolean']['output'];
  /** Mark Aura's one-time welcome dialog as seen (apps/web). */
  markAuraWelcomeSeen: Me;
  /** Mark the PM quick tour as completed or skipped (apps/web). */
  markPmTourSeen: Me;
  /** Dismiss the PM product-update banner (apps/web). */
  markPmUpdateBannerDismissed: Me;
  /** Email everyone registered on an event (apps/web). Recipients resolve server-side — the browser never sees addresses. */
  messageEventAttendees: Scalars['Boolean']['output'];
  nominateQueenName: QueenCandidateDto;
  publishReportSectionTemplate: ReportSectionTemplate;
  registerForEvent: Scalars['Boolean']['output'];
  registerKioskAttendees: Scalars['Boolean']['output'];
  removeBuzz: Scalars['Boolean']['output'];
  removePageFromGroup: Scalars['Boolean']['output'];
  removePageManager: Scalars['Boolean']['output'];
  /** Remove one of the actor's own self-added sites. */
  removeSelfAddedSite: Scalars['Boolean']['output'];
  /** Remove a team member from the building (apps/web). */
  removeTeamMember: Scalars['Boolean']['output'];
  removeUserFromAllGroupPages: Scalars['Float']['output'];
  removeUserFromAllUserToClonePages: Scalars['Float']['output'];
  /** Rename a chat session. */
  renameAuraChatSession: AuraChatSession;
  requestWorkshop: Scalars['Boolean']['output'];
  resendInviteEmail: Scalars['Boolean']['output'];
  revertDraftToLive: ReportSectionTemplate;
  scanHandwrittenContacts: SubScanResponse;
  sendChatMessageStreaming: Scalars['Boolean']['output'];
  sendFreeChatMessageStreaming: Scalars['Boolean']['output'];
  sendFreeToolReportEmail: Scalars['Boolean']['output'];
  sendShareWithColleague: Scalars['Boolean']['output'];
  sendShareWithTenants: Scalars['Boolean']['output'];
  /** Set the calling visitor's email. */
  setAuraVisitorEmail: Scalars['Boolean']['output'];
  setMeadowSitePolygon: MeadowSite;
  setMeadowSiteSensorData: MeadowSite;
  setMeadowSiteThreebeeId: MeadowSite;
  setMyHiveOnboardingProgress: Scalars['Boolean']['output'];
  setPageAuraTier: AdminSitePage;
  /** Set (or clear) the running contest's voting deadline — end of the given day on the venue's clock (apps/web). */
  setQueenContestDeadline: Scalars['Boolean']['output'];
  /** Turn community voting on the running contest on or off (apps/web). */
  setQueenContestVoting: Scalars['Boolean']['output'];
  setQueenElectionDeadline: Scalars['Boolean']['output'];
  setReportTemplateMembers: ReportTemplate;
  shareEvent: Scalars['Boolean']['output'];
  /** Invite tenants to the building page by email — subscribes each address and sends the invite through the legacy comms path (apps/web). */
  sharePageWithTenants: Scalars['Boolean']['output'];
  /** Stop the contest by hiding it from the tenant page — names and votes are kept; launching again shows the same contest (apps/web). */
  stopQueenContest: Scalars['Boolean']['output'];
  toggleQueenVote: Scalars['Boolean']['output'];
  trackUserSeen: Scalars['Boolean']['output'];
  /** Start a HubSpot mirror sync in the background and return its run; a run already in progress is returned instead of starting another (admins only). Poll hubspotSyncRuns for completion. */
  triggerHubspotSync: HubspotSyncRun;
  unlikeBuzz: Scalars['Boolean']['output'];
  unregisterFromEvent: Scalars['Boolean']['output'];
  updateBannerImage: Scalars['Boolean']['output'];
  updateBuzz: Scalars['Boolean']['output'];
  updateCompanyLogo: Scalars['Boolean']['output'];
  /** Save who to contact and where to deliver a building's honey; mirrored onto the current Zuper delivery job's description (apps/web). */
  updateHoneyDeliveryDetails: HoneyDeliveryDetails;
  updateHoneyLabelStatus: Scalars['Boolean']['output'];
  /** Flip a managed page's public-page feature toggles (apps/web). */
  updatePageFeatures: Scalars['Boolean']['output'];
  updatePageGroup: PageGroup;
  /** Replace a managed page's banner or logo image; returns the stored URL (apps/web). */
  updatePageImage: Scalars['String']['output'];
  updatePageManager: Scalars['Boolean']['output'];
  updatePagePreferences: Scalars['Boolean']['output'];
  /** Update a managed page's title, welcome message, link slug or default language (apps/web). */
  updatePageSettings: Scalars['Boolean']['output'];
  updatePageUserContactSettings: PageUserContactSettings;
  updateProfileImage: Scalars['Boolean']['output'];
  updateRegion: Region;
  updateReportSectionTemplate: ReportSectionTemplate;
  updateReportTemplate: ReportTemplate;
  /** Edit one team member's details, contact flags and notification preferences (apps/web). */
  updateTeamMember: Scalars['Boolean']['output'];
  updateUser: Scalars['Boolean']['output'];
  /** Update the viewer's own profile (apps/web). */
  updateViewerProfile: Me;
};


export type MutationAddPageManagerArgs = {
  addPageManagerInput: AddPageManagerInput;
};


export type MutationAddPageSubscriberArgs = {
  input: AddToWaitingListInput;
};


export type MutationAddPagesToGroupArgs = {
  input: AddPagesToGroupInput;
};


export type MutationAddSelfAddedSiteArgs = {
  input: AddSelfAddedSiteInput;
};


export type MutationAddTeamMemberArgs = {
  input: AddTeamMemberInput;
};


export type MutationAddToEventWaitingListArgs = {
  input: AddToWaitingListInput;
};


export type MutationAddToHoneyWaitingListArgs = {
  input: AddToWaitingListInput;
};


export type MutationAddUserToAllGroupPagesArgs = {
  input: AddUserToGroupPagesInput;
};


export type MutationAddUserToAllUserToClonePagesArgs = {
  input: AddUserToUserToClonePagesInput;
};


export type MutationAdminAssignUserToGroupArgs = {
  clearOthers: Scalars['Boolean']['input'];
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminAssignUserToPageArgs = {
  clearOthers: Scalars['Boolean']['input'];
  pageId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminJoinUserPagesArgs = {
  clearOthers: Scalars['Boolean']['input'];
  sourceUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminRemoveUserFromGroupArgs = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminRemoveUserFromPageArgs = {
  pageId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdoptAuraShareLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationApproveHoneyLabelArgs = {
  pageId: Scalars['ID']['input'];
};


export type MutationArchiveAuraChatSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClaimAuraChatSessionsArgs = {
  visitorToken: Scalars['String']['input'];
};


export type MutationClearAllUserPagesArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCreateAuraShareLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  siteIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateAuraVisitorArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBuzzArgs = {
  createBuzzInput: CreateBuzzInput;
};


export type MutationCreateChatSessionArgs = {
  input: CreateChatSessionInput;
};


export type MutationCreateFreeToolSessionArgs = {
  input: CreateFreeToolSessionInput;
};


export type MutationCreateFreeToolShareSessionArgs = {
  freeToolUseSessionId: Scalars['String']['input'];
};


export type MutationCreateLinkedInShareSessionArgs = {
  input: CreateLinkedInShareInput;
};


export type MutationCreatePageGroupArgs = {
  input: CreatePageGroupInput;
};


export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};


export type MutationCreateReportSectionTemplateArgs = {
  input: CreateReportSectionTemplateInput;
};


export type MutationCreateReportTemplateArgs = {
  input: CreateReportTemplateInput;
};


export type MutationCreateThreebeeSiteArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCrownQueenCandidateArgs = {
  input: CrownQueenCandidateInput;
};


export type MutationCrownQueenContestWinnerArgs = {
  candidateId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
};


export type MutationDeletePageGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRegionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteReportSectionTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteReportTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationEmailAttendeesArgs = {
  input: EmailAttendeesInput;
};


export type MutationGenerateAuraFreeReportArgs = {
  input: GenerateAuraFreeReportInput;
};


export type MutationGenerateAuraReportArgs = {
  input: GenerateAuraReportInput;
};


export type MutationGenerateFreeToolReportArgs = {
  freeToolUseSessionId: Scalars['String']['input'];
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  landCoverImage?: InputMaybe<Scalars['Upload']['input']>;
  protectedAreasImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationGenerateReportArgs = {
  input: CreateReportInput;
};


export type MutationGenerateReportFromTemplateArgs = {
  input: GenerateReportInput;
};


export type MutationGetOrCreateMeadowSiteForPageArgs = {
  pageId: Scalars['ID']['input'];
};


export type MutationHivePageAssignSelfArgs = {
  pageId: Scalars['String']['input'];
};


export type MutationHivePageAssignSelfOnlyArgs = {
  pageId: Scalars['String']['input'];
};


export type MutationHivePageCreateBuzzArgs = {
  input: HivePageCreateBuzzInput;
};


export type MutationHivePageDeleteBuzzArgs = {
  buzzId: Scalars['String']['input'];
};


export type MutationHivePageInviteColleagueArgs = {
  input: HivePageInviteInput;
};


export type MutationHivePageJoinEventInterestArgs = {
  input: HivePageListInput;
};


export type MutationHivePageJoinHoneyInterestArgs = {
  input: HivePageListInput;
};


export type MutationHivePageJoinManagerPagesArgs = {
  clearOthers: Scalars['Boolean']['input'];
  pageId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationHivePageLikeBuzzArgs = {
  buzzId: Scalars['String']['input'];
  liked: Scalars['Boolean']['input'];
};


export type MutationHivePageNominateQueenNameArgs = {
  input: HivePageNominateInput;
};


export type MutationHivePageRegisterForEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationHivePageSubscribeArgs = {
  input: HivePageListInput;
};


export type MutationHivePageToggleQueenVoteArgs = {
  candidateId: Scalars['String']['input'];
};


export type MutationHivePageUnregisterFromEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationHivePageUpdateBuzzArgs = {
  input: HivePageUpdateBuzzInput;
};


export type MutationInviteTenantsToEventArgs = {
  input: InviteTenantsToEventInput;
};


export type MutationLaunchQueenContestArgs = {
  input: LaunchQueenContestInput;
};


export type MutationLikeBuzzArgs = {
  id: Scalars['String']['input'];
};


export type MutationMessageEventAttendeesArgs = {
  input: MessageEventAttendeesInput;
};


export type MutationNominateQueenNameArgs = {
  input: NominateQueenNameInput;
};


export type MutationPublishReportSectionTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationRegisterForEventArgs = {
  input: RegisterEventInput;
};


export type MutationRegisterKioskAttendeesArgs = {
  input: RegisterKioskAttendeesInput;
};


export type MutationRemoveBuzzArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemovePageFromGroupArgs = {
  input: RemovePageFromGroupInput;
};


export type MutationRemovePageManagerArgs = {
  pageId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveSelfAddedSiteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


export type MutationRemoveUserFromAllGroupPagesArgs = {
  input: AddUserToGroupPagesInput;
};


export type MutationRemoveUserFromAllUserToClonePagesArgs = {
  input: AddUserToUserToClonePagesInput;
};


export type MutationRenameAuraChatSessionArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationRequestWorkshopArgs = {
  input: RequestWorkshopInput;
};


export type MutationResendInviteEmailArgs = {
  email: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


export type MutationRevertDraftToLiveArgs = {
  id: Scalars['String']['input'];
};


export type MutationScanHandwrittenContactsArgs = {
  input: ScanHandwrittenSubsInput;
};


export type MutationSendChatMessageStreamingArgs = {
  input: SendMessageInput;
};


export type MutationSendFreeChatMessageStreamingArgs = {
  input: SendFreeChatMessageStreamingInput;
};


export type MutationSendFreeToolReportEmailArgs = {
  assetAddress: Scalars['String']['input'];
  email: Scalars['String']['input'];
  reportDownloadUrl: Scalars['String']['input'];
};


export type MutationSendShareWithColleagueArgs = {
  input: ShareWithColleagueInput;
};


export type MutationSendShareWithTenantsArgs = {
  input: ShareWithTenantsInput;
};


export type MutationSetAuraVisitorEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSetMeadowSitePolygonArgs = {
  id: Scalars['ID']['input'];
  polygonGeojson?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSetMeadowSiteSensorDataArgs = {
  hasSensorData: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetMeadowSiteThreebeeIdArgs = {
  id: Scalars['ID']['input'];
  threebeeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetMyHiveOnboardingProgressArgs = {
  progress: UpdateMyHiveOnboardingInput;
};


export type MutationSetPageAuraTierArgs = {
  auraTier: AuraTier;
  pageId: Scalars['ID']['input'];
};


export type MutationSetQueenContestDeadlineArgs = {
  input: SetQueenContestDeadlineInput;
};


export type MutationSetQueenContestVotingArgs = {
  enabled: Scalars['Boolean']['input'];
  pageId: Scalars['ID']['input'];
};


export type MutationSetQueenElectionDeadlineArgs = {
  input: SetQueenElectionDeadlineInput;
};


export type MutationSetReportTemplateMembersArgs = {
  input: SetReportTemplateMembersInput;
};


export type MutationShareEventArgs = {
  input: ShareEventInput;
};


export type MutationSharePageWithTenantsArgs = {
  input: SharePageWithTenantsInput;
};


export type MutationStopQueenContestArgs = {
  pageId: Scalars['ID']['input'];
};


export type MutationToggleQueenVoteArgs = {
  candidateId: Scalars['String']['input'];
};


export type MutationUnlikeBuzzArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnregisterFromEventArgs = {
  input: UnregisterEventInput;
};


export type MutationUpdateBannerImageArgs = {
  updateBannerImageInput: UpdateBannerImageInput;
};


export type MutationUpdateBuzzArgs = {
  updateBuzzInput: UpdateBuzzInput;
};


export type MutationUpdateCompanyLogoArgs = {
  updateCompanyLogoInput: UpdateCompanyLogoInput;
};


export type MutationUpdateHoneyDeliveryDetailsArgs = {
  input: UpdateHoneyDeliveryDetailsInput;
};


export type MutationUpdateHoneyLabelStatusArgs = {
  honeyLabelStatusInput: HoneyLabelStatusInput;
};


export type MutationUpdatePageFeaturesArgs = {
  input: UpdatePageFeaturesInput;
};


export type MutationUpdatePageGroupArgs = {
  input: UpdatePageGroupInput;
};


export type MutationUpdatePageImageArgs = {
  input: UpdatePageImageInput;
};


export type MutationUpdatePageManagerArgs = {
  updatePageManagerInput: UpdatePageManagerInput;
};


export type MutationUpdatePagePreferencesArgs = {
  description: Scalars['String']['input'];
  eventInterestEnabled: Scalars['Boolean']['input'];
  eventRegistrationEnabled: Scalars['Boolean']['input'];
  honeyInterestEnabled: Scalars['Boolean']['input'];
  intercomChatBotEnabled: Scalars['Boolean']['input'];
  language: Language;
  pageId: Scalars['String']['input'];
  queenCommunityVotingEnabled: Scalars['Boolean']['input'];
  queenFeatureEnabled: Scalars['Boolean']['input'];
  searchVisibility: SearchVisibility;
  showUpcomingEvents: Scalars['Boolean']['input'];
  showUpcomingVisits: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdatePageSettingsArgs = {
  input: UpdatePageSettingsInput;
};


export type MutationUpdatePageUserContactSettingsArgs = {
  input: UpdatePageUserContactSettingsInput;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProfileImageArgs = {
  updateProfileImageInput: UpdateProfileImageInput;
};


export type MutationUpdateRegionArgs = {
  input: UpdateRegionInput;
};


export type MutationUpdateReportSectionTemplateArgs = {
  input: UpdateReportSectionTemplateInput;
};


export type MutationUpdateReportTemplateArgs = {
  input: UpdateReportTemplateInput;
};


export type MutationUpdateTeamMemberArgs = {
  input: UpdateTeamMemberInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateViewerProfileArgs = {
  input: UpdateViewerProfileInput;
};

export type MyHiveOnboardingProgressEntity = {
  __typename?: 'MyHiveOnboardingProgressEntity';
  activeFlow?: Maybe<Scalars['String']['output']>;
  cohort?: Maybe<OnboardingCohort>;
  completedFlows?: Maybe<Array<Scalars['String']['output']>>;
  contractedWorkshops?: Maybe<Scalars['Int']['output']>;
  numberOfWorkshopsBookedThisYear?: Maybe<Scalars['Int']['output']>;
  seen?: Maybe<Array<Scalars['String']['output']>>;
  sharedPageWithTenantsAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type NestingDataEntity = {
  __typename?: 'NestingDataEntity';
  grass: Scalars['Int']['output'];
  leafPulpSandGrainsLeafDiscs: Scalars['Int']['output'];
  looseLeafPieces: Scalars['Int']['output'];
  lumpyMud: Scalars['Int']['output'];
  masticLeafPulp: Scalars['Int']['output'];
  membranousCellophaneLikeLining: Scalars['Int']['output'];
  mudSomeLeafPulpOrangePollen: Scalars['Int']['output'];
  otherCombination: Scalars['Int']['output'];
  resin: Scalars['Int']['output'];
  smoothMud: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  woolPlantHairs: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type NestingDto = {
  __typename?: 'NestingDto';
  grass: Scalars['Int']['output'];
  leafPulpSandGrainsLeafDiscs: Scalars['Int']['output'];
  looseLeafPieces: Scalars['Int']['output'];
  lumpyMud: Scalars['Int']['output'];
  masticLeafPulp: Scalars['Int']['output'];
  membranousCellophaneLikeLining: Scalars['Int']['output'];
  mudSomeLeafPulpOrangePollen: Scalars['Int']['output'];
  otherCombination: Scalars['Int']['output'];
  resin: Scalars['Int']['output'];
  smoothMud: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  woolPlantHairs: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type NominateQueenNameInput = {
  name: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};

export enum OnboardingCohort {
  EditTitle = 'EDIT_TITLE'
}

export type OutboundLogGroup = {
  __typename?: 'OutboundLogGroup';
  logGroup?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<CommunicationMedium>;
  recipients: Array<OutboundLogRecipient>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  updateContext: UpdateContext;
  updateUuid: Scalars['String']['output'];
};

export type OutboundLogRecipient = {
  __typename?: 'OutboundLogRecipient';
  cioStatus?: Maybe<CustomerIoMessageStatus>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  twilioStatus?: Maybe<TwilioMessageStatus>;
};

export type OwnedPage = {
  __typename?: 'OwnedPage';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  hasBeehives?: Maybe<Scalars['Boolean']['output']>;
  hasBioacoustics: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isChatEnabled: Scalars['Boolean']['output'];
  isReportingEnabled: Scalars['Boolean']['output'];
  postalCode: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  threeBeeSiteId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PageAudienceSummary = {
  __typename?: 'PageAudienceSummary';
  eventInterestCount: Scalars['Float']['output'];
  honeyInterestCount: Scalars['Float']['output'];
  registeredForAnEventCount: Scalars['Float']['output'];
  subscribersCount: Scalars['Float']['output'];
  users: Array<PageAudienceUser>;
};

export type PageAudienceUser = {
  __typename?: 'PageAudienceUser';
  email: Scalars['String']['output'];
  eventStatuses: Array<SubscriberEventStatus>;
  firstName?: Maybe<Scalars['String']['output']>;
  interestedInEvents: Scalars['Boolean']['output'];
  interestedInHoney: Scalars['Boolean']['output'];
  isSubscriber: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type PageData = {
  __typename?: 'PageData';
  assets?: Maybe<Array<CustomerAsset>>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hit25TenantSubscribersAt?: Maybe<Scalars['DateTime']['output']>;
  hiveContactEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastCompletedBeekeepingVisitDate?: Maybe<Scalars['DateTime']['output']>;
  mainContactEmail?: Maybe<Scalars['String']['output']>;
  managerLastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  myHiveUrl?: Maybe<Scalars['String']['output']>;
  nonManagerPageSubscribersCount?: Maybe<Scalars['Int']['output']>;
  numberOfBeeHives?: Maybe<Scalars['Int']['output']>;
  numberOfBeeHivesInstalled?: Maybe<Scalars['Int']['output']>;
  numberOfBeeHomes?: Maybe<Scalars['Int']['output']>;
  numberOfBeeHomesInstalled?: Maybe<Scalars['Int']['output']>;
  numberOfWorkshopsBookedThisYear?: Maybe<Scalars['Int']['output']>;
  numberOfWorkshopsCompletedThisYear?: Maybe<Scalars['Int']['output']>;
  pageManagers?: Maybe<Array<PageManager>>;
  profilePic?: Maybe<Scalars['String']['output']>;
  serviceStatus?: Maybe<ServiceStatus>;
  slugs?: Maybe<Array<Slug>>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  tenantSubCreatedAts?: Maybe<Array<Scalars['DateTime']['output']>>;
  title: Scalars['String']['output'];
  totalCompletedBeekeepingVisitsThisYearCount?: Maybe<Scalars['Int']['output']>;
  totalPageUpdateSubscribersCount?: Maybe<Scalars['Int']['output']>;
  workshopsAllotted?: Maybe<Scalars['Int']['output']>;
  zuperAlveoleRegion?: Maybe<Scalars['String']['output']>;
  zuperCustomerCategory?: Maybe<ZuperCustomerCategory>;
  zuperCustomerName?: Maybe<Scalars['String']['output']>;
  zuperCustomerUid?: Maybe<Scalars['String']['output']>;
  zuperCustomerUrl?: Maybe<Scalars['String']['output']>;
  zuperLastSyncedAt?: Maybe<Scalars['String']['output']>;
  zuperPreferredTechnicianName?: Maybe<Scalars['String']['output']>;
  zuperRegion?: Maybe<Scalars['String']['output']>;
};

export type PageFeatures = {
  __typename?: 'PageFeatures';
  eventInterest: Scalars['Boolean']['output'];
  honeyInterest: Scalars['Boolean']['output'];
  registration: Scalars['Boolean']['output'];
  showEvents: Scalars['Boolean']['output'];
  showVisits: Scalars['Boolean']['output'];
};

export type PageGroup = {
  __typename?: 'PageGroup';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pageIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type PageHome = {
  __typename?: 'PageHome';
  address?: Maybe<Scalars['String']['output']>;
  beekeepingVisits: Array<BeekeepingVisit>;
  buzzes: Array<BuzzGood>;
  chatBotEnabled: Scalars['Boolean']['output'];
  companyLogo?: Maybe<Scalars['String']['output']>;
  contractedWorkshops?: Maybe<Scalars['Int']['output']>;
  country: Scalars['String']['output'];
  coverPic?: Maybe<Scalars['String']['output']>;
  coverPicOriginal?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eventHighlightCard?: Maybe<EventHighlight>;
  eventInterestEnabled: Scalars['Boolean']['output'];
  eventRegistrationEnabled: Scalars['Boolean']['output'];
  eventWaitingList: Array<WaitingListUser>;
  events: Array<Event>;
  hasBioacoustics: Scalars['Boolean']['output'];
  hasRecentPageUpdateSubscribers: Scalars['Boolean']['output'];
  honeyDeliveredBy: Scalars['String']['output'];
  honeyInterestEnabled: Scalars['Boolean']['output'];
  honeyNextHarvest?: Maybe<Scalars['String']['output']>;
  honeyWaitingList: Array<WaitingListUser>;
  id: Scalars['String']['output'];
  intercomChatBotEnabled: Scalars['Boolean']['output'];
  isReportingEnabled: Scalars['Boolean']['output'];
  language: Language;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  numberOfWorkshopsBookedThisYear: Scalars['Int']['output'];
  pageSubscriberEmails: Array<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['String']['output']>;
  profilePicOriginal?: Maybe<Scalars['String']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  queenCommunityVotingEnabled: Scalars['Boolean']['output'];
  queenFeatureEnabled: Scalars['Boolean']['output'];
  searchVisibility: SearchVisibility;
  showUpcomingEvents: Scalars['Boolean']['output'];
  showUpcomingVisits: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  threeBeeSiteId?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalPageUpdateSubscribers: Scalars['Int']['output'];
  yearEndBuzz?: Maybe<BuzzGood>;
  zuperAlveoleRegion?: Maybe<Scalars['String']['output']>;
  zuperCustomerTimezone?: Maybe<Scalars['String']['output']>;
  zuperCustomerUid?: Maybe<Scalars['String']['output']>;
};

/** Which of the page's branding images an upload replaces. */
export enum PageImageKind {
  Banner = 'BANNER',
  Logo = 'LOGO'
}

export type PageManager = {
  __typename?: 'PageManager';
  buzzReminders: Scalars['Boolean']['output'];
  contactRole?: Maybe<ContactRole>;
  email: Scalars['String']['output'];
  emailAddressStatus: EmailAddressStatus;
  firstName: Scalars['String']['output'];
  hiveContact: Scalars['Boolean']['output'];
  jobTitle: Scalars['String']['output'];
  language?: Maybe<Language>;
  lastName: Scalars['String']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  mainContact: Scalars['Boolean']['output'];
  mobilePhone: Scalars['String']['output'];
  page?: Maybe<SearchablePage>;
  pageId: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  phoneNumberVerification?: Maybe<PhoneNumberVerification>;
  role: Role;
  subscriberAlertsOptIn: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  visitReminders: Scalars['Boolean']['output'];
};

export enum PageSubscriberSource {
  AssetBannerSub = 'ASSET_BANNER_SUB',
  EmailSubscribeTile = 'EMAIL_SUBSCRIBE_TILE',
  EventWaitingList = 'EVENT_WAITING_LIST',
  HoneyWaitingList = 'HONEY_WAITING_LIST',
  KioskHandwrittenScan = 'KIOSK_HANDWRITTEN_SCAN',
  KioskManualForm = 'KIOSK_MANUAL_FORM',
  Legacy = 'LEGACY',
  Settings = 'SETTINGS',
  ShareEvent = 'SHARE_EVENT',
  SharePage = 'SHARE_PAGE',
  SignedUpQueenBee = 'SIGNED_UP_QUEEN_BEE',
  SignedUpRegisterEvent = 'SIGNED_UP_REGISTER_EVENT'
}

export type PageUserContactSettings = {
  __typename?: 'PageUserContactSettings';
  buzzReminders: Scalars['Boolean']['output'];
  emailAddressStatus: EmailAddressStatus;
  eventWaitingList: Scalars['Boolean']['output'];
  hiveContact: Scalars['Boolean']['output'];
  isPageManager: Scalars['Boolean']['output'];
  mainContact: Scalars['Boolean']['output'];
  page: PageUserContactSettingsPage;
  subscriberAlertsOptIn?: Maybe<Scalars['Boolean']['output']>;
  visitReminders?: Maybe<Scalars['Boolean']['output']>;
};

export type PageUserContactSettingsPage = {
  __typename?: 'PageUserContactSettingsPage';
  pageId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum PhoneNumberStatus {
  Deliverable = 'DELIVERABLE',
  Invalid = 'INVALID',
  NonSms = 'NON_SMS',
  OptedOut = 'OPTED_OUT',
  Unknown = 'UNKNOWN'
}

export type PhoneNumberVerification = {
  __typename?: 'PhoneNumberVerification';
  lastMessageSentAt?: Maybe<Scalars['DateTime']['output']>;
  smsOptIn: Scalars['Boolean']['output'];
  status: PhoneNumberStatus;
  twilioErrorCode?: Maybe<Scalars['Int']['output']>;
  twilioErrorMessage?: Maybe<Scalars['String']['output']>;
  twilioStatus?: Maybe<TwilioMessageStatus>;
};

export type PortfolioBeekeepingVisit = {
  __typename?: 'PortfolioBeekeepingVisit';
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type PortfolioBuzz = {
  __typename?: 'PortfolioBuzz';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latestImageMedia?: Maybe<BuzzMediaGood>;
  text: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type PortfolioDashboardResponse = {
  __typename?: 'PortfolioDashboardResponse';
  beekeepingVisits: Array<PortfolioBeekeepingVisit>;
  contractedWorkshops?: Maybe<Scalars['Int']['output']>;
  country: Scalars['String']['output'];
  events: Array<PortfolioEvent>;
  honeyHarvests: Array<PortfolioHoneyJob>;
  honeyJars: Array<PortfolioHoneyJob>;
  id: Scalars['String']['output'];
  installations: Array<PortfolioInstallation>;
  lat?: Maybe<Scalars['Float']['output']>;
  latestBuzzes?: Maybe<Array<PortfolioBuzz>>;
  lng?: Maybe<Scalars['Float']['output']>;
  newSubs?: Maybe<Scalars['Int']['output']>;
  numberOfWorkshopsBookedThisYear?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<AlveolePackages>;
  pageManagerName?: Maybe<Scalars['String']['output']>;
  pesticideDownloadUrl?: Maybe<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  tenantSubCount?: Maybe<Scalars['Int']['output']>;
  threeBeeSiteId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  yearEndDownloadUrl?: Maybe<Scalars['String']['output']>;
  zuperCustomerUid?: Maybe<Scalars['String']['output']>;
};

export type PortfolioEvent = {
  __typename?: 'PortfolioEvent';
  endTime: Scalars['String']['output'];
  eventType: EventType;
  id: Scalars['String']['output'];
  registeredCount: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title: LanguageText;
};

export type PortfolioHoneyJob = {
  __typename?: 'PortfolioHoneyJob';
  dueDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: ZuperJobStatus;
  timezone: Scalars['String']['output'];
};

export type PortfolioInstallation = {
  __typename?: 'PortfolioInstallation';
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type PriorityScore = {
  __typename?: 'PriorityScore';
  dependency: PriorityScoreEntity_Dependency_OrLocked;
  /** true if impact_and_state is still generating (its threebee-derived metrics aren't ready) */
  generating: Scalars['Boolean']['output'];
  impactAndState: PriorityScoreEntity_ImpactAndState_OrLocked;
  locationRisk: PriorityScoreCategory;
  score: PriorityScoreEntity_Score_OrLocked;
};

export type PriorityScoreCategory = {
  __typename?: 'PriorityScoreCategory';
  /** true if any metric in this category is still generating */
  generating: Scalars['Boolean']['output'];
  metrics: Array<PriorityScoreMetric>;
  rank?: Maybe<AuraRank>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type PriorityScoreEntity_Dependency_OrLocked = Locked | PriorityScoreCategory;

export type PriorityScoreEntity_ImpactAndState_OrLocked = Locked | PriorityScoreCategory;

export type PriorityScoreEntity_Score_OrLocked = Locked | ScoreValue;

export type PriorityScoreMetric = {
  __typename?: 'PriorityScoreMetric';
  contribution?: Maybe<Scalars['Float']['output']>;
  floored: Scalars['Boolean']['output'];
  /** true while a background-generated metric (land_cover, ecosystem_condition, light_pollution, heat) is still generating */
  generating: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ProcessSitesInput = {
  siteIds: Array<Scalars['String']['input']>;
};

export type ProcessedSitePayload = {
  __typename?: 'ProcessedSitePayload';
  address?: Maybe<Scalars['String']['output']>;
  agriculturalCover?: Maybe<Scalars['Float']['output']>;
  artificialCover?: Maybe<Scalars['Float']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  buildingType: BenchMarkBuildingType;
  cloudCover?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  criticalSpeciesCount?: Maybe<Scalars['Int']['output']>;
  endangeredSpeciesCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  leastConcernSpeciesCount?: Maybe<Scalars['Int']['output']>;
  lng: Scalars['Float']['output'];
  msaLU?: Maybe<Scalars['Float']['output']>;
  naturalCover?: Maybe<Scalars['Float']['output']>;
  nearThreatenedSpeciesCount?: Maybe<Scalars['Int']['output']>;
  pasi?: Maybe<Scalars['Float']['output']>;
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  speciesCount?: Maybe<Scalars['Int']['output']>;
  threatenedSpeciesTotal?: Maybe<Scalars['Int']['output']>;
  vulnerableSpeciesCount?: Maybe<Scalars['Int']['output']>;
  waterCover?: Maybe<Scalars['Float']['output']>;
};

export type ProtectedAreasData = {
  __typename?: 'ProtectedAreasData';
  /** GeoJSON string */
  aoi: Scalars['String']['output'];
  areas: Array<WdpaAreaResult>;
  count: Scalars['Int']['output'];
  pasi: Scalars['Float']['output'];
};

export type QueenCandidateDto = {
  __typename?: 'QueenCandidateDto';
  id: Scalars['String']['output'];
  isMyNomination: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nominatorInitials?: Maybe<Scalars['String']['output']>;
  nominatorOrganization?: Maybe<Scalars['String']['output']>;
  voteCount: Scalars['Int']['output'];
  votedByMe: Scalars['Boolean']['output'];
};

export type QueenCandidateEntry = {
  __typename?: 'QueenCandidateEntry';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nominatedAt: Scalars['DateTime']['output'];
  nominatorEmail: Scalars['String']['output'];
  nominatorName?: Maybe<Scalars['String']['output']>;
  voteCount: Scalars['Int']['output'];
};

/** Where the building's Name-the-Queen contest stands. */
export enum QueenContestState {
  AwaitingWinner = 'AWAITING_WINNER',
  Crowned = 'CROWNED',
  None = 'NONE',
  Open = 'OPEN',
  Running = 'RUNNING'
}

export type QueenElectionDto = {
  __typename?: 'QueenElectionDto';
  candidates: Array<QueenCandidateDto>;
  communityVotingEnabled: Scalars['Boolean']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  hasWinner: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  myNomination?: Maybe<QueenCandidateDto>;
  winner?: Maybe<QueenCandidateDto>;
};

export type QueenPublicWinnerDto = {
  __typename?: 'QueenPublicWinnerDto';
  communityVotingEnabled: Scalars['Boolean']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  hasWinner: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  voteCount?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Open/paid counts and outstanding balance per currency, across every cached invoice (admin only). */
  adminInvoiceStats: AdminInvoiceStats;
  /** Cached invoices, optionally filtered to one page and/or status/provider/page-name search/overdue-only - the invoice dashboard and a page detail view (admin only). First 100, most recent first. */
  adminInvoices: Array<AdminInvoice>;
  /** Every page group with its pages — the admin assign dialog’s group picker (internal roles only). */
  adminPageGroups: Array<AdminPageGroup>;
  /** Pages whose title or slug matches a search — the admin assign dialog (internal roles only). First 50 by title; an empty search lists the first 50. */
  adminPages: Array<AdminPage>;
  adminSitePages: Array<AdminSitePage>;
  /** One account with the pages it manages — the admin hub Users page detail (internal roles only). No userId: the viewer itself ("assign yourself"). */
  adminUser: AdminUserDetail;
  /** Accounts matching a search, optionally one role — the admin hub Users page (apps/web admin-control-hub; internal roles only). First 50, by last name. */
  adminUsers: Array<AdminUser>;
  allActivePages: Array<SearchablePage>;
  /** Facts about the calling actor that the client cannot know. */
  auraActor: AuraActor;
  /** One chat session, if the actor owns it. */
  auraChatSession?: Maybe<AuraChatSession>;
  /** The actor's chat sessions, most recent first. */
  auraChatSessions: Array<AuraChatSession>;
  /** One building's full nature data (apps/web). Pass exactly one of pageId (an Alvéole-managed building), selfAddedSiteId (an address the actor added), or shareToken + shareSiteIndex (a site inside a share link). Null when meadow cannot answer. */
  auraSiteData?: Maybe<AuraData>;
  /** One building's priority score (apps/web). Same args as auraSiteData: pass exactly one of pageId, selfAddedSiteId, or shareToken + shareSiteIndex. Null when meadow cannot answer. */
  auraSiteScore?: Maybe<PriorityScore>;
  bouncingContactPages: Array<BouncingPage>;
  checkMeadowSiteClc: ThreebeeClcCheck;
  clonedUsersInUserOwnedPages: Array<UserToClone>;
  draftPptxDownloadUrl: Scalars['String']['output'];
  /** Get list of benchmark sites for aoi */
  getBenchmarkSitesByAoi: Array<BenchmarkSiteMetricsPayload>;
  /** Get bioacoustics sample data */
  getBioacousticsSampleData: BioacousticsEntity;
  getChatSession: ChatSession;
  getChatSessions: Array<ChatSessionMinified>;
  getCurrentUser: User;
  /** Get eDNA plant detection data for a page */
  getEdnaData: EdnaData;
  /** Get data payload for a free tool site */
  getFreeSiteDataWithBenchmarks: FreeSiteDataPayload;
  getKioskFromZuperJobUid?: Maybe<KioskFromZuperJobUid>;
  /** Get land cover data for a location */
  getLandCover: LandCoverData;
  getMyHiveOnboardingProgress?: Maybe<MyHiveOnboardingProgressEntity>;
  /** Get bioacoustics data for a page */
  getPageBioacousticsData: BioacousticsEntity;
  getPageHoneyLabel?: Maybe<HoneyLabel>;
  /** Find any portfolioIds for which are contained by the input siteId list */
  getThreeBeePortfoliosFromSiteList: Array<Scalars['String']['output']>;
  /** get three bee site info by id */
  getThreeBeeSiteIds: ThreeBeeSiteIds;
  getUserRegisteredEvents: Array<Scalars['String']['output']>;
  groupsForPage: Array<PageGroup>;
  /** The aura dialog's interactive-map payload — WDPA footprints + method rings (apps/web site/:site, fetched on dialog open; heavy geometries stay out of the tile query). */
  hivePageAuraMap?: Maybe<HivePageAuraMap>;
  /** One buzz of the public MyHive page by id — a shared link's target (apps/web site/:site ?buzz=). */
  hivePageBuzz?: Maybe<HivePageBuzz>;
  /** The public MyHive page's buzz stream, paged (apps/web site/:site). */
  hivePageBuzzes: HivePageBuzzStream;
  /** The public MyHive page's hero + share-card data (apps/web site/:site loader) — deliberately slim; sections below the hero have their own queries. */
  hivePageCard?: Maybe<HivePageCard>;
  /** The public MyHive page's upcoming workshops + the flags that decide each card's CTA (apps/web site/:site). */
  hivePageEvents?: Maybe<HivePageEvents>;
  /** Ids of the page's buzzes the signed-in viewer has liked (apps/web site/:site). */
  hivePageLikedBuzzIds: Array<Scalars['String']['output']>;
  /** The building's living nature data, meadow-backed (apps/web site/:site — client-side, slow fan-out). */
  hivePageNature?: Maybe<HivePageNature>;
  /** The public MyHive page's Name-the-Queen facts (apps/web site/:site loader). */
  hivePageQueen?: Maybe<HivePageQueen>;
  /** The signed-in viewer's Name-the-Queen ballot for a page (apps/web site/:site). */
  hivePageQueenBallot?: Maybe<QueenElectionDto>;
  /** A page by slug as Alvéole staff see it — id, title, canonical slug and its managers (apps/web: the tenant page staff door and the property-management pages; internal roles only, separate from the public page payload on purpose). */
  hivePageStaffAccess: HivePageStaffAccess;
  hiveStrength: HiveStrengthDto;
  /** Data-quality findings from the last HubSpot sync, filtered by type, severity, subscription status and a search — the admin hub findings table (admins only). Errors first; `first` caps at 1000, default 200. */
  hubspotFindings: Array<HubspotFinding>;
  /** Counts over the HubSpot mirror and the last successful sync — the admin hub HubSpot page header (admins only). */
  hubspotOverview: HubspotOverview;
  /** The per-SKU entitlements per unit inferred by the last HubSpot sync, most-used SKU first (admins only). */
  hubspotSkuCatalog: Array<HubspotCatalogEntry>;
  /** One HubSpot Service Subscription with its deals, line items, this season, the renewal preview and its findings (admins only). Null when the mirror has no such id. */
  hubspotSubscription?: Maybe<HubspotSubscriptionDetail>;
  /** HubSpot Service Subscriptions matching a search, optionally one effective status and a findings filter — the admin hub HubSpot list (admins only). First 200, by name. */
  hubspotSubscriptions: Array<HubspotSubscription>;
  /** The last ten HubSpot mirror sync runs, newest first (admins only). */
  hubspotSyncRuns: Array<HubspotSyncRun>;
  /** Get intercom token (for fin messenger) */
  intercomToken: Scalars['String']['output'];
  listUsers: Array<User>;
  livePptxDownloadUrl: Scalars['String']['output'];
  /** Viewer root for the rewrite frontend (apps/web). */
  me: Me;
  meadowSiteParcelPolygon: Scalars['JSON']['output'];
  nesting: NestingDto;
  ownedPages: Array<OwnedPage>;
  ownedPagesDashboard: Array<PortfolioDashboardResponse>;
  page: PageHome;
  pageAudienceSummary: PageAudienceSummary;
  pageData: Array<PageData>;
  pageGroup?: Maybe<PageGroup>;
  pageGroups: Array<PageGroup>;
  pageGroupsInUserOwnedPages: Array<PageGroup>;
  pageManagers: Array<PageManager>;
  pageMedia: Array<BuzzMediaGood>;
  pageOutboundLogs: Array<OutboundLogGroup>;
  pageUserContactSettings: PageUserContactSettings;
  pagesInGroup: Array<Scalars['String']['output']>;
  /** Process a selection of benchmark sites by ID */
  processSites: Array<ProcessedSitePayload>;
  queenElection?: Maybe<QueenElectionDto>;
  queenPublicWinner?: Maybe<QueenPublicWinnerDto>;
  regions: Array<Region>;
  /** Get a presigned download URL for a specific report */
  reportDownloadUrl: DownloadUrlResponse;
  reportSectionTemplates: Array<ReportSectionTemplate>;
  reportTemplateSamplePayload: Scalars['JSONObject']['output'];
  reportTemplates: Array<ReportTemplate>;
  /** Get all reports for a portfolio */
  reportsByUser: Array<Report>;
  sayHello: Scalars['String']['output'];
  /** Sites the actor added themselves. */
  selfAddedSites: Array<SelfAddedSite>;
  staffUsers: Array<StaffUser>;
};


export type QueryAdminInvoicesArgs = {
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<InvoicingServiceProvider>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
};


export type QueryAdminPagesArgs = {
  search: Scalars['String']['input'];
};


export type QueryAdminUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminUsersArgs = {
  role?: InputMaybe<Role>;
  search?: InputMaybe<Scalars['String']['input']>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuraChatSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuraChatSessionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuraSiteDataArgs = {
  pageId?: InputMaybe<Scalars['ID']['input']>;
  selfAddedSiteId?: InputMaybe<Scalars['ID']['input']>;
  shareSiteIndex?: InputMaybe<Scalars['Int']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuraSiteScoreArgs = {
  pageId?: InputMaybe<Scalars['ID']['input']>;
  selfAddedSiteId?: InputMaybe<Scalars['ID']['input']>;
  shareSiteIndex?: InputMaybe<Scalars['Int']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckMeadowSiteClcArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClonedUsersInUserOwnedPagesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryDraftPptxDownloadUrlArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetBenchmarkSitesByAoiArgs = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  radius: Scalars['Float']['input'];
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetChatSessionArgs = {
  input: GetChatSessionInput;
};


export type QueryGetEdnaDataArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryGetFreeSiteDataWithBenchmarksArgs = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type QueryGetKioskFromZuperJobUidArgs = {
  zuperJobUid: Scalars['String']['input'];
};


export type QueryGetLandCoverArgs = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  radius?: Scalars['Float']['input'];
};


export type QueryGetMyHiveOnboardingProgressArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryGetPageBioacousticsDataArgs = {
  endDate: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGetPageHoneyLabelArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetThreeBeePortfoliosFromSiteListArgs = {
  siteIds: Array<Scalars['Int']['input']>;
};


export type QueryGetThreeBeeSiteIdsArgs = {
  siteId: Scalars['Int']['input'];
};


export type QueryGroupsForPageArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryHivePageAuraMapArgs = {
  slug: Scalars['String']['input'];
};


export type QueryHivePageBuzzArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryHivePageBuzzesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryHivePageCardArgs = {
  slug: Scalars['String']['input'];
};


export type QueryHivePageEventsArgs = {
  slug: Scalars['String']['input'];
};


export type QueryHivePageLikedBuzzIdsArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryHivePageNatureArgs = {
  slug: Scalars['String']['input'];
};


export type QueryHivePageQueenArgs = {
  slug: Scalars['String']['input'];
};


export type QueryHivePageQueenBallotArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryHivePageStaffAccessArgs = {
  slug: Scalars['String']['input'];
};


export type QueryHiveStrengthArgs = {
  pageId: Scalars['String']['input'];
  windowWeeks?: Scalars['Int']['input'];
};


export type QueryHubspotFindingsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<HubspotIssueSeverity>;
  status?: InputMaybe<HubspotSubscriptionStatus>;
};


export type QueryHubspotSubscriptionArgs = {
  id: Scalars['String']['input'];
};


export type QueryHubspotSubscriptionsArgs = {
  aura?: InputMaybe<HubspotAuraFilter>;
  findings?: InputMaybe<HubspotFindingsFilter>;
  linked?: InputMaybe<HubspotLinkFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<HubspotSubscriptionStatus>;
};


export type QueryIntercomTokenArgs = {
  assetSlug: Scalars['String']['input'];
};


export type QueryListUsersArgs = {
  role?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryLivePptxDownloadUrlArgs = {
  id: Scalars['String']['input'];
};


export type QueryMeadowSiteParcelPolygonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNestingArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryPageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPageAudienceSummaryArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryPageGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryPageManagersArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPageMediaArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPageOutboundLogsArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryPageUserContactSettingsArgs = {
  email: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPagesInGroupArgs = {
  pageGroupId: Scalars['String']['input'];
};


export type QueryProcessSitesArgs = {
  input: ProcessSitesInput;
};


export type QueryQueenElectionArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryQueenPublicWinnerArgs = {
  pageId: Scalars['String']['input'];
};


export type QueryReportDownloadUrlArgs = {
  reportId: Scalars['String']['input'];
};


export type QueryReportTemplateSamplePayloadArgs = {
  reportTemplateId: Scalars['String']['input'];
  sectionVersion?: SectionVersion;
};

export type RecentUpdate = {
  __typename?: 'RecentUpdate';
  authorName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: RecentUpdateKind;
  media: Array<BuzzMediaItem>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  postedAt: Scalars['DateTime']['output'];
  tempC?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** The job a feed buzz reports on (BUZZ = a standalone post). */
export enum RecentUpdateKind {
  Buzz = 'BUZZ',
  Delivery = 'DELIVERY',
  Event = 'EVENT',
  Install = 'INSTALL',
  Visit = 'VISIT'
}

export type Region = {
  __typename?: 'Region';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  territoryLead?: Maybe<RegionTerritoryLead>;
  territoryLeadUserId?: Maybe<Scalars['String']['output']>;
};

export type RegionTerritoryLead = {
  __typename?: 'RegionTerritoryLead';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type RegisterEventInput = {
  visitId: Scalars['String']['input'];
};

export type RegisterKioskAttendeesInput = {
  contacts: Array<KioskRegistrantInput>;
  eventId: Scalars['String']['input'];
  language: Language;
  pageId: Scalars['String']['input'];
  source: PageSubscriberSource;
};

export type RegisteredUser = {
  __typename?: 'RegisteredUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  registrationStatus?: Maybe<EventRegistrationStatus>;
};

export type RemovePageFromGroupInput = {
  pageGroupId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};

export type RemoveTeamMemberInput = {
  pageId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type Report = {
  __typename?: 'Report';
  createdAt: Scalars['DateTime']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileSize: Scalars['Int']['output'];
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  pageIds: Array<Scalars['String']['output']>;
  reportLanguage?: Maybe<Language>;
  reportType: Scalars['String']['output'];
  reportUrl: Scalars['String']['output'];
  requestedByUserId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportSectionTemplate = {
  __typename?: 'ReportSectionTemplate';
  createdAt: Scalars['DateTime']['output'];
  draftUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  liveUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  needsPublish: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  members: Array<ReportTemplateMember>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportTemplateMember = {
  __typename?: 'ReportTemplateMember';
  alternativeSectionTemplate?: Maybe<ReportSectionTemplate>;
  id: Scalars['String']['output'];
  optional: Scalars['Boolean']['output'];
  order: Scalars['Float']['output'];
  sectionTemplate: ReportSectionTemplate;
};

export type ReportTemplateMemberInput = {
  alternativeSectionTemplateId?: InputMaybe<Scalars['String']['input']>;
  optional?: Scalars['Boolean']['input'];
  sectionTemplateId: Scalars['String']['input'];
};

export type RequestWorkshopInput = {
  pageId: Scalars['String']['input'];
  scheduledStartTime: Scalars['String']['input'];
  workshopType: Scalars['String']['input'];
};

export enum Role {
  Admin = 'ADMIN',
  Beekeeper = 'BEEKEEPER',
  Partner = 'PARTNER',
  Staff = 'STAFF',
  User = 'USER'
}

export type ScanHandwrittenSubsInput = {
  /** Image containing handwritten names/emails */
  file: Scalars['Upload']['input'];
  /** Zuper job uid for the kiosk this scan belongs to. */
  zuperJobUid: Scalars['String']['input'];
};

export type ScannedSub = {
  __typename?: 'ScannedSub';
  companyGuess?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ScoreValue = {
  __typename?: 'ScoreValue';
  score?: Maybe<Scalars['Float']['output']>;
};

export enum SearchVisibility {
  Public = 'PUBLIC',
  Unlisted = 'UNLISTED'
}

export type SearchablePage = {
  __typename?: 'SearchablePage';
  id: Scalars['String']['output'];
  profilePic?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  zuperCustomerUid?: Maybe<Scalars['String']['output']>;
};

export enum SectionVersion {
  Draft = 'DRAFT',
  Live = 'LIVE'
}

export type SelfAddedSite = {
  __typename?: 'SelfAddedSite';
  address?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  /** Meadow priority score, tier-gated; null when meadow is down (null is NOT a lock). */
  scores?: Maybe<PriorityScore>;
  tier: AuraTier;
};

export type SendFreeChatMessageStreamingInput = {
  chatSessionId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  uiContext?: InputMaybe<FreeToolUiContext>;
};

export type SendMessageInput = {
  chatId: Scalars['String']['input'];
  content: Scalars['String']['input'];
};

export enum ServiceStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED'
}

export type SetQueenContestDeadlineInput = {
  deadline?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['ID']['input'];
};

export type SetQueenElectionDeadlineInput = {
  deadline?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['String']['input'];
};

export type SetReportTemplateMembersInput = {
  members: Array<ReportTemplateMemberInput>;
  reportTemplateId: Scalars['String']['input'];
};

export type ShareEventInput = {
  language: Language;
  message: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  tenantEmails: Array<Scalars['String']['input']>;
  workshopId: Scalars['String']['input'];
};

export enum ShareFeature {
  Feed = 'FEED',
  QueenElection = 'QUEEN_ELECTION'
}

export type SharePageWithTenantsInput = {
  emails: Array<Scalars['String']['input']>;
  feature?: InputMaybe<ShareFeature>;
  language: Language;
  message: Scalars['String']['input'];
  pageId: Scalars['ID']['input'];
};

export type ShareWithColleagueInput = {
  language: Language;
  pageId: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
};

export type ShareWithTenantsInput = {
  feature: ShareFeature;
  language: Language;
  message: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  tenantEmails: Array<Scalars['String']['input']>;
};

export type SimplePageManager = {
  __typename?: 'SimplePageManager';
  email: Scalars['String']['output'];
  emailAddressStatus: EmailAddressStatus;
  hiveContact: Scalars['Boolean']['output'];
  mainContact: Scalars['Boolean']['output'];
};

export type SiteDetails = {
  __typename?: 'SiteDetails';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type Slug = {
  __typename?: 'Slug';
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SpeciesData = {
  __typename?: 'SpeciesData';
  /** GeoJSON string */
  aoi: Scalars['String']['output'];
  speciesList: Array<SpeciesListItem>;
  summary: SpeciesSummary;
};

export type SpeciesInfo = {
  __typename?: 'SpeciesInfo';
  canonicalName?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  iucn?: Maybe<IucnSpeciesCategory>;
  kingdom?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  phylum?: Maybe<Scalars['String']['output']>;
  scientificName?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  speciesKey: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vernacularName?: Maybe<Scalars['String']['output']>;
};

export type SpeciesListItem = {
  __typename?: 'SpeciesListItem';
  count: Scalars['Int']['output'];
  speciesInfo: SpeciesInfo;
};

export type SpeciesSummary = {
  __typename?: 'SpeciesSummary';
  criticalSpeciesCount: Scalars['Int']['output'];
  endangeredSpeciesCount: Scalars['Int']['output'];
  leastConcernSpeciesCount: Scalars['Int']['output'];
  nearThreatenedSpeciesCount: Scalars['Int']['output'];
  speciesCount: Scalars['Int']['output'];
  threatenedSpeciesTotal: Scalars['Int']['output'];
  vulnerableSpeciesCount: Scalars['Int']['output'];
};

export type StaffUser = {
  __typename?: 'StaffUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type SubScanResponse = {
  __typename?: 'SubScanResponse';
  contacts: Array<ScannedSub>;
  rawText?: Maybe<Scalars['String']['output']>;
};

export type SubscribedPage = {
  __typename?: 'SubscribedPage';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SubscriberEventStatus = {
  __typename?: 'SubscriberEventStatus';
  eventId: Scalars['String']['output'];
  eventStartTime: Scalars['DateTime']['output'];
  eventTitle: Scalars['String']['output'];
  registrationStatus: EventRegistrationStatus;
};

export type Subscription = {
  __typename?: 'Subscription';
  chatStream: ChatStreamEvent;
};


export type SubscriptionChatStreamArgs = {
  chatId: Scalars['String']['input'];
};

export type SurfaceTemperatureData = {
  __typename?: 'SurfaceTemperatureData';
  aoi: Scalars['GeoJSON']['output'];
  aoiTemp?: Maybe<Scalars['Float']['output']>;
  controlArea: Scalars['GeoJSON']['output'];
  controlTemp?: Maybe<Scalars['Float']['output']>;
  generating: Scalars['Boolean']['output'];
  /** Presigned URL to the composite GeoTIFF */
  mapLayerUrl?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<AuraRank>;
  score?: Maybe<Scalars['Float']['output']>;
  tempDelta?: Maybe<Scalars['Float']['output']>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  buzzReminders: Scalars['Boolean']['output'];
  contactRole?: Maybe<ContactRole>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  hiveContact: Scalars['Boolean']['output'];
  language?: Maybe<Language>;
  lastName?: Maybe<Scalars['String']['output']>;
  mainContact: Scalars['Boolean']['output'];
  mobilePhone?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  smsOptIn: Scalars['Boolean']['output'];
  smsStatus?: Maybe<PhoneNumberStatus>;
  staff: Scalars['Boolean']['output'];
  subscriberAlerts: Scalars['Boolean']['output'];
  unreachable: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
  visitReminders: Scalars['Boolean']['output'];
};

export type ThreeBeeSiteIds = {
  __typename?: 'ThreeBeeSiteIds';
  caId?: Maybe<Scalars['String']['output']>;
  polygonId?: Maybe<Scalars['String']['output']>;
  portfolioId?: Maybe<Scalars['String']['output']>;
  roiId?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Float']['output'];
};

export type ThreebeeClcCheck = {
  __typename?: 'ThreebeeClcCheck';
  error?: Maybe<Scalars['String']['output']>;
  stage: ThreebeeClcPipelineStage;
};

export enum ThreebeeClcPipelineStage {
  BackfillingClasses = 'BACKFILLING_CLASSES',
  BuildingRaster = 'BUILDING_RASTER',
  Error = 'ERROR',
  GeneratingKpi = 'GENERATING_KPI',
  GeneratingLayer = 'GENERATING_LAYER',
  Ready = 'READY',
  ResolvingPolygon = 'RESOLVING_POLYGON'
}

export type ThreebeeLandUseSummary = {
  __typename?: 'ThreebeeLandUseSummary';
  agricultural?: Maybe<Scalars['Float']['output']>;
  agriculturalHa?: Maybe<Scalars['Float']['output']>;
  artificial?: Maybe<Scalars['Float']['output']>;
  artificialHa?: Maybe<Scalars['Float']['output']>;
  freshwater?: Maybe<Scalars['Float']['output']>;
  freshwaterHa?: Maybe<Scalars['Float']['output']>;
  natural?: Maybe<Scalars['Float']['output']>;
  naturalHa?: Maybe<Scalars['Float']['output']>;
  roads?: Maybe<Scalars['Float']['output']>;
  roadsHa?: Maybe<Scalars['Float']['output']>;
  saltwater?: Maybe<Scalars['Float']['output']>;
  saltwaterHa?: Maybe<Scalars['Float']['output']>;
};

export enum TwilioMessageStatus {
  Accepted = 'accepted',
  Delivered = 'delivered',
  Failed = 'failed',
  Queued = 'queued',
  Sending = 'sending',
  Sent = 'sent',
  Undelivered = 'undelivered'
}

export type UnreachableContacts = {
  __typename?: 'UnreachableContacts';
  anyPrimary: Scalars['Boolean']['output'];
  count: Scalars['Int']['output'];
};

export type UnregisterEventInput = {
  visitId: Scalars['String']['input'];
};

export type UpcomingEvent = {
  __typename?: 'UpcomingEvent';
  attendees: Array<EventAttendee>;
  capacity: Scalars['Int']['output'];
  description: LanguageText;
  id: Scalars['ID']['output'];
  imageKey: Scalars['String']['output'];
  kiosk: Scalars['Boolean']['output'];
  startsAt: Scalars['DateTime']['output'];
  /** PENDING = booked, awaiting confirmation from Alvéole; CONFIRMED = a beekeeper is scheduled. */
  status: UpcomingEventStatus;
  timeZone?: Maybe<Scalars['String']['output']>;
  title: LanguageText;
};

/** PENDING = booked, awaiting confirmation from Alvéole (Zuper NEW); CONFIRMED = a beekeeper is scheduled. */
export enum UpcomingEventStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export type UpcomingVisit = {
  __typename?: 'UpcomingVisit';
  address?: Maybe<Scalars['String']['output']>;
  beekeeper?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: UpcomingVisitKind;
  startsAt: Scalars['DateTime']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
};

/** Field-work label: a beekeeping visit (incl. relocations) or an installation. */
export enum UpcomingVisitKind {
  Install = 'INSTALL',
  Visit = 'VISIT'
}

export type UpdateBannerImageInput = {
  /** cropped banner image */
  bannerImageFile: Scalars['Upload']['input'];
  /** original full banner image when user selected a new image */
  bannerOriginalImageFile?: InputMaybe<Scalars['Upload']['input']>;
  /** page to update */
  pageId: Scalars['String']['input'];
};

export type UpdateBuzzInput = {
  /** IDs of existing media to keep, in desired order */
  existingMediaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  /** new media files to add */
  newMedia?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** buzz text */
  text: Scalars['String']['input'];
};

export type UpdateCompanyLogoInput = {
  /** company logo image */
  companyLogoFile: Scalars['Upload']['input'];
  /** page to update */
  pageId: Scalars['String']['input'];
};

export enum UpdateContext {
  AddManagedPage = 'ADD_MANAGED_PAGE',
  AddPageGroup = 'ADD_PAGE_GROUP',
  AddSubscriber = 'ADD_SUBSCRIBER',
  RemoveSubscriber = 'REMOVE_SUBSCRIBER',
  UpdateBuzz = 'UPDATE_BUZZ',
  UpdateEvents = 'UPDATE_EVENTS',
  UpdateHoneyHarvest = 'UPDATE_HONEY_HARVEST',
  UpdateHoneyJars = 'UPDATE_HONEY_JARS',
  UpdatePageManager = 'UPDATE_PAGE_MANAGER',
  UpdatePagePreferences = 'UPDATE_PAGE_PREFERENCES',
  UpdateQueenElection = 'UPDATE_QUEEN_ELECTION',
  UpdateUser = 'UPDATE_USER',
  UpdateVisit = 'UPDATE_VISIT',
  ZuperSms = 'ZUPER_SMS',
  ZuperSync = 'ZUPER_SYNC'
}

export type UpdateHoneyDeliveryDetailsInput = {
  contactFirstName: Scalars['String']['input'];
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactPhone: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['ID']['input'];
  streetAddress: Scalars['String']['input'];
};

export type UpdateMyHiveOnboardingInput = {
  activeFlow?: InputMaybe<Scalars['String']['input']>;
  cohort?: InputMaybe<OnboardingCohort>;
  completedFlows?: InputMaybe<Array<Scalars['String']['input']>>;
  seen?: InputMaybe<Array<Scalars['String']['input']>>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageFeaturesInput = {
  eventInterest?: InputMaybe<Scalars['Boolean']['input']>;
  honeyInterest?: InputMaybe<Scalars['Boolean']['input']>;
  pageId: Scalars['ID']['input'];
  registration?: InputMaybe<Scalars['Boolean']['input']>;
  showEvents?: InputMaybe<Scalars['Boolean']['input']>;
  showVisits?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePageGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageImageInput = {
  imageFile: Scalars['Upload']['input'];
  kind: PageImageKind;
  pageId: Scalars['ID']['input'];
};

export type UpdatePageManagerInput = {
  /** Indicates if buzz reminders are enabled */
  buzzReminders: Scalars['Boolean']['input'];
  /** Indicates if the page manager is the hive contact */
  hiveContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the page manager is the main contact */
  mainContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** page id of the page manager */
  pageId: Scalars['String']['input'];
  /** Indicates if the user is opted in to SMS */
  smsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if subscriber alerts are opted in */
  subscriberAlertsOptIn: Scalars['Boolean']['input'];
  /** user id of the page manager */
  userId: Scalars['String']['input'];
  /** Indicates if visit reminders are enabled */
  visitReminders: Scalars['Boolean']['input'];
};

export type UpdatePageSettingsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  pageId: Scalars['ID']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageUserContactSettingsInput = {
  buzzReminders?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  eventWaitingList?: InputMaybe<Scalars['Boolean']['input']>;
  pageId: Scalars['String']['input'];
  subscriberAlertsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  visitReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProfileImageInput = {
  /** page to update */
  pageId: Scalars['String']['input'];
  /** cropped profile image */
  profileImageFile: Scalars['Upload']['input'];
  /** original full profile image when user selected a new image */
  profileOriginalImageFile?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateRegionInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  territoryLeadUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportSectionTemplateInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateReportTemplateInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTeamMemberInput = {
  buzzReminders: Scalars['Boolean']['input'];
  contactRole?: InputMaybe<ContactRole>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hiveContact?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mainContact?: InputMaybe<Scalars['Boolean']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  subscriberAlerts: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
  visitReminders: Scalars['Boolean']['input'];
};

export type UpdateUserInput = {
  /** avatar image file  */
  avatarImageFile?: InputMaybe<Scalars['Upload']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  contactRole?: InputMaybe<ContactRole>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  reportingOnboard?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  role?: InputMaybe<Role>;
  slackMemberId?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateViewerProfileInput = {
  avatarImageFile?: InputMaybe<Scalars['Upload']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  auth0Id?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  contactRole?: Maybe<ContactRole>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Language>;
  lastName: Scalars['String']['output'];
  managedPages?: Maybe<Array<PageManager>>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  portfolioId?: Maybe<Scalars['String']['output']>;
  reportingOnboard?: Maybe<Array<Scalars['JSONObject']['output']>>;
  role: Role;
  slackMemberId?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserToClone = {
  __typename?: 'UserToClone';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  pageIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type WaitingListUser = {
  __typename?: 'WaitingListUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type WaterStressData = {
  __typename?: 'WaterStressData';
  rank: AuraRank;
  score: Scalars['Float']['output'];
};

export type WdpaAreaResult = {
  __typename?: 'WdpaAreaResult';
  designation: Scalars['String']['output'];
  distance: Scalars['Float']['output'];
  /** GeoJSON string */
  geometry: Scalars['String']['output'];
  intersectArea: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  sitePid: Scalars['String']['output'];
};

export enum ZuperCustomerCategory {
  AlveoleClient = 'ALVEOLE_CLIENT',
  FakeClient = 'FAKE_CLIENT',
  General = 'GENERAL',
  OneTimeClient = 'ONE_TIME_CLIENT',
  Yard = 'YARD'
}

export enum ZuperJobStatus {
  Canceled = 'CANCELED',
  CannotComplete = 'CANNOT_COMPLETE',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Failed = 'FAILED',
  FollowUp = 'FOLLOW_UP',
  FollowUpSameJob = 'FOLLOW_UP_SAME_JOB',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  OnMyWay = 'ON_MY_WAY',
  Other = 'OTHER',
  Others = 'OTHERS',
  Paid = 'PAID',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED'
}

export type GetHiveStrengthQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
  windowWeeks?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHiveStrengthQuery = { __typename?: 'Query', hiveStrength: { __typename?: 'HiveStrengthDto', windowWeeks: number, pointCount: number, timeline: Array<{ __typename?: 'HiveStrengthPointDto', date: string, beeFrames?: number | null, honeyFrames?: number | null, broodFrames?: number | null, state: HiveStrengthState, trendPercent?: number | null, showNectarFlow: boolean, queenSpotted: boolean, isHarvest: boolean }> } };

export type GetBioacousticsSampleDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBioacousticsSampleDataQuery = { __typename?: 'Query', getBioacousticsSampleData: { __typename?: 'BioacousticsEntity', siteDetails: { __typename?: 'SiteDetails', name: string, latitude: number, longitude: number }, hourlyPollinatorObservations: Array<{ __typename?: 'HourlyObservation', date: string, hour: number, count: number, hz: string }>, dailyPollinatorData: Array<{ __typename?: 'DailyBioacousticsData', date: string, meanBuzzPerHour: number, weatherData: { __typename?: 'DailyWeatherData', meanTemp: number, totalPrecip: number } }>, buzzDetections: Array<{ __typename?: 'BuzzDetection', audioUrl: string, dateTime: string, hz: string }>, birdObservations: Array<{ __typename?: 'BirdObservation', latinTaxa: string, commonName?: string | null, imgUrl?: string | null, dateTime: string, audioClip: string }> } };

export type GetPageBioacousticsDataQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetPageBioacousticsDataQuery = { __typename?: 'Query', getPageBioacousticsData: { __typename?: 'BioacousticsEntity', siteDetails: { __typename?: 'SiteDetails', name: string, latitude: number, longitude: number }, hourlyPollinatorObservations: Array<{ __typename?: 'HourlyObservation', date: string, hour: number, count: number, hz: string }>, dailyPollinatorData: Array<{ __typename?: 'DailyBioacousticsData', date: string, meanBuzzPerHour: number, weatherData: { __typename?: 'DailyWeatherData', meanTemp: number, totalPrecip: number } }>, buzzDetections: Array<{ __typename?: 'BuzzDetection', audioUrl: string, dateTime: string, hz: string }>, birdObservations: Array<{ __typename?: 'BirdObservation', latinTaxa: string, commonName?: string | null, imgUrl?: string | null, dateTime: string, audioClip: string }> } };

export type CreateBuzzMutationVariables = Exact<{
  input: CreateBuzzInput;
}>;


export type CreateBuzzMutation = { __typename?: 'Mutation', createBuzz: boolean };

export type RemoveBuzzMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveBuzzMutation = { __typename?: 'Mutation', removeBuzz: boolean };

export type UpdateBuzzMutationVariables = Exact<{
  updateBuzzInput: UpdateBuzzInput;
}>;


export type UpdateBuzzMutation = { __typename?: 'Mutation', updateBuzz: boolean };

export type LikeBuzzMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LikeBuzzMutation = { __typename?: 'Mutation', likeBuzz: boolean };

export type UnlikeBuzzMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UnlikeBuzzMutation = { __typename?: 'Mutation', unlikeBuzz: boolean };

export type GetChatSessionQueryVariables = Exact<{
  input: GetChatSessionInput;
}>;


export type GetChatSessionQuery = { __typename?: 'Query', getChatSession: { __typename?: 'ChatSession', id: string, messages: Array<{ __typename?: 'ChatMessage', id: string, role: MessageRole, content: string, createdAt: string }> } };

export type GetChatSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChatSessionsQuery = { __typename?: 'Query', getChatSessions: Array<{ __typename?: 'ChatSessionMinified', id: string, lastMessageDate: string, title?: string | null }> };

export type CreateChatSessionMutationVariables = Exact<{
  input: CreateChatSessionInput;
}>;


export type CreateChatSessionMutation = { __typename?: 'Mutation', createChatSession: string };

export type SendChatMessageStreamingMutationVariables = Exact<{
  input: SendMessageInput;
}>;


export type SendChatMessageStreamingMutation = { __typename?: 'Mutation', sendChatMessageStreaming: boolean };

export type ChatStreamSubscriptionVariables = Exact<{
  chatId: Scalars['String']['input'];
}>;


export type ChatStreamSubscription = { __typename?: 'Subscription', chatStream: { __typename?: 'ChatStreamEvent', chatId: string, type: ChatStreamEventType, content?: string | null, toolName?: string | null } };

export type GetEdnaDataQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type GetEdnaDataQuery = { __typename?: 'Query', getEdnaData: { __typename?: 'EdnaData', year: number, totalUniqueHits: number, totalHits: number, pageTitle: string, pageCity: string, detections: Array<{ __typename?: 'EdnaPlantDetection', count: number, commonNameEn: string, commonNameFr: string, latinTaxon: string, growthHabit: string, iucnStatus: string, imgUrl: string }> } };

export type ShareEventMutationVariables = Exact<{
  input: ShareEventInput;
}>;


export type ShareEventMutation = { __typename?: 'Mutation', shareEvent: boolean };

export type EmailAttendeesMutationVariables = Exact<{
  input: EmailAttendeesInput;
}>;


export type EmailAttendeesMutation = { __typename?: 'Mutation', emailAttendees: boolean };

export type RequestWorkshopMutationVariables = Exact<{
  input: RequestWorkshopInput;
}>;


export type RequestWorkshopMutation = { __typename?: 'Mutation', requestWorkshop: boolean };

export type ProcessSitesQueryVariables = Exact<{
  input: ProcessSitesInput;
}>;


export type ProcessSitesQuery = { __typename?: 'Query', processSites: Array<{ __typename?: 'ProcessedSitePayload', id: string, rank: number, score: number, lat: number, lng: number, buildingType: BenchMarkBuildingType, country?: string | null, address?: string | null, buildingName?: string | null, pasi?: number | null, naturalCover?: number | null, agriculturalCover?: number | null, artificialCover?: number | null, waterCover?: number | null, cloudCover?: number | null, msaLU?: number | null, speciesCount?: number | null, criticalSpeciesCount?: number | null, endangeredSpeciesCount?: number | null, vulnerableSpeciesCount?: number | null, nearThreatenedSpeciesCount?: number | null, leastConcernSpeciesCount?: number | null, threatenedSpeciesTotal?: number | null }> };

export type GetBenchmarkSitesByAoiQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  radius: Scalars['Float']['input'];
  sources?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetBenchmarkSitesByAoiQuery = { __typename?: 'Query', getBenchmarkSitesByAoi: Array<{ __typename?: 'BenchmarkSiteMetricsPayload', id: string, lat: number, lng: number, buildingType: BenchMarkBuildingType, country?: string | null, address?: string | null, buildingName?: string | null, distance: number, pasi?: number | null, naturalCover?: number | null, agriculturalCover?: number | null, artificialCover?: number | null, waterCover?: number | null, cloudCover?: number | null, msaLU?: number | null, speciesCount?: number | null, criticalSpeciesCount?: number | null, endangeredSpeciesCount?: number | null, vulnerableSpeciesCount?: number | null, nearThreatenedSpeciesCount?: number | null, leastConcernSpeciesCount?: number | null, threatenedSpeciesTotal?: number | null }> };

export type GetFreeSiteDataWithBenchmarksQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
}>;


export type GetFreeSiteDataWithBenchmarksQuery = { __typename?: 'Query', getFreeSiteDataWithBenchmarks: { __typename?: 'FreeSiteDataPayload', lng: number, lat: number, benchmarks: { __typename?: 'FreeToolBenchmarks', impactScore: number, riskScore: number, pasiRaw: { __typename?: 'BenchMarkRaw', percentileScore: number }, threatenedSpeciesRaw: { __typename?: 'BenchMarkRaw', percentileScore: number }, msaRaw: { __typename?: 'BenchMarkRaw', percentileScore: number, value: number, sampleMean?: number | null, sampleStd?: number | null, zScore?: number | null }, naturalCoverRaw: { __typename?: 'BenchMarkRaw', percentileScore: number } }, landCoverData: { __typename?: 'LandCoverData', sources: Array<string>, tiff: string, aoi: string, summary: { __typename?: 'LandCoverSummary', agriculturalCover: number, artificialCover: number, naturalCover: number, waterCover: number, cloudCover: number, msaLU: number } }, protectedAreasData: { __typename?: 'ProtectedAreasData', count: number, pasi: number, aoi: string, areas: Array<{ __typename?: 'WdpaAreaResult', sitePid: string, designation: string, geometry: string, distance: number, intersectArea: number, name: string }> }, speciesData: { __typename?: 'SpeciesData', aoi: string, speciesList: Array<{ __typename?: 'SpeciesListItem', count: number, speciesInfo: { __typename?: 'SpeciesInfo', canonicalName?: string | null, iucn?: IucnSpeciesCategory | null, vernacularName?: string | null, scientificName?: string | null } }>, summary: { __typename?: 'SpeciesSummary', criticalSpeciesCount: number, endangeredSpeciesCount: number, leastConcernSpeciesCount: number, nearThreatenedSpeciesCount: number, speciesCount: number, threatenedSpeciesTotal: number, vulnerableSpeciesCount: number } } } };

export type CreateFreeToolSessionMutationVariables = Exact<{
  sites: Array<FreeToolSiteInput> | FreeToolSiteInput;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFreeToolSessionMutation = { __typename?: 'Mutation', createFreeToolSession: { __typename?: 'FreeToolUseSession', id: string, email?: string | null, chatSessionId: string, sites: Array<{ __typename?: 'FreeToolSite', id: string, address: string, lat: number, lng: number }> } };

export type CreateFreeToolShareSessionMutationVariables = Exact<{
  freeToolUseSessionId: Scalars['String']['input'];
}>;


export type CreateFreeToolShareSessionMutation = { __typename?: 'Mutation', createFreeToolShareSession?: { __typename?: 'FreeToolUseSession', id: string, email?: string | null, chatSessionId: string, sites: Array<{ __typename?: 'FreeToolSite', id: string, address: string, lat: number, lng: number }> } | null };

export type SendFreeChatMessageStreamingMutationVariables = Exact<{
  chatSessionId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  uiContext?: InputMaybe<FreeToolUiContext>;
}>;


export type SendFreeChatMessageStreamingMutation = { __typename?: 'Mutation', sendFreeChatMessageStreaming: boolean };

export type GetIntercomTokenQueryVariables = Exact<{
  assetSlug: Scalars['String']['input'];
}>;


export type GetIntercomTokenQuery = { __typename?: 'Query', intercomToken: string };

export type CreateLinkedInShareInputMutationVariables = Exact<{
  input: CreateLinkedInShareInput;
}>;


export type CreateLinkedInShareInputMutation = { __typename?: 'Mutation', createLinkedInShareSession: { __typename?: 'LinkedInShareSessionResponse', redirectUrl: string } };

export type GetNestingQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type GetNestingQuery = { __typename?: 'Query', nesting: { __typename?: 'NestingDto', year: number, total: number, lumpyMud: number, smoothMud: number, masticLeafPulp: number, woolPlantHairs: number, grass: number, looseLeafPieces: number, resin: number, membranousCellophaneLikeLining: number, leafPulpSandGrainsLeafDiscs: number, mudSomeLeafPulpOrangePollen: number, otherCombination: number } };

export type ListOwnedPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOwnedPagesQuery = { __typename?: 'Query', ownedPages: Array<{ __typename?: 'OwnedPage', id: string, title: string, streetAddress: string, city: string, postalCode: string, country: string, slug?: string | null, isReportingEnabled: boolean, isChatEnabled: boolean, threeBeeSiteId?: string | null, hasBeehives?: boolean | null, hasBioacoustics: boolean }> };

export type ListBouncingContactPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBouncingContactPagesQuery = { __typename?: 'Query', bouncingContactPages: Array<{ __typename?: 'BouncingPage', id: string, title: string, slug?: string | null, zuperCustomerUid?: string | null, zuperHubspotCustomerId?: string | null, region?: string | null, pageManagers: Array<{ __typename?: 'SimplePageManager', email: string, emailAddressStatus: EmailAddressStatus, mainContact: boolean, hiveContact: boolean }> }> };

export type ListAllActivePagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllActivePagesQuery = { __typename?: 'Query', allActivePages: Array<{ __typename?: 'SearchablePage', id: string, title: string, slug?: string | null, profilePic?: string | null, streetAddress?: string | null }> };

export type ListPagesDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPagesDataQuery = { __typename?: 'Query', pageData: Array<{ __typename?: 'PageData', id: string, title: string, myHiveUrl?: string | null, profilePic?: string | null, streetAddress?: string | null, city?: string | null, nonManagerPageSubscribersCount?: number | null, totalPageUpdateSubscribersCount?: number | null, tenantSubCreatedAts?: Array<string> | null, managerLastSeenAt?: string | null, zuperCustomerUid?: string | null, zuperRegion?: string | null, zuperCustomerUrl?: string | null, zuperCustomerName?: string | null, zuperLastSyncedAt?: string | null, mainContactEmail?: string | null, zuperAlveoleRegion?: string | null, zuperPreferredTechnicianName?: string | null, numberOfBeeHives?: number | null, numberOfBeeHomes?: number | null, numberOfBeeHivesInstalled?: number | null, numberOfBeeHomesInstalled?: number | null, hit25TenantSubscribersAt?: string | null, zuperCustomerCategory?: ZuperCustomerCategory | null, serviceStatus?: ServiceStatus | null, lastCompletedBeekeepingVisitDate?: string | null, totalCompletedBeekeepingVisitsThisYearCount?: number | null, numberOfWorkshopsCompletedThisYear?: number | null, numberOfWorkshopsBookedThisYear?: number | null, workshopsAllotted?: number | null, createdAt?: string | null, slugs?: Array<{ __typename?: 'Slug', slug: string, updatedAt: string }> | null, pageManagers?: Array<{ __typename?: 'PageManager', role: Role, email: string, mainContact: boolean }> | null, assets?: Array<{ __typename?: 'CustomerAsset', id: string, hiveHealth?: string | null, createdAt: string, updatedAt: string, pageId: string, assetCategory?: CustomerAssetCategory | null, assetStatus?: CustomerAssetStatus | null }> | null }> };

export type GetPageOutboundLogsQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type GetPageOutboundLogsQuery = { __typename?: 'Query', pageOutboundLogs: Array<{ __typename?: 'OutboundLogGroup', updateUuid: string, updateContext: UpdateContext, logGroup?: string | null, sentAt?: string | null, medium?: CommunicationMedium | null, recipients: Array<{ __typename?: 'OutboundLogRecipient', recipient: string, firstName?: string | null, lastName?: string | null, twilioStatus?: TwilioMessageStatus | null, cioStatus?: CustomerIoMessageStatus | null }> }> };

export type GetPageHomeQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageHomeQuery = { __typename?: 'Query', page: { __typename?: 'PageHome', id: string, title: string, description: string, threeBeeSiteId?: string | null, language: Language, searchVisibility: SearchVisibility, slug: string, country: string, profilePic?: string | null, profilePicOriginal?: string | null, coverPic?: string | null, coverPicOriginal?: string | null, companyLogo?: string | null, isReportingEnabled: boolean, chatBotEnabled: boolean, intercomChatBotEnabled: boolean, totalPageUpdateSubscribers: number, hasRecentPageUpdateSubscribers: boolean, honeyDeliveredBy: string, honeyNextHarvest?: string | null, zuperCustomerUid?: string | null, lat?: number | null, lng?: number | null, address?: string | null, pageSubscriberEmails: Array<string>, eventInterestEnabled: boolean, honeyInterestEnabled: boolean, eventRegistrationEnabled: boolean, showUpcomingEvents: boolean, showUpcomingVisits: boolean, queenFeatureEnabled: boolean, queenCommunityVotingEnabled: boolean, zuperCustomerTimezone?: string | null, zuperAlveoleRegion?: string | null, numberOfWorkshopsBookedThisYear: number, contractedWorkshops?: number | null, hasBioacoustics: boolean, events: Array<{ __typename?: 'Event', id: string, timezone: string, startTime: string, endTime: string, eventType: EventType, beekeeperFirstName: string, beekeeperLastName: string, registeredCount: number, capacity?: number | null, imageFilename?: string | null, zuperJobUid: string, registeredUsers: Array<{ __typename?: 'RegisteredUser', id: string, email: string, firstName?: string | null, lastName?: string | null, organizationName?: string | null, registrationStatus?: EventRegistrationStatus | null }>, title: { __typename?: 'LanguageText', en: string, fr: string }, description: { __typename?: 'LanguageText', en: string, fr: string } }>, beekeepingVisits: Array<{ __typename?: 'BeekeepingVisit', id: string, timezone: string, startTime: string, endTime: string, beekeeperFirstName: string, beekeeperLastName: string, title: { __typename?: 'LanguageText', en: string, fr: string } }>, buzzes: Array<{ __typename?: 'BuzzGOOD', id: string, authorId: string, beekeeperFirstName: string, beekeeperLastName: string, beekeeperTagline: string, beekeeperAvatarUrl?: string | null, likedByMe: boolean, totalLikes: number, text: string, weatherDescription?: string | null, weatherTempCelsius?: string | null, city: string, createdAt: string, isYearEnd?: boolean | null, media: Array<{ __typename?: 'BuzzMediaGOOD', id?: string | null, fileUrl: string, mimeType: string, buzzId?: string | null }> }>, yearEndBuzz?: { __typename?: 'BuzzGOOD', id: string, text: string, likedByMe: boolean, totalLikes: number, createdAt: string, media: Array<{ __typename?: 'BuzzMediaGOOD', id?: string | null, fileUrl: string, mimeType: string }> } | null, eventWaitingList: Array<{ __typename?: 'WaitingListUser', id: string, email: string, firstName?: string | null, lastName?: string | null, organizationName?: string | null }>, honeyWaitingList: Array<{ __typename?: 'WaitingListUser', id: string, email: string, firstName?: string | null, lastName?: string | null, organizationName?: string | null }>, eventHighlightCard?: { __typename?: 'EventHighlight', buzzId: string, buzzText: string, mediaPath?: string | null, eventDate: string, title: { __typename?: 'LanguageText', en: string, fr: string } } | null } };

export type GetPageMediaQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageMediaQuery = { __typename?: 'Query', pageMedia: Array<{ __typename?: 'BuzzMediaGOOD', id?: string | null, fileUrl: string, mimeType: string, buzzId?: string | null }> };

export type AddPageSubscriberMutationVariables = Exact<{
  AddToWaitingListInput: AddToWaitingListInput;
}>;


export type AddPageSubscriberMutation = { __typename?: 'Mutation', addPageSubscriber: boolean };

export type AddToEventWaitingListMutationVariables = Exact<{
  AddToWaitingListInput: AddToWaitingListInput;
}>;


export type AddToEventWaitingListMutation = { __typename?: 'Mutation', addToEventWaitingList: boolean };

export type AddToHoneyWaitingListMutationVariables = Exact<{
  AddToWaitingListInput: AddToWaitingListInput;
}>;


export type AddToHoneyWaitingListMutation = { __typename?: 'Mutation', addToHoneyWaitingList: boolean };

export type UpdatePagePreferencesMutationVariables = Exact<{
  pageId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  language: Language;
  searchVisibility: SearchVisibility;
  slug: Scalars['String']['input'];
  eventInterestEnabled: Scalars['Boolean']['input'];
  honeyInterestEnabled: Scalars['Boolean']['input'];
  eventRegistrationEnabled: Scalars['Boolean']['input'];
  intercomChatBotEnabled: Scalars['Boolean']['input'];
  showUpcomingEvents: Scalars['Boolean']['input'];
  showUpcomingVisits: Scalars['Boolean']['input'];
  queenFeatureEnabled: Scalars['Boolean']['input'];
  queenCommunityVotingEnabled: Scalars['Boolean']['input'];
}>;


export type UpdatePagePreferencesMutation = { __typename?: 'Mutation', updatePagePreferences: boolean };

export type UpdatePageManagerMutationVariables = Exact<{
  input: UpdatePageManagerInput;
}>;


export type UpdatePageManagerMutation = { __typename?: 'Mutation', updatePageManager: boolean };

export type ResendInviteEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;


export type ResendInviteEmailMutation = { __typename?: 'Mutation', resendInviteEmail: boolean };

export type RemovePageManagerMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;


export type RemovePageManagerMutation = { __typename?: 'Mutation', removePageManager: boolean };

export type GetPageManagersQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageManagersQuery = { __typename?: 'Query', pageManagers: Array<{ __typename?: 'PageManager', pageId: string, userId: string, role: Role, firstName: string, lastName: string, jobTitle: string, phone: string, mobilePhone: string, email: string, visitReminders: boolean, buzzReminders: boolean, subscriberAlertsOptIn: boolean, mainContact: boolean, hiveContact: boolean, contactRole?: ContactRole | null, emailAddressStatus: EmailAddressStatus, lastSeenAt?: string | null, language?: Language | null, phoneNumberVerification?: { __typename?: 'PhoneNumberVerification', status: PhoneNumberStatus, smsOptIn: boolean, twilioStatus?: TwilioMessageStatus | null, twilioErrorCode?: number | null, twilioErrorMessage?: string | null, lastMessageSentAt?: string | null } | null }> };

export type GetPageUserContactSettingsQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPageUserContactSettingsQuery = { __typename?: 'Query', pageUserContactSettings: { __typename?: 'PageUserContactSettings', mainContact: boolean, hiveContact: boolean, visitReminders?: boolean | null, buzzReminders: boolean, subscriberAlertsOptIn?: boolean | null, eventWaitingList: boolean, emailAddressStatus: EmailAddressStatus, isPageManager: boolean, page: { __typename?: 'PageUserContactSettingsPage', pageId: string, slug: string, title: string } } };

export type UpdatePageUserContactSettingsMutationVariables = Exact<{
  input: UpdatePageUserContactSettingsInput;
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePageUserContactSettingsMutation = { __typename?: 'Mutation', updatePageUserContactSettings: { __typename?: 'PageUserContactSettings', mainContact: boolean, hiveContact: boolean, visitReminders?: boolean | null, buzzReminders: boolean, subscriberAlertsOptIn?: boolean | null, eventWaitingList: boolean, emailAddressStatus: EmailAddressStatus } };

export type AddPageManagerMutationVariables = Exact<{
  input: AddPageManagerInput;
}>;


export type AddPageManagerMutation = { __typename?: 'Mutation', addPageManager: boolean };

export type UpdateBannerImageMutationVariables = Exact<{
  input: UpdateBannerImageInput;
}>;


export type UpdateBannerImageMutation = { __typename?: 'Mutation', updateBannerImage: boolean };

export type UpdateProfileImageMutationVariables = Exact<{
  input: UpdateProfileImageInput;
}>;


export type UpdateProfileImageMutation = { __typename?: 'Mutation', updateProfileImage: boolean };

export type UpdateCompanyLogoMutationVariables = Exact<{
  input: UpdateCompanyLogoInput;
}>;


export type UpdateCompanyLogoMutation = { __typename?: 'Mutation', updateCompanyLogo: boolean };

export type GetPageHoneyLabelQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPageHoneyLabelQuery = { __typename?: 'Query', getPageHoneyLabel?: { __typename?: 'HoneyLabel', zuperJobId: string, fileUrl?: string | null, status: HoneyLabelStatus, designRefId?: string | null } | null };

export type UpdateHoneyLabelStatusMutationVariables = Exact<{
  input: HoneyLabelStatusInput;
}>;


export type UpdateHoneyLabelStatusMutation = { __typename?: 'Mutation', updateHoneyLabelStatus: boolean };

export type SendShareWithTenantsMutationVariables = Exact<{
  input: ShareWithTenantsInput;
}>;


export type SendShareWithTenantsMutation = { __typename?: 'Mutation', sendShareWithTenants: boolean };

export type GetThreeBeeIdsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
}>;


export type GetThreeBeeIdsQuery = { __typename?: 'Query', getThreeBeeSiteIds: { __typename?: 'ThreeBeeSiteIds', siteId: number, polygonId?: string | null, caId?: string | null, roiId?: string | null, portfolioId?: string | null } };

export type ListOwnedPagesDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOwnedPagesDashboardQuery = { __typename?: 'Query', ownedPagesDashboard: Array<{ __typename?: 'PortfolioDashboardResponse', id: string, title: string, streetAddress: string, country: string, lat?: number | null, lng?: number | null, slug?: string | null, zuperCustomerUid?: string | null, region?: string | null, profilePic?: string | null, tenantSubCount?: number | null, numberOfWorkshopsBookedThisYear?: number | null, contractedWorkshops?: number | null, threeBeeSiteId?: string | null, pageManagerName?: string | null, package?: AlveolePackages | null, newSubs?: number | null, yearEndDownloadUrl?: string | null, pesticideDownloadUrl?: string | null, events: Array<{ __typename?: 'PortfolioEvent', id: string, startTime: string, endTime: string, timezone: string, eventType: EventType, registeredCount: number, title: { __typename?: 'LanguageText', en: string, fr: string } }>, beekeepingVisits: Array<{ __typename?: 'PortfolioBeekeepingVisit', id: string, startTime: string, endTime: string, timezone: string }>, installations: Array<{ __typename?: 'PortfolioInstallation', id: string, startTime: string, endTime: string, timezone: string }>, honeyJars: Array<{ __typename?: 'PortfolioHoneyJob', id: string, dueDate: string, status: ZuperJobStatus, timezone: string }>, honeyHarvests: Array<{ __typename?: 'PortfolioHoneyJob', id: string, dueDate: string, status: ZuperJobStatus, timezone: string }>, latestBuzzes?: Array<{ __typename?: 'PortfolioBuzz', id: string, text: string, createdAt: string, timezone: string, latestImageMedia?: { __typename?: 'BuzzMediaGOOD', fileUrl: string, mimeType: string } | null }> | null }> };

export type PageGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type PageGroupsQuery = { __typename?: 'Query', pageGroups: Array<{ __typename?: 'PageGroup', id: string, name: string, description: string, pageIds?: Array<string> | null }> };

export type CreatePageGroupMutationVariables = Exact<{
  input: CreatePageGroupInput;
}>;


export type CreatePageGroupMutation = { __typename?: 'Mutation', createPageGroup: { __typename?: 'PageGroup', id: string, name: string, description: string, pageIds?: Array<string> | null } };

export type UpdatePageGroupMutationVariables = Exact<{
  input: UpdatePageGroupInput;
}>;


export type UpdatePageGroupMutation = { __typename?: 'Mutation', updatePageGroup: { __typename?: 'PageGroup', id: string, name: string, description: string, pageIds?: Array<string> | null } };

export type DeletePageGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePageGroupMutation = { __typename?: 'Mutation', deletePageGroup: boolean };

export type AddPagesToGroupMutationVariables = Exact<{
  input: AddPagesToGroupInput;
}>;


export type AddPagesToGroupMutation = { __typename?: 'Mutation', addPagesToGroup: boolean };

export type RemovePageFromGroupMutationVariables = Exact<{
  input: RemovePageFromGroupInput;
}>;


export type RemovePageFromGroupMutation = { __typename?: 'Mutation', removePageFromGroup: boolean };

export type PagesInGroupQueryVariables = Exact<{
  pageGroupId: Scalars['String']['input'];
}>;


export type PagesInGroupQuery = { __typename?: 'Query', pagesInGroup: Array<string> };

export type GroupsForPageQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type GroupsForPageQuery = { __typename?: 'Query', groupsForPage: Array<{ __typename?: 'PageGroup', id: string, name: string, description: string }> };

export type AddUserToAllGroupPagesMutationVariables = Exact<{
  input: AddUserToGroupPagesInput;
}>;


export type AddUserToAllGroupPagesMutation = { __typename?: 'Mutation', addUserToAllGroupPages: number };

export type RemoveUserFromAllGroupPagesMutationVariables = Exact<{
  input: AddUserToGroupPagesInput;
}>;


export type RemoveUserFromAllGroupPagesMutation = { __typename?: 'Mutation', removeUserFromAllGroupPages: number };

export type AddUserToAllUserToClonePagesMutationVariables = Exact<{
  input: AddUserToUserToClonePagesInput;
}>;


export type AddUserToAllUserToClonePagesMutation = { __typename?: 'Mutation', addUserToAllUserToClonePages: number };

export type RemoveUserFromAllUserToClonePagesMutationVariables = Exact<{
  input: AddUserToUserToClonePagesInput;
}>;


export type RemoveUserFromAllUserToClonePagesMutation = { __typename?: 'Mutation', removeUserFromAllUserToClonePages: number };

export type ClearAllUserPagesMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ClearAllUserPagesMutation = { __typename?: 'Mutation', clearAllUserPages: number };

export type GetPageGroupsInUserOwnedPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPageGroupsInUserOwnedPagesQuery = { __typename?: 'Query', pageGroupsInUserOwnedPages: Array<{ __typename?: 'PageGroup', id: string, name: string, description: string, pageIds?: Array<string> | null }> };

export type GetClonedUsersInUserOwnedPagesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetClonedUsersInUserOwnedPagesQuery = { __typename?: 'Query', clonedUsersInUserOwnedPages: Array<{ __typename?: 'UserToClone', id: string, firstName?: string | null, lastName?: string | null, email: string }> };

export type GetKioskFromZuperJobUidQueryVariables = Exact<{
  zuperJobUid: Scalars['String']['input'];
}>;


export type GetKioskFromZuperJobUidQuery = { __typename?: 'Query', getKioskFromZuperJobUid?: { __typename?: 'KioskFromZuperJobUid', pageId: string, title: string, description?: string | null, coverPic?: string | null, profilePic?: string | null, slug?: string | null, eventId: string, eventType: EventType, eventImageFilename?: string | null, language?: Language | null, eventTitle: { __typename?: 'LanguageText', en: string, fr: string }, eventDescription: { __typename?: 'LanguageText', en: string, fr: string } } | null };

export type RegisterKioskAttendeesMutationVariables = Exact<{
  input: RegisterKioskAttendeesInput;
}>;


export type RegisterKioskAttendeesMutation = { __typename?: 'Mutation', registerKioskAttendees: boolean };

export type GetPageAudienceSummaryQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type GetPageAudienceSummaryQuery = { __typename?: 'Query', pageAudienceSummary: { __typename?: 'PageAudienceSummary', subscribersCount: number, honeyInterestCount: number, registeredForAnEventCount: number, eventInterestCount: number, users: Array<{ __typename?: 'PageAudienceUser', firstName?: string | null, lastName?: string | null, email: string, organizationName?: string | null, isSubscriber: boolean, interestedInHoney: boolean, interestedInEvents: boolean, eventStatuses: Array<{ __typename?: 'SubscriberEventStatus', eventId: string, eventTitle: string, eventStartTime: string, registrationStatus: EventRegistrationStatus }> }> } };

export type SendShareWithColleagueMutationVariables = Exact<{
  input: ShareWithColleagueInput;
}>;


export type SendShareWithColleagueMutation = { __typename?: 'Mutation', sendShareWithColleague: boolean };

export type RegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: string, name: string, territoryLeadUserId?: string | null, territoryLead?: { __typename?: 'RegionTerritoryLead', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }> };

export type StaffUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type StaffUsersQuery = { __typename?: 'Query', staffUsers: Array<{ __typename?: 'StaffUser', id: string, firstName?: string | null, lastName?: string | null, email: string, role: Role }> };

export type CreateRegionMutationVariables = Exact<{
  input: CreateRegionInput;
}>;


export type CreateRegionMutation = { __typename?: 'Mutation', createRegion: { __typename?: 'Region', id: string, name: string, territoryLeadUserId?: string | null, territoryLead?: { __typename?: 'RegionTerritoryLead', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type UpdateRegionMutationVariables = Exact<{
  input: UpdateRegionInput;
}>;


export type UpdateRegionMutation = { __typename?: 'Mutation', updateRegion: { __typename?: 'Region', id: string, name: string, territoryLeadUserId?: string | null, territoryLead?: { __typename?: 'RegionTerritoryLead', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type DeleteRegionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteRegionMutation = { __typename?: 'Mutation', deleteRegion: boolean };

export type GetQueenElectionQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type GetQueenElectionQuery = { __typename?: 'Query', queenElection?: { __typename?: 'QueenElectionDto', id: string, deadline?: string | null, communityVotingEnabled: boolean, hasWinner: boolean, myNomination?: { __typename?: 'QueenCandidateDto', id: string, name: string } | null, candidates: Array<{ __typename?: 'QueenCandidateDto', id: string, name: string, voteCount: number, votedByMe: boolean, isMyNomination: boolean, nominatorInitials?: string | null, nominatorOrganization?: string | null }>, winner?: { __typename?: 'QueenCandidateDto', id: string, name: string, voteCount: number, votedByMe: boolean, isMyNomination: boolean, nominatorInitials?: string | null, nominatorOrganization?: string | null } | null } | null };

export type GetQueenPublicWinnerQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type GetQueenPublicWinnerQuery = { __typename?: 'Query', queenPublicWinner?: { __typename?: 'QueenPublicWinnerDto', name?: string | null, voteCount?: number | null, communityVotingEnabled: boolean, deadline?: string | null, hasWinner: boolean } | null };

export type SetQueenElectionDeadlineMutationVariables = Exact<{
  input: SetQueenElectionDeadlineInput;
}>;


export type SetQueenElectionDeadlineMutation = { __typename?: 'Mutation', setQueenElectionDeadline: boolean };

export type ToggleQueenVoteMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
}>;


export type ToggleQueenVoteMutation = { __typename?: 'Mutation', toggleQueenVote: boolean };

export type CrownQueenCandidateMutationVariables = Exact<{
  input: CrownQueenCandidateInput;
}>;


export type CrownQueenCandidateMutation = { __typename?: 'Mutation', crownQueenCandidate: boolean };

export type NominateQueenNameMutationVariables = Exact<{
  input: NominateQueenNameInput;
}>;


export type NominateQueenNameMutation = { __typename?: 'Mutation', nominateQueenName: { __typename?: 'QueenCandidateDto', id: string, name: string, voteCount: number, votedByMe: boolean, isMyNomination: boolean, nominatorInitials?: string | null, nominatorOrganization?: string | null } };

export type ReportsByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportsByUserQuery = { __typename?: 'Query', reportsByUser: Array<{ __typename?: 'Report', id: string, pageIds: Array<string>, reportUrl: string, createdAt: string, updatedAt: string, reportType: string, status: string, requestedByUserId?: string | null, mimeType: string, fileSize: number, downloadUrl?: string | null, title?: string | null, formattedAddress?: string | null, reportLanguage?: Language | null }> };

export type ReportDownloadUrlQueryVariables = Exact<{
  reportId: Scalars['String']['input'];
}>;


export type ReportDownloadUrlQuery = { __typename?: 'Query', reportDownloadUrl: { __typename?: 'DownloadUrlResponse', downloadUrl: string } };

export type GenerateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type GenerateReportMutation = { __typename?: 'Mutation', generateReport: { __typename?: 'Report', id: string, pageIds: Array<string>, reportUrl: string, createdAt: string, updatedAt: string, reportType: string, status: string, requestedByUserId?: string | null, mimeType: string, fileSize: number, downloadUrl?: string | null, title?: string | null, formattedAddress?: string | null } };

export type GenerateFreeToolReportMutationVariables = Exact<{
  freeToolUseSessionId: Scalars['String']['input'];
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  landCoverImage?: InputMaybe<Scalars['Upload']['input']>;
  protectedAreasImage?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type GenerateFreeToolReportMutation = { __typename?: 'Mutation', generateFreeToolReport: { __typename?: 'DownloadUrlResponse', downloadUrl: string, viewUrl?: string | null, reportId?: string | null } };

export type SendFreeToolReportEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  reportDownloadUrl: Scalars['String']['input'];
  assetAddress: Scalars['String']['input'];
}>;


export type SendFreeToolReportEmailMutation = { __typename?: 'Mutation', sendFreeToolReportEmail: boolean };

export type ScanHandwrittenSubsInputMutationVariables = Exact<{
  input: ScanHandwrittenSubsInput;
}>;


export type ScanHandwrittenSubsInputMutation = { __typename?: 'Mutation', scanHandwrittenContacts: { __typename?: 'SubScanResponse', rawText?: string | null, contacts: Array<{ __typename?: 'ScannedSub', firstName?: string | null, lastName?: string | null, email?: string | null, companyGuess?: string | null, confidence?: number | null }> } };

export type GetThreeBeePortfoliosFromSiteListQueryVariables = Exact<{
  siteIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetThreeBeePortfoliosFromSiteListQuery = { __typename?: 'Query', getThreeBeePortfoliosFromSiteList: Array<string> };

export type GetThreeBeeSiteIdsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
}>;


export type GetThreeBeeSiteIdsQuery = { __typename?: 'Query', getThreeBeeSiteIds: { __typename?: 'ThreeBeeSiteIds', siteId: number, polygonId?: string | null, caId?: string | null, roiId?: string | null, portfolioId?: string | null } };

export type GetLandCoverQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  radius?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetLandCoverQuery = { __typename?: 'Query', getLandCover: { __typename?: 'LandCoverData', tiff: string, summary: { __typename?: 'LandCoverSummary', naturalCover: number, agriculturalCover: number, artificialCover: number, waterCover: number } } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', getCurrentUser: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, role: Role, avatarUrl?: string | null, tagline?: string | null, language?: Language | null, bio?: string | null, organizationName?: string | null, portfolioId?: string | null, reportingOnboard?: Array<Record<string, any>> | null, phone?: string | null, jobTitle?: string | null } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: boolean };

export type TrackUserSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type TrackUserSeenMutation = { __typename?: 'Mutation', trackUserSeen: boolean };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: boolean };

export type ListUsersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string, role: Role, mobilePhone?: string | null, language?: Language | null, slackMemberId?: string | null, managedPages?: Array<{ __typename?: 'PageManager', pageId: string, mainContact: boolean, page?: { __typename?: 'SearchablePage', id: string, title: string, streetAddress?: string | null, slug?: string | null, profilePic?: string | null } | null }> | null }> };

export type GetUserRegisteredEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRegisteredEventsQuery = { __typename?: 'Query', getUserRegisteredEvents: Array<string> };

export type RegisterForEventMutationVariables = Exact<{
  input: RegisterEventInput;
}>;


export type RegisterForEventMutation = { __typename?: 'Mutation', registerForEvent: boolean };

export type UnregisterFromEventMutationVariables = Exact<{
  input: UnregisterEventInput;
}>;


export type UnregisterFromEventMutation = { __typename?: 'Mutation', unregisterFromEvent: boolean };

export type GetMyHiveOnboardingProgressQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
}>;


export type GetMyHiveOnboardingProgressQuery = { __typename?: 'Query', getMyHiveOnboardingProgress?: { __typename?: 'MyHiveOnboardingProgressEntity', activeFlow?: string | null, completedFlows?: Array<string> | null, seen?: Array<string> | null, updatedAt?: string | null, numberOfWorkshopsBookedThisYear?: number | null, contractedWorkshops?: number | null, sharedPageWithTenantsAt?: string | null, cohort?: OnboardingCohort | null, startedAt?: string | null } | null };

export type SetMyHiveOnboardingProgressMutationVariables = Exact<{
  progress: UpdateMyHiveOnboardingInput;
}>;


export type SetMyHiveOnboardingProgressMutation = { __typename?: 'Mutation', setMyHiveOnboardingProgress: boolean };


export const GetHiveStrengthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHiveStrength"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"windowWeeks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiveStrength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"windowWeeks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"windowWeeks"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"beeFrames"}},{"kind":"Field","name":{"kind":"Name","value":"honeyFrames"}},{"kind":"Field","name":{"kind":"Name","value":"broodFrames"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"trendPercent"}},{"kind":"Field","name":{"kind":"Name","value":"showNectarFlow"}},{"kind":"Field","name":{"kind":"Name","value":"queenSpotted"}},{"kind":"Field","name":{"kind":"Name","value":"isHarvest"}}]}},{"kind":"Field","name":{"kind":"Name","value":"windowWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"pointCount"}}]}}]}}]} as unknown as DocumentNode<GetHiveStrengthQuery, GetHiveStrengthQueryVariables>;
export const GetBioacousticsSampleDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBioacousticsSampleData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBioacousticsSampleData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hourlyPollinatorObservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"hz"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dailyPollinatorData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"meanBuzzPerHour"}},{"kind":"Field","name":{"kind":"Name","value":"weatherData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meanTemp"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrecip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buzzDetections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"dateTime"}},{"kind":"Field","name":{"kind":"Name","value":"hz"}}]}},{"kind":"Field","name":{"kind":"Name","value":"birdObservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latinTaxa"}},{"kind":"Field","name":{"kind":"Name","value":"commonName"}},{"kind":"Field","name":{"kind":"Name","value":"imgUrl"}},{"kind":"Field","name":{"kind":"Name","value":"dateTime"}},{"kind":"Field","name":{"kind":"Name","value":"audioClip"}}]}}]}}]}}]} as unknown as DocumentNode<GetBioacousticsSampleDataQuery, GetBioacousticsSampleDataQueryVariables>;
export const GetPageBioacousticsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageBioacousticsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPageBioacousticsData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hourlyPollinatorObservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"hz"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dailyPollinatorData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"meanBuzzPerHour"}},{"kind":"Field","name":{"kind":"Name","value":"weatherData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meanTemp"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrecip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buzzDetections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"dateTime"}},{"kind":"Field","name":{"kind":"Name","value":"hz"}}]}},{"kind":"Field","name":{"kind":"Name","value":"birdObservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latinTaxa"}},{"kind":"Field","name":{"kind":"Name","value":"commonName"}},{"kind":"Field","name":{"kind":"Name","value":"imgUrl"}},{"kind":"Field","name":{"kind":"Name","value":"dateTime"}},{"kind":"Field","name":{"kind":"Name","value":"audioClip"}}]}}]}}]}}]} as unknown as DocumentNode<GetPageBioacousticsDataQuery, GetPageBioacousticsDataQueryVariables>;
export const CreateBuzzDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBuzz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBuzzInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBuzz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createBuzzInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateBuzzMutation, CreateBuzzMutationVariables>;
export const RemoveBuzzDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveBuzz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeBuzz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveBuzzMutation, RemoveBuzzMutationVariables>;
export const UpdateBuzzDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBuzz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateBuzzInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBuzzInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBuzz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateBuzzInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateBuzzInput"}}}]}]}}]} as unknown as DocumentNode<UpdateBuzzMutation, UpdateBuzzMutationVariables>;
export const LikeBuzzDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LikeBuzz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"likeBuzz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<LikeBuzzMutation, LikeBuzzMutationVariables>;
export const UnlikeBuzzDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnlikeBuzz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlikeBuzz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UnlikeBuzzMutation, UnlikeBuzzMutationVariables>;
export const GetChatSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetChatSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetChatSessionQuery, GetChatSessionQueryVariables>;
export const GetChatSessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatSessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChatSessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageDate"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetChatSessionsQuery, GetChatSessionsQueryVariables>;
export const CreateChatSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateChatSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChatSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateChatSessionMutation, CreateChatSessionMutationVariables>;
export const SendChatMessageStreamingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendChatMessageStreaming"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendChatMessageStreaming"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendChatMessageStreamingMutation, SendChatMessageStreamingMutationVariables>;
export const ChatStreamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ChatStream"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatStream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"toolName"}}]}}]}}]} as unknown as DocumentNode<ChatStreamSubscription, ChatStreamSubscriptionVariables>;
export const GetEdnaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEdnaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEdnaData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"totalUniqueHits"}},{"kind":"Field","name":{"kind":"Name","value":"totalHits"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageCity"}},{"kind":"Field","name":{"kind":"Name","value":"detections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"commonNameEn"}},{"kind":"Field","name":{"kind":"Name","value":"commonNameFr"}},{"kind":"Field","name":{"kind":"Name","value":"latinTaxon"}},{"kind":"Field","name":{"kind":"Name","value":"growthHabit"}},{"kind":"Field","name":{"kind":"Name","value":"iucnStatus"}},{"kind":"Field","name":{"kind":"Name","value":"imgUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetEdnaDataQuery, GetEdnaDataQueryVariables>;
export const ShareEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShareEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ShareEventMutation, ShareEventMutationVariables>;
export const EmailAttendeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailAttendees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailAttendeesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAttendees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<EmailAttendeesMutation, EmailAttendeesMutationVariables>;
export const RequestWorkshopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestWorkshop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestWorkshopInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestWorkshop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RequestWorkshopMutation, RequestWorkshopMutationVariables>;
export const ProcessSitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProcessSites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessSitesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processSites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"buildingType"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"pasi"}},{"kind":"Field","name":{"kind":"Name","value":"naturalCover"}},{"kind":"Field","name":{"kind":"Name","value":"agriculturalCover"}},{"kind":"Field","name":{"kind":"Name","value":"artificialCover"}},{"kind":"Field","name":{"kind":"Name","value":"waterCover"}},{"kind":"Field","name":{"kind":"Name","value":"cloudCover"}},{"kind":"Field","name":{"kind":"Name","value":"msaLU"}},{"kind":"Field","name":{"kind":"Name","value":"speciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"criticalSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"endangeredSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"vulnerableSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"nearThreatenedSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"leastConcernSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"threatenedSpeciesTotal"}}]}}]}}]} as unknown as DocumentNode<ProcessSitesQuery, ProcessSitesQueryVariables>;
export const GetBenchmarkSitesByAoiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBenchmarkSitesByAoi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"radius"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sources"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBenchmarkSitesByAoi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"Argument","name":{"kind":"Name","value":"lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"Argument","name":{"kind":"Name","value":"radius"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radius"}}},{"kind":"Argument","name":{"kind":"Name","value":"sources"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sources"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"buildingType"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"pasi"}},{"kind":"Field","name":{"kind":"Name","value":"naturalCover"}},{"kind":"Field","name":{"kind":"Name","value":"agriculturalCover"}},{"kind":"Field","name":{"kind":"Name","value":"artificialCover"}},{"kind":"Field","name":{"kind":"Name","value":"waterCover"}},{"kind":"Field","name":{"kind":"Name","value":"cloudCover"}},{"kind":"Field","name":{"kind":"Name","value":"msaLU"}},{"kind":"Field","name":{"kind":"Name","value":"speciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"criticalSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"endangeredSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"vulnerableSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"nearThreatenedSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"leastConcernSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"threatenedSpeciesTotal"}}]}}]}}]} as unknown as DocumentNode<GetBenchmarkSitesByAoiQuery, GetBenchmarkSitesByAoiQueryVariables>;
export const GetFreeSiteDataWithBenchmarksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFreeSiteDataWithBenchmarks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFreeSiteDataWithBenchmarks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"Argument","name":{"kind":"Name","value":"lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impactScore"}},{"kind":"Field","name":{"kind":"Name","value":"riskScore"}},{"kind":"Field","name":{"kind":"Name","value":"pasiRaw"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentileScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"threatenedSpeciesRaw"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentileScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"msaRaw"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentileScore"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sampleMean"}},{"kind":"Field","name":{"kind":"Name","value":"sampleStd"}},{"kind":"Field","name":{"kind":"Name","value":"zScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"naturalCoverRaw"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentileScore"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"landCoverData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"tiff"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agriculturalCover"}},{"kind":"Field","name":{"kind":"Name","value":"artificialCover"}},{"kind":"Field","name":{"kind":"Name","value":"naturalCover"}},{"kind":"Field","name":{"kind":"Name","value":"waterCover"}},{"kind":"Field","name":{"kind":"Name","value":"cloudCover"}},{"kind":"Field","name":{"kind":"Name","value":"msaLU"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aoi"}}]}},{"kind":"Field","name":{"kind":"Name","value":"protectedAreasData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"pasi"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sitePid"}},{"kind":"Field","name":{"kind":"Name","value":"designation"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"intersectArea"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aoi"}}]}},{"kind":"Field","name":{"kind":"Name","value":"speciesData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"speciesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"speciesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalName"}},{"kind":"Field","name":{"kind":"Name","value":"iucn"}},{"kind":"Field","name":{"kind":"Name","value":"vernacularName"}},{"kind":"Field","name":{"kind":"Name","value":"scientificName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"criticalSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"endangeredSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"leastConcernSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"nearThreatenedSpeciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"speciesCount"}},{"kind":"Field","name":{"kind":"Name","value":"threatenedSpeciesTotal"}},{"kind":"Field","name":{"kind":"Name","value":"vulnerableSpeciesCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aoi"}}]}}]}}]}}]} as unknown as DocumentNode<GetFreeSiteDataWithBenchmarksQuery, GetFreeSiteDataWithBenchmarksQueryVariables>;
export const CreateFreeToolSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFreeToolSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sites"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FreeToolSiteInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFreeToolSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sites"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sites"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFreeToolSessionMutation, CreateFreeToolSessionMutationVariables>;
export const CreateFreeToolShareSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFreeToolShareSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"freeToolUseSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFreeToolShareSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"freeToolUseSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"freeToolUseSessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFreeToolShareSessionMutation, CreateFreeToolShareSessionMutationVariables>;
export const SendFreeChatMessageStreamingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendFreeChatMessageStreaming"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uiContext"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FreeToolUiContext"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendFreeChatMessageStreaming"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chatSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatSessionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"uiContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uiContext"}}}]}}]}]}}]} as unknown as DocumentNode<SendFreeChatMessageStreamingMutation, SendFreeChatMessageStreamingMutationVariables>;
export const GetIntercomTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIntercomToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intercomToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetSlug"}}}]}]}}]} as unknown as DocumentNode<GetIntercomTokenQuery, GetIntercomTokenQueryVariables>;
export const CreateLinkedInShareInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLinkedInShareInput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLinkedInShareInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLinkedInShareSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<CreateLinkedInShareInputMutation, CreateLinkedInShareInputMutationVariables>;
export const GetNestingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNesting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nesting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lumpyMud"}},{"kind":"Field","name":{"kind":"Name","value":"smoothMud"}},{"kind":"Field","name":{"kind":"Name","value":"masticLeafPulp"}},{"kind":"Field","name":{"kind":"Name","value":"woolPlantHairs"}},{"kind":"Field","name":{"kind":"Name","value":"grass"}},{"kind":"Field","name":{"kind":"Name","value":"looseLeafPieces"}},{"kind":"Field","name":{"kind":"Name","value":"resin"}},{"kind":"Field","name":{"kind":"Name","value":"membranousCellophaneLikeLining"}},{"kind":"Field","name":{"kind":"Name","value":"leafPulpSandGrainsLeafDiscs"}},{"kind":"Field","name":{"kind":"Name","value":"mudSomeLeafPulpOrangePollen"}},{"kind":"Field","name":{"kind":"Name","value":"otherCombination"}}]}}]}}]} as unknown as DocumentNode<GetNestingQuery, GetNestingQueryVariables>;
export const ListOwnedPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListOwnedPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isReportingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isChatEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"threeBeeSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeehives"}},{"kind":"Field","name":{"kind":"Name","value":"hasBioacoustics"}}]}}]}}]} as unknown as DocumentNode<ListOwnedPagesQuery, ListOwnedPagesQueryVariables>;
export const ListBouncingContactPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListBouncingContactPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bouncingContactPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"zuperCustomerUid"}},{"kind":"Field","name":{"kind":"Name","value":"zuperHubspotCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"pageManagers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"mainContact"}},{"kind":"Field","name":{"kind":"Name","value":"hiveContact"}}]}}]}}]}}]} as unknown as DocumentNode<ListBouncingContactPagesQuery, ListBouncingContactPagesQueryVariables>;
export const ListAllActivePagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListAllActivePages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allActivePages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}}]}}]}}]} as unknown as DocumentNode<ListAllActivePagesQuery, ListAllActivePagesQueryVariables>;
export const ListPagesDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPagesData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slugs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myHiveUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"nonManagerPageSubscribersCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPageUpdateSubscribersCount"}},{"kind":"Field","name":{"kind":"Name","value":"tenantSubCreatedAts"}},{"kind":"Field","name":{"kind":"Name","value":"pageManagers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mainContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"managerLastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"zuperCustomerUid"}},{"kind":"Field","name":{"kind":"Name","value":"zuperRegion"}},{"kind":"Field","name":{"kind":"Name","value":"zuperCustomerUrl"}},{"kind":"Field","name":{"kind":"Name","value":"zuperCustomerName"}},{"kind":"Field","name":{"kind":"Name","value":"zuperLastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mainContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"zuperAlveoleRegion"}},{"kind":"Field","name":{"kind":"Name","value":"zuperPreferredTechnicianName"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfBeeHives"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfBeeHomes"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfBeeHivesInstalled"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfBeeHomesInstalled"}},{"kind":"Field","name":{"kind":"Name","value":"hit25TenantSubscribersAt"}},{"kind":"Field","name":{"kind":"Name","value":"zuperCustomerCategory"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastCompletedBeekeepingVisitDate"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedBeekeepingVisitsThisYearCount"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfWorkshopsCompletedThisYear"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfWorkshopsBookedThisYear"}},{"kind":"Field","name":{"kind":"Name","value":"workshopsAllotted"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiveHealth"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"assetCategory"}},{"kind":"Field","name":{"kind":"Name","value":"assetStatus"}}]}}]}}]}}]} as unknown as DocumentNode<ListPagesDataQuery, ListPagesDataQueryVariables>;
export const GetPageOutboundLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageOutboundLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageOutboundLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUuid"}},{"kind":"Field","name":{"kind":"Name","value":"updateContext"}},{"kind":"Field","name":{"kind":"Name","value":"logGroup"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"twilioStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cioStatus"}}]}}]}}]}}]} as unknown as DocumentNode<GetPageOutboundLogsQuery, GetPageOutboundLogsQueryVariables>;
export const GetPageHomeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageHome"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"threeBeeSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"searchVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"coverPic"}},{"kind":"Field","name":{"kind":"Name","value":"coverPicOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"companyLogo"}},{"kind":"Field","name":{"kind":"Name","value":"isReportingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"chatBotEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"intercomChatBotEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"totalPageUpdateSubscribers"}},{"kind":"Field","name":{"kind":"Name","value":"hasRecentPageUpdateSubscribers"}},{"kind":"Field","name":{"kind":"Name","value":"honeyDeliveredBy"}},{"kind":"Field","name":{"kind":"Name","value":"honeyNextHarvest"}},{"kind":"Field","name":{"kind":"Name","value":"zuperCustomerUid"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"beekeeperFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"beekeeperLastName"}},{"kind":"Field","name":{"kind":"Name","value":"registeredCount"}},{"kind":"Field","name":{"kind":"Name","value":"registeredUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"registrationStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"imageFilename"}},{"kind":"Field","name":{"kind":"Name","value":"zuperJobUid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"beekeepingVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"beekeeperFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"beekeeperLastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buzzes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"beekeeperFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"beekeeperLastName"}},{"kind":"Field","name":{"kind":"Name","value":"beekeeperTagline"}},{"kind":"Field","name":{"kind":"Name","value":"beekeeperAvatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"likedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"totalLikes"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"buzzId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weatherDescription"}},{"kind":"Field","name":{"kind":"Name","value":"weatherTempCelsius"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isYearEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearEndBuzz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"likedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"totalLikes"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventWaitingList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"honeyWaitingList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageSubscriberEmails"}},{"kind":"Field","name":{"kind":"Name","value":"eventInterestEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"honeyInterestEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"eventRegistrationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"showUpcomingEvents"}},{"kind":"Field","name":{"kind":"Name","value":"showUpcomingVisits"}},{"kind":"Field","name":{"kind":"Name","value":"queenFeatureEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"queenCommunityVotingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"eventHighlightCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buzzId"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buzzText"}},{"kind":"Field","name":{"kind":"Name","value":"mediaPath"}},{"kind":"Field","name":{"kind":"Name","value":"eventDate"}},{"kind":"Field","name":{"kind":"Name","value":"buzzId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zuperCustomerTimezone"}},{"kind":"Field","name":{"kind":"Name","value":"zuperAlveoleRegion"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfWorkshopsBookedThisYear"}},{"kind":"Field","name":{"kind":"Name","value":"contractedWorkshops"}},{"kind":"Field","name":{"kind":"Name","value":"hasBioacoustics"}}]}}]}}]} as unknown as DocumentNode<GetPageHomeQuery, GetPageHomeQueryVariables>;
export const GetPageMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"buzzId"}}]}}]}}]} as unknown as DocumentNode<GetPageMediaQuery, GetPageMediaQueryVariables>;
export const AddPageSubscriberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPageSubscriber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AddToWaitingListInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddToWaitingListInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPageSubscriber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AddToWaitingListInput"}}}]}]}}]} as unknown as DocumentNode<AddPageSubscriberMutation, AddPageSubscriberMutationVariables>;
export const AddToEventWaitingListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddToEventWaitingList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AddToWaitingListInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddToWaitingListInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addToEventWaitingList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AddToWaitingListInput"}}}]}]}}]} as unknown as DocumentNode<AddToEventWaitingListMutation, AddToEventWaitingListMutationVariables>;
export const AddToHoneyWaitingListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddToHoneyWaitingList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AddToWaitingListInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddToWaitingListInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addToHoneyWaitingList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AddToWaitingListInput"}}}]}]}}]} as unknown as DocumentNode<AddToHoneyWaitingListMutation, AddToHoneyWaitingListMutationVariables>;
export const UpdatePagePreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePagePreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchVisibility"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchVisibility"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventInterestEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"honeyInterestEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventRegistrationEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intercomChatBotEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showUpcomingEvents"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showUpcomingVisits"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queenFeatureEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queenCommunityVotingEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePagePreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchVisibility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchVisibility"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventInterestEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventInterestEnabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"honeyInterestEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"honeyInterestEnabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventRegistrationEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventRegistrationEnabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"intercomChatBotEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intercomChatBotEnabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"showUpcomingEvents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showUpcomingEvents"}}},{"kind":"Argument","name":{"kind":"Name","value":"showUpcomingVisits"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showUpcomingVisits"}}},{"kind":"Argument","name":{"kind":"Name","value":"queenFeatureEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queenFeatureEnabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"queenCommunityVotingEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queenCommunityVotingEnabled"}}}]}]}}]} as unknown as DocumentNode<UpdatePagePreferencesMutation, UpdatePagePreferencesMutationVariables>;
export const UpdatePageManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePageManager"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePageManagerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePageManager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updatePageManagerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdatePageManagerMutation, UpdatePageManagerMutationVariables>;
export const ResendInviteEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendInviteEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendInviteEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}]}}]} as unknown as DocumentNode<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>;
export const RemovePageManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePageManager"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePageManager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}]}]}}]} as unknown as DocumentNode<RemovePageManagerMutation, RemovePageManagerMutationVariables>;
export const GetPageManagersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageManagers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageManagers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminders"}},{"kind":"Field","name":{"kind":"Name","value":"buzzReminders"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberAlertsOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"mainContact"}},{"kind":"Field","name":{"kind":"Name","value":"hiveContact"}},{"kind":"Field","name":{"kind":"Name","value":"contactRole"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberVerification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"smsOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"twilioStatus"}},{"kind":"Field","name":{"kind":"Name","value":"twilioErrorCode"}},{"kind":"Field","name":{"kind":"Name","value":"twilioErrorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageSentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<GetPageManagersQuery, GetPageManagersQueryVariables>;
export const GetPageUserContactSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageUserContactSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageUserContactSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainContact"}},{"kind":"Field","name":{"kind":"Name","value":"hiveContact"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminders"}},{"kind":"Field","name":{"kind":"Name","value":"buzzReminders"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberAlertsOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"eventWaitingList"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isPageManager"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<GetPageUserContactSettingsQuery, GetPageUserContactSettingsQueryVariables>;
export const UpdatePageUserContactSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePageUserContactSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePageUserContactSettingsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePageUserContactSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainContact"}},{"kind":"Field","name":{"kind":"Name","value":"hiveContact"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminders"}},{"kind":"Field","name":{"kind":"Name","value":"buzzReminders"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberAlertsOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"eventWaitingList"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressStatus"}}]}}]}}]} as unknown as DocumentNode<UpdatePageUserContactSettingsMutation, UpdatePageUserContactSettingsMutationVariables>;
export const AddPageManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPageManager"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddPageManagerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPageManager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addPageManagerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<AddPageManagerMutation, AddPageManagerMutationVariables>;
export const UpdateBannerImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBannerImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBannerImageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBannerImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateBannerImageInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateBannerImageMutation, UpdateBannerImageMutationVariables>;
export const UpdateProfileImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfileImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProfileImageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfileImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateProfileImageInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateProfileImageMutation, UpdateProfileImageMutationVariables>;
export const UpdateCompanyLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompanyLogo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCompanyLogoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyLogo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateCompanyLogoInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateCompanyLogoMutation, UpdateCompanyLogoMutationVariables>;
export const GetPageHoneyLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageHoneyLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPageHoneyLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zuperJobId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"designRefId"}}]}}]}}]} as unknown as DocumentNode<GetPageHoneyLabelQuery, GetPageHoneyLabelQueryVariables>;
export const UpdateHoneyLabelStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateHoneyLabelStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HoneyLabelStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateHoneyLabelStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"honeyLabelStatusInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateHoneyLabelStatusMutation, UpdateHoneyLabelStatusMutationVariables>;
export const SendShareWithTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendShareWithTenants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareWithTenantsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendShareWithTenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendShareWithTenantsMutation, SendShareWithTenantsMutationVariables>;
export const GetThreeBeeIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetThreeBeeIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getThreeBeeSiteIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"polygonId"}},{"kind":"Field","name":{"kind":"Name","value":"caId"}},{"kind":"Field","name":{"kind":"Name","value":"roiId"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioId"}}]}}]}}]} as unknown as DocumentNode<GetThreeBeeIdsQuery, GetThreeBeeIdsQueryVariables>;
export const ListOwnedPagesDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListOwnedPagesDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownedPagesDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"zuperCustomerUid"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"tenantSubCount"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfWorkshopsBookedThisYear"}},{"kind":"Field","name":{"kind":"Name","value":"contractedWorkshops"}},{"kind":"Field","name":{"kind":"Name","value":"threeBeeSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"pageManagerName"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"newSubs"}},{"kind":"Field","name":{"kind":"Name","value":"yearEndDownloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"pesticideDownloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"registeredCount"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"beekeepingVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"honeyJars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"honeyHarvests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestBuzzes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"latestImageMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListOwnedPagesDashboardQuery, ListOwnedPagesDashboardQueryVariables>;
export const PageGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pageIds"}}]}}]}}]} as unknown as DocumentNode<PageGroupsQuery, PageGroupsQueryVariables>;
export const CreatePageGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePageGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePageGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPageGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pageIds"}}]}}]}}]} as unknown as DocumentNode<CreatePageGroupMutation, CreatePageGroupMutationVariables>;
export const UpdatePageGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePageGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePageGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePageGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pageIds"}}]}}]}}]} as unknown as DocumentNode<UpdatePageGroupMutation, UpdatePageGroupMutationVariables>;
export const DeletePageGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePageGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePageGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeletePageGroupMutation, DeletePageGroupMutationVariables>;
export const AddPagesToGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPagesToGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddPagesToGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPagesToGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<AddPagesToGroupMutation, AddPagesToGroupMutationVariables>;
export const RemovePageFromGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePageFromGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemovePageFromGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePageFromGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RemovePageFromGroupMutation, RemovePageFromGroupMutationVariables>;
export const PagesInGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PagesInGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagesInGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageGroupId"}}}]}]}}]} as unknown as DocumentNode<PagesInGroupQuery, PagesInGroupQueryVariables>;
export const GroupsForPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GroupsForPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsForPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GroupsForPageQuery, GroupsForPageQueryVariables>;
export const AddUserToAllGroupPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUserToAllGroupPages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserToGroupPagesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserToAllGroupPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<AddUserToAllGroupPagesMutation, AddUserToAllGroupPagesMutationVariables>;
export const RemoveUserFromAllGroupPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFromAllGroupPages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserToGroupPagesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromAllGroupPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RemoveUserFromAllGroupPagesMutation, RemoveUserFromAllGroupPagesMutationVariables>;
export const AddUserToAllUserToClonePagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUserToAllUserToClonePages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserToUserToClonePagesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserToAllUserToClonePages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<AddUserToAllUserToClonePagesMutation, AddUserToAllUserToClonePagesMutationVariables>;
export const RemoveUserFromAllUserToClonePagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFromAllUserToClonePages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserToUserToClonePagesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromAllUserToClonePages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RemoveUserFromAllUserToClonePagesMutation, RemoveUserFromAllUserToClonePagesMutationVariables>;
export const ClearAllUserPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearAllUserPages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearAllUserPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<ClearAllUserPagesMutation, ClearAllUserPagesMutationVariables>;
export const GetPageGroupsInUserOwnedPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPageGroupsInUserOwnedPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageGroupsInUserOwnedPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pageIds"}}]}}]}}]} as unknown as DocumentNode<GetPageGroupsInUserOwnedPagesQuery, GetPageGroupsInUserOwnedPagesQueryVariables>;
export const GetClonedUsersInUserOwnedPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClonedUsersInUserOwnedPages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clonedUsersInUserOwnedPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetClonedUsersInUserOwnedPagesQuery, GetClonedUsersInUserOwnedPagesQueryVariables>;
export const GetKioskFromZuperJobUidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKioskFromZuperJobUid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zuperJobUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getKioskFromZuperJobUid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zuperJobUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zuperJobUid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"coverPic"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"eventTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventImageFilename"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<GetKioskFromZuperJobUidQuery, GetKioskFromZuperJobUidQueryVariables>;
export const RegisterKioskAttendeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterKioskAttendees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterKioskAttendeesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerKioskAttendees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RegisterKioskAttendeesMutation, RegisterKioskAttendeesMutationVariables>;
export const GetPageAudienceSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageAudienceSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageAudienceSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribersCount"}},{"kind":"Field","name":{"kind":"Name","value":"honeyInterestCount"}},{"kind":"Field","name":{"kind":"Name","value":"registeredForAnEventCount"}},{"kind":"Field","name":{"kind":"Name","value":"eventInterestCount"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriber"}},{"kind":"Field","name":{"kind":"Name","value":"interestedInHoney"}},{"kind":"Field","name":{"kind":"Name","value":"interestedInEvents"}},{"kind":"Field","name":{"kind":"Name","value":"eventStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventTitle"}},{"kind":"Field","name":{"kind":"Name","value":"eventStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"registrationStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPageAudienceSummaryQuery, GetPageAudienceSummaryQueryVariables>;
export const SendShareWithColleagueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendShareWithColleague"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareWithColleagueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendShareWithColleague"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendShareWithColleagueMutation, SendShareWithColleagueMutationVariables>;
export const RegionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"territoryLeadUserId"}},{"kind":"Field","name":{"kind":"Name","value":"territoryLead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<RegionsQuery, RegionsQueryVariables>;
export const StaffUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StaffUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<StaffUsersQuery, StaffUsersQueryVariables>;
export const CreateRegionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRegion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRegionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRegion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"territoryLeadUserId"}},{"kind":"Field","name":{"kind":"Name","value":"territoryLead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRegionMutation, CreateRegionMutationVariables>;
export const UpdateRegionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRegion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRegionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRegion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"territoryLeadUserId"}},{"kind":"Field","name":{"kind":"Name","value":"territoryLead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRegionMutation, UpdateRegionMutationVariables>;
export const DeleteRegionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRegion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRegion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteRegionMutation, DeleteRegionMutationVariables>;
export const GetQueenElectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQueenElection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queenElection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"communityVotingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hasWinner"}},{"kind":"Field","name":{"kind":"Name","value":"myNomination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"candidates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"voteCount"}},{"kind":"Field","name":{"kind":"Name","value":"votedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"isMyNomination"}},{"kind":"Field","name":{"kind":"Name","value":"nominatorInitials"}},{"kind":"Field","name":{"kind":"Name","value":"nominatorOrganization"}}]}},{"kind":"Field","name":{"kind":"Name","value":"winner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"voteCount"}},{"kind":"Field","name":{"kind":"Name","value":"votedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"isMyNomination"}},{"kind":"Field","name":{"kind":"Name","value":"nominatorInitials"}},{"kind":"Field","name":{"kind":"Name","value":"nominatorOrganization"}}]}}]}}]}}]} as unknown as DocumentNode<GetQueenElectionQuery, GetQueenElectionQueryVariables>;
export const GetQueenPublicWinnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQueenPublicWinner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queenPublicWinner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"voteCount"}},{"kind":"Field","name":{"kind":"Name","value":"communityVotingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"hasWinner"}}]}}]}}]} as unknown as DocumentNode<GetQueenPublicWinnerQuery, GetQueenPublicWinnerQueryVariables>;
export const SetQueenElectionDeadlineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetQueenElectionDeadline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetQueenElectionDeadlineInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setQueenElectionDeadline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SetQueenElectionDeadlineMutation, SetQueenElectionDeadlineMutationVariables>;
export const ToggleQueenVoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleQueenVote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"candidateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleQueenVote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"candidateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidateId"}}}]}]}}]} as unknown as DocumentNode<ToggleQueenVoteMutation, ToggleQueenVoteMutationVariables>;
export const CrownQueenCandidateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CrownQueenCandidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrownQueenCandidateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crownQueenCandidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CrownQueenCandidateMutation, CrownQueenCandidateMutationVariables>;
export const NominateQueenNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NominateQueenName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NominateQueenNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nominateQueenName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"voteCount"}},{"kind":"Field","name":{"kind":"Name","value":"votedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"isMyNomination"}},{"kind":"Field","name":{"kind":"Name","value":"nominatorInitials"}},{"kind":"Field","name":{"kind":"Name","value":"nominatorOrganization"}}]}}]}}]} as unknown as DocumentNode<NominateQueenNameMutation, NominateQueenNameMutationVariables>;
export const ReportsByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportsByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportsByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageIds"}},{"kind":"Field","name":{"kind":"Name","value":"reportUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestedByUserId"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"reportLanguage"}}]}}]}}]} as unknown as DocumentNode<ReportsByUserQuery, ReportsByUserQueryVariables>;
export const ReportDownloadUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportDownloadUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportDownloadUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<ReportDownloadUrlQuery, ReportDownloadUrlQueryVariables>;
export const GenerateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageIds"}},{"kind":"Field","name":{"kind":"Name","value":"reportUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestedByUserId"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}}]}}]}}]} as unknown as DocumentNode<GenerateReportMutation, GenerateReportMutationVariables>;
export const GenerateFreeToolReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generateFreeToolReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"freeToolUseSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"landCoverImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"protectedAreasImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateFreeToolReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"freeToolUseSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"freeToolUseSessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fullAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"landCoverImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"landCoverImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"protectedAreasImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"protectedAreasImage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"viewUrl"}},{"kind":"Field","name":{"kind":"Name","value":"reportId"}}]}}]}}]} as unknown as DocumentNode<GenerateFreeToolReportMutation, GenerateFreeToolReportMutationVariables>;
export const SendFreeToolReportEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendFreeToolReportEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportDownloadUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendFreeToolReportEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportDownloadUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportDownloadUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"assetAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetAddress"}}}]}]}}]} as unknown as DocumentNode<SendFreeToolReportEmailMutation, SendFreeToolReportEmailMutationVariables>;
export const ScanHandwrittenSubsInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScanHandwrittenSubsInput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScanHandwrittenSubsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scanHandwrittenContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuess"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}}]}}]}}]} as unknown as DocumentNode<ScanHandwrittenSubsInputMutation, ScanHandwrittenSubsInputMutationVariables>;
export const GetThreeBeePortfoliosFromSiteListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetThreeBeePortfoliosFromSiteList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getThreeBeePortfoliosFromSiteList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteIds"}}}]}]}}]} as unknown as DocumentNode<GetThreeBeePortfoliosFromSiteListQuery, GetThreeBeePortfoliosFromSiteListQueryVariables>;
export const GetThreeBeeSiteIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetThreeBeeSiteIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getThreeBeeSiteIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"polygonId"}},{"kind":"Field","name":{"kind":"Name","value":"caId"}},{"kind":"Field","name":{"kind":"Name","value":"roiId"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioId"}}]}}]}}]} as unknown as DocumentNode<GetThreeBeeSiteIdsQuery, GetThreeBeeSiteIdsQueryVariables>;
export const GetLandCoverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLandCover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"radius"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLandCover"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"Argument","name":{"kind":"Name","value":"lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"Argument","name":{"kind":"Name","value":"radius"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radius"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tiff"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"naturalCover"}},{"kind":"Field","name":{"kind":"Name","value":"agriculturalCover"}},{"kind":"Field","name":{"kind":"Name","value":"artificialCover"}},{"kind":"Field","name":{"kind":"Name","value":"waterCover"}}]}}]}}]}}]} as unknown as DocumentNode<GetLandCoverQuery, GetLandCoverQueryVariables>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioId"}},{"kind":"Field","name":{"kind":"Name","value":"reportingOnboard"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const TrackUserSeenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrackUserSeen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackUserSeen"}}]}}]} as unknown as DocumentNode<TrackUserSeenMutation, TrackUserSeenMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const ListUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"slackMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"managedPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"mainContact"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListUsersQuery, ListUsersQueryVariables>;
export const GetUserRegisteredEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserRegisteredEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserRegisteredEvents"}}]}}]} as unknown as DocumentNode<GetUserRegisteredEventsQuery, GetUserRegisteredEventsQueryVariables>;
export const RegisterForEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterForEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerForEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RegisterForEventMutation, RegisterForEventMutationVariables>;
export const UnregisterFromEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnregisterFromEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnregisterEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unregisterFromEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UnregisterFromEventMutation, UnregisterFromEventMutationVariables>;
export const GetMyHiveOnboardingProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyHiveOnboardingProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMyHiveOnboardingProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeFlow"}},{"kind":"Field","name":{"kind":"Name","value":"completedFlows"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfWorkshopsBookedThisYear"}},{"kind":"Field","name":{"kind":"Name","value":"contractedWorkshops"}},{"kind":"Field","name":{"kind":"Name","value":"sharedPageWithTenantsAt"}},{"kind":"Field","name":{"kind":"Name","value":"cohort"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}}]}}]}}]} as unknown as DocumentNode<GetMyHiveOnboardingProgressQuery, GetMyHiveOnboardingProgressQueryVariables>;
export const SetMyHiveOnboardingProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMyHiveOnboardingProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"progress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMyHiveOnboardingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setMyHiveOnboardingProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"progress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"progress"}}}]}]}}]} as unknown as DocumentNode<SetMyHiveOnboardingProgressMutation, SetMyHiveOnboardingProgressMutationVariables>;